
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("eWfwO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0bc55cc5cdac960$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $gRw8I = parcelRequire("gRw8I");

var $dqZkp = parcelRequire("dqZkp");

var $lkATK = parcelRequire("lkATK");

var $9IGks = parcelRequire("9IGks");

var $CnEPi = parcelRequire("CnEPi");

var $aMgHa = parcelRequire("aMgHa");
const $c0bc55cc5cdac960$var$JQLEditorInner = ({ analyticsSource: analyticsSource, query: query, messages: messages = [], inputRef: inputRef, isSearching: isSearching, onEditorMounted: onEditorMounted, onDebugUnsafeMessage: onDebugUnsafeMessage, onHydrate: onHydrate, onUpdate: onUpdate, onSearch: onSearch, autocompleteProvider: autocompleteProvider, intl: intl, enableRichInlineNodes: enableRichInlineNodes = false, isCompact: isCompact, onSyntaxHelp: onSyntaxHelp, onFocus: onFocus, customComponents: customComponents, defaultRows: defaultRows })=>{
    (0, $gRw8I.di)((0, $aMgHa.default));
    const editorTheme = (0, $lkATK.useEditorTheme)({
        isSearch: !!onSearch,
        isCompact: isCompact,
        defaultRows: defaultRows
    });
    const { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent } = (0, $dqZkp.useJqlEditorAnalytics)(analyticsSource);
    // Create and update a mutable ref for our intl object so it can be used by Prosemirror plugins.
    const intlRef = (0, $eJOHy.useRef)(intl);
    (0, $eJOHy.useEffect)(()=>{
        intlRef.current = intl;
    }, [
        intl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9IGks.EditorStateContainer), {
        query: query,
        externalMessages: messages,
        isSearching: isSearching,
        intlRef: intlRef,
        onEditorMounted: onEditorMounted,
        onDebugUnsafeMessage: onDebugUnsafeMessage,
        onHydrate: onHydrate,
        onUpdate: onUpdate,
        onSearch: onSearch,
        createAndFireAnalyticsEvent: createAndFireAnalyticsEvent,
        autocompleteProvider: autocompleteProvider,
        enableRichInlineNodes: enableRichInlineNodes,
        onSyntaxHelp: onSyntaxHelp,
        onFocus: onFocus,
        customComponents: customComponents,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkATK.EditorThemeContext).Provider, {
            value: editorTheme,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CnEPi.JQLEditorPortalRenderer), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aMgHa.default), {
                    inputRef: inputRef
                })
            })
        })
    });
};
var $c0bc55cc5cdac960$export$2e2bcd8739ae039 = (0, $6YFG2.default)($c0bc55cc5cdac960$var$JQLEditorInner);

});
parcelRegister("dqZkp", function(module, exports) {
$parcel$export(module.exports, "useJqlEditorAnalytics", () => $14836470c2d48a1b$export$4603b866b007489f);

var $6S5SS = parcelRequire("6S5SS");
var $3U8bp = parcelRequire("3U8bp");
const $14836470c2d48a1b$export$4603b866b007489f = (analyticsSource)=>{
    return (0, $3U8bp.useJqlPackageAnalytics)(analyticsSource, "platform-pkg", "0.0.0-use.local", (0, $6S5SS.ANALYTICS_CHANNEL));
};

});

parcelRegister("9IGks", function(module, exports) {
$parcel$export(module.exports, "actions", () => $d294401b5ed67134$export$e324594224ef24da);
$parcel$export(module.exports, "useStoreActions", () => $d294401b5ed67134$export$8c7a43c7095015ee);
$parcel$export(module.exports, "useEditorView", () => $d294401b5ed67134$export$1465415f50708fb3);
$parcel$export(module.exports, "useIsSearching", () => $d294401b5ed67134$export$4fcd4d06ac62e583);
$parcel$export(module.exports, "useIntl", () => $d294401b5ed67134$export$5aebe9a147f4d146);
$parcel$export(module.exports, "useScopedId", () => $d294401b5ed67134$export$1f910160e5ac22b);
$parcel$export(module.exports, "useEditorViewHasFocus", () => $d294401b5ed67134$export$1705e93daf0a68e8);
$parcel$export(module.exports, "useLineNumbersVisible", () => $d294401b5ed67134$export$cd4ed76dbe5a915b);
$parcel$export(module.exports, "useAutocomplete", () => $d294401b5ed67134$export$1e40b3ca02d92d21);
$parcel$export(module.exports, "useJqlError", () => $d294401b5ed67134$export$f6f95452c4f02406);
$parcel$export(module.exports, "useEditorStateHasJqlError", () => $d294401b5ed67134$export$8a1f1243eb2951e7);
$parcel$export(module.exports, "useExternalMessages", () => $d294401b5ed67134$export$11b40eaa1fecfce4);
$parcel$export(module.exports, "useCustomErrorComponent", () => $d294401b5ed67134$export$d8e633c51ca63412);
$parcel$export(module.exports, "useAutocompleteOptions", () => $d294401b5ed67134$export$b0d1068703753b6a);
$parcel$export(module.exports, "useAutocompleteLoading", () => $d294401b5ed67134$export$d7fd2dc4e60ba300);
$parcel$export(module.exports, "useAutocompleteIsOpen", () => $d294401b5ed67134$export$9662437732e60d84);
$parcel$export(module.exports, "useAutocompletePosition", () => $d294401b5ed67134$export$237e1111a05d57cb);
$parcel$export(module.exports, "useHydratedUser", () => $d294401b5ed67134$export$a6881b2ed83fb629);
$parcel$export(module.exports, "useHydratedTeam", () => $d294401b5ed67134$export$cde4996ca7f1bdb6);
$parcel$export(module.exports, "useHydratedDeprecations", () => $d294401b5ed67134$export$6879df2c687d67b6);
$parcel$export(module.exports, "useRichInlineNodesEnabled", () => $d294401b5ed67134$export$ce42380b06e92b5a);
$parcel$export(module.exports, "useOnSyntaxHelp", () => $d294401b5ed67134$export$9d5410a4ea95cc4f);
$parcel$export(module.exports, "EditorStateContainer", () => $d294401b5ed67134$export$9f8863665f4f9c);

var $2f1HK = parcelRequire("2f1HK");

var $6Abnv = parcelRequire("6Abnv");

var $4nehu = parcelRequire("4nehu");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $psiyV = parcelRequire("psiyV");

var $jgII5 = parcelRequire("jgII5");

var $aXKmr = parcelRequire("aXKmr");

var $b7EWj = parcelRequire("b7EWj");

var $jc8Nj = parcelRequire("jc8Nj");
var $8okjU = parcelRequire("8okjU");

var $dEBM2 = parcelRequire("dEBM2");

var $4cOHu = parcelRequire("4cOHu");
var $6S5SS = parcelRequire("6S5SS");

var $jwFim = parcelRequire("jwFim");


var $5ORvr = parcelRequire("5ORvr");

var $3HQ0y = parcelRequire("3HQ0y");

var $bkqOC = parcelRequire("bkqOC");

var $j3U9J = parcelRequire("j3U9J");

var $eRjpa = parcelRequire("eRjpa");

var $dutrm = parcelRequire("dutrm");

var $fksm0 = parcelRequire("fksm0");

var $6Moo9 = parcelRequire("6Moo9");
const $d294401b5ed67134$var$initialIntl = (0, $4nehu.createIntl)({
    locale: 'en'
});
const $d294401b5ed67134$var$defaultAutocompleteOptions = {
    tokens: [],
    fields: [],
    operators: [],
    values: [],
    functions: []
};
const $d294401b5ed67134$export$d4c72bab9d6cc13a = {
    controlledQuery: '',
    query: '',
    externalMessages: [],
    isSearching: undefined,
    editorState: (0, $bkqOC.defaultEditorState),
    editorView: undefined,
    intlRef: {
        current: $d294401b5ed67134$var$initialIntl
    },
    autocompleteProvider: (0, $5ORvr.defaultAutocompleteProvider),
    idPrefix: '',
    editorViewHasFocus: false,
    editorViewBlurTimeout: null,
    lineNumbersVisible: false,
    jqlError: null,
    autocomplete: {
        // Keep autocomplete closed until user modifies query
        shouldStayClosedOnNextUpdate: true,
        shouldStayClosed: true,
        selectedOptionId: undefined,
        loading: false,
        options: $d294401b5ed67134$var$defaultAutocompleteOptions,
        subscription: null,
        analyticsSubscription: null,
        container: null,
        offsetParentRect: undefined,
        replacePositionStart: 0
    },
    enableRichInlineNodes: false,
    hydratedValues: {},
    resizeObserver: undefined,
    editorViewContainer: undefined,
    editorViewContainerRect: undefined,
    editorViewContainerScroll: 0,
    onDebugUnsafeMessage: undefined
};
/**
 * Line numbers should be shown if there are more than 1 paragraph blocks in the document.
 */ const $d294401b5ed67134$var$isLineNumbersVisible = (editorState)=>editorState.doc.childCount > 1;
const $d294401b5ed67134$export$e324594224ef24da = {
    onEditorViewBlur: ()=>({ setState: setState, dispatch: dispatch })=>{
            // Set editorViewHasFocus within a timeout, to handle the scenario where a dropdown option is clicked. Without the
            // timeout, a blur event would be fired for the editor on mousedown, which would cause the dropdown to be hidden
            // before the click event is fired.
            const editorViewBlurTimeout = window.setTimeout(()=>{
                setState({
                    editorViewHasFocus: false
                });
                dispatch($d294401b5ed67134$export$e324594224ef24da.setSelectedAutocompleteOptionId(undefined));
            });
            setState({
                editorViewBlurTimeout: editorViewBlurTimeout
            });
        },
    onEditorViewFocus: (event)=>({ setState: setState, getState: getState }, { onFocus: onFocus })=>{
            const { autocomplete: autocomplete, editorViewBlurTimeout: editorViewBlurTimeout, editorViewHasFocus: editorViewHasFocus } = getState();
            editorViewBlurTimeout && clearTimeout(editorViewBlurTimeout);
            if (!editorViewHasFocus) {
                setState({
                    autocomplete: {
                        ...autocomplete,
                        // This is a performance optimization to avoid querying this rect on every autocomplete dropdown render.
                        // We assume that autocomplete offset parent rect is not going to change while user interacts with the editor,
                        // so we only recompute this on focus.
                        offsetParentRect: autocomplete.container?.offsetParent?.getBoundingClientRect()
                    },
                    editorViewHasFocus: true
                });
                onFocus && onFocus(event);
            }
        },
    openAutocompleteOnNextUpdate: ()=>({ setState: setState, getState: getState })=>{
            const autocompleteState = getState().autocomplete;
            setState({
                autocomplete: {
                    ...autocompleteState,
                    // Schedule open for next update of autocomplete suggestions so dropdown doesn't incur in layout shifts
                    shouldStayClosedOnNextUpdate: false
                }
            });
        },
    closeAutocomplete: ()=>({ setState: setState, getState: getState })=>{
            const autocompleteState = getState().autocomplete;
            setState({
                autocomplete: {
                    ...autocompleteState,
                    // Closing autocomplete can be done immediately as it won't incur in layout shifts
                    shouldStayClosed: true,
                    shouldStayClosedOnNextUpdate: true
                }
            });
        },
    setSelectedAutocompleteOptionId: (selectedOptionId)=>({ setState: setState, getState: getState })=>{
            const autocompleteState = getState().autocomplete;
            setState({
                autocomplete: {
                    ...autocompleteState,
                    selectedOptionId: selectedOptionId
                }
            });
        },
    getAutocompleteSuggestions: (editorState)=>({ getState: getState, dispatch: dispatch })=>{
            // No need to process suggestions if autocomplete is going to stay closed on next update
            if (!getState().autocomplete.shouldStayClosedOnNextUpdate) {
                const { from: from, to: to } = editorState.selection;
                const text = (0, $j3U9J.getNodeText)(editorState.doc, 0, editorState.doc.content.size);
                const textBeforeSelectionStart = (0, $j3U9J.getNodeText)(editorState.doc, 0, from);
                const textBeforeSelectionEnd = (0, $j3U9J.getNodeText)(editorState.doc, 0, to);
                const textPositionStart = textBeforeSelectionStart.length;
                const textPositionStop = textBeforeSelectionEnd.length;
                const autocomplete = (0, $dEBM2.JQLAutocomplete).fromText(text);
                const suggestions = autocomplete.getJQLSuggestionsForCaretPosition([
                    textPositionStart,
                    textPositionStop
                ]);
                const { rules: rules, tokens: tokens } = suggestions;
                // In some situations (e.g. "issuetype in "), autocomplete expects a list, but we want to display operands
                // to the user as a shortcut – so they don't have to manually type the opening parenthesis. There is logic
                // on autocomplete option selection that will auto-insert this opening parenthesis.
                if (rules.list && rules.list.context && !rules.list.context.isList) {
                    if (!tokens.values.includes('EMPTY')) {
                        tokens.values.push('EMPTY');
                        tokens.context = rules.list.context;
                    }
                    if (!rules.value) rules.value = rules.list;
                    if (!rules.function) rules.function = rules.list;
                }
                dispatch($d294401b5ed67134$export$e324594224ef24da.getAutocompleteOptions(suggestions));
            }
        },
    getAutocompleteOptions: (suggestions)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { autocomplete: autocomplete, editorView: editorView } = getState();
            const { shouldStayClosedOnNextUpdate: shouldStayClosedOnNextUpdate } = autocomplete;
            setState({
                autocomplete: {
                    ...autocomplete,
                    options: {
                        ...$d294401b5ed67134$var$defaultAutocompleteOptions,
                        tokens: (0, $6Moo9.tokensToAutocompleteOptions)(suggestions.tokens)
                    },
                    // Set replace position start in the same update as initial options to avoid visible layout shifts
                    ...editorView && {
                        replacePositionStart: (0, $6Moo9.getReplacePositionStart)(suggestions)
                    },
                    // Update autocomplete visibility in the same update as initial options to avoid visible layout shifts
                    shouldStayClosed: shouldStayClosedOnNextUpdate
                }
            });
            dispatch($d294401b5ed67134$export$e324594224ef24da.cancelSubscription());
            dispatch($d294401b5ed67134$export$e324594224ef24da.callAutocompleteProviders(suggestions));
        },
    appendOptionsForObservable: (key, observable, rule, type)=>({ getState: getState, setState: setState })=>{
            const { context: context, matchedText: matchedText, replacePosition: replacePosition } = rule;
            return observable.pipe((0, $jgII5.tap)((data)=>{
                const nextSuggestions = data.map((option)=>({
                        ...option,
                        context: context,
                        matchedText: matchedText,
                        replacePosition: replacePosition,
                        type: type,
                        id: (0, $6Moo9.getAutocompleteOptionId)(option.value)
                    }));
                const { autocomplete: autocomplete } = getState();
                const { options: options } = autocomplete;
                setState({
                    autocomplete: {
                        ...autocomplete,
                        options: {
                            ...options,
                            [key]: options[key].concat(nextSuggestions)
                        }
                    }
                });
            }));
        },
    cancelSubscription: ()=>({ setState: setState, getState: getState })=>{
            const autocompleteState = getState().autocomplete;
            const { subscription: subscription, analyticsSubscription: analyticsSubscription } = autocompleteState;
            // Cancel any in-flight subscriptions
            subscription && subscription.unsubscribe();
            analyticsSubscription && analyticsSubscription.unsubscribe();
            setState({
                autocomplete: {
                    ...autocompleteState,
                    subscription: null,
                    analyticsSubscription: null,
                    // Setting loading back to false on unsubscribe as this won't call error or complete callbacks
                    // in the observer, and we don't seem to have any other way to handle this from the observer itself
                    loading: false
                }
            });
        },
    setLoading: (loading)=>({ setState: setState, getState: getState })=>{
            const { autocomplete: autocomplete } = getState();
            setState({
                autocomplete: {
                    ...autocomplete,
                    loading: loading
                }
            });
        },
    setAutocompleteOptions: (options)=>({ setState: setState, getState: getState })=>{
            const autocompleteState = getState().autocomplete;
            setState({
                autocomplete: {
                    ...autocompleteState,
                    options: options
                }
            });
        },
    setAutocompleteContainer: (container)=>({ setState: setState, getState: getState })=>{
            const autocompleteState = getState().autocomplete;
            setState({
                autocomplete: {
                    ...autocompleteState,
                    container: container,
                    offsetParentRect: container?.offsetParent?.getBoundingClientRect()
                }
            });
        },
    callAutocompleteProviders: ({ rules: rules, tokens: tokens })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { onFields: onFields, onOperators: onOperators, onValues: onValues, onFunctions: onFunctions } = getState().autocompleteProvider;
            const optionTypes = [];
            const observables = [];
            if (rules.value || rules.function || // If EMPTY is suggested as a token, we are also in "operand mode" and we don't want to call other providers
            // e.g. "assignee is " will return "EMPTY" token and "operator" rule as suggestions (because of "is not")
            tokens.values.includes('EMPTY')) {
                if (rules.value) {
                    const values$ = onValues(rules.value.matchedText, rules.value.context?.field);
                    optionTypes.push('values');
                    observables.push(dispatch($d294401b5ed67134$export$e324594224ef24da.appendOptionsForObservable('values', values$, rules.value, 'value')));
                }
                if (rules.function) {
                    const functions$ = onFunctions(rules.function.matchedText, rules.function.context?.field, rules.function.context?.operator ? (0, $8okjU.isListOperator)(rules.function.context.operator) : false);
                    optionTypes.push('functions');
                    observables.push(dispatch($d294401b5ed67134$export$e324594224ef24da.appendOptionsForObservable('functions', functions$, rules.function, 'function')));
                }
            } else if (rules.operator) {
                const { context: context, matchedText: matchedText } = rules.operator;
                const operators$ = (0, $dutrm.sortOperators)(onOperators(matchedText, context?.field));
                optionTypes.push('operators');
                observables.push(dispatch($d294401b5ed67134$export$e324594224ef24da.appendOptionsForObservable('operators', operators$, rules.operator, 'operator')));
            } else if (rules.field) {
                const { context: context, matchedText: matchedText } = rules.field;
                const fields$ = onFields(matchedText, context?.clause);
                optionTypes.push('fields');
                observables.push(dispatch($d294401b5ed67134$export$e324594224ef24da.appendOptionsForObservable('fields', fields$, rules.field, 'field')));
            }
            if (observables.length === 0) return;
            const { analyticsSubscription: analyticsSubscription, onStopAutocompleteEvent: onStopAutocompleteEvent } = dispatch((0, $eRjpa.onStartAutocompleteEvent)());
            dispatch($d294401b5ed67134$export$e324594224ef24da.setLoading(true));
            let hasOptions = false;
            const subscription = (0, $psiyV.merge)(...observables).subscribe({
                next () {
                    hasOptions = true;
                },
                error () {
                    onStopAutocompleteEvent(false, optionTypes, hasOptions);
                    dispatch($d294401b5ed67134$export$e324594224ef24da.setLoading(false));
                },
                complete () {
                    onStopAutocompleteEvent(true, optionTypes, hasOptions);
                    dispatch($d294401b5ed67134$export$e324594224ef24da.setLoading(false));
                }
            });
            const { autocomplete: autocomplete } = getState();
            setState({
                autocomplete: {
                    ...autocomplete,
                    subscription: subscription,
                    analyticsSubscription: analyticsSubscription
                }
            });
        },
    updateValidationState: ()=>({ getState: getState, setState: setState })=>{
            const { editorState: editorState } = getState();
            const jast = (0, $3HQ0y.getJastFromState)(editorState);
            setState({
                jqlError: jast.errors.length > 0 ? jast.errors[0] : null
            });
        },
    initialiseEditorState: ()=>({ dispatch: dispatch }, { query: query })=>{
            // Configure plugins that don't require portal rendering (these will be reconfigured later when the editor view is mounted).
            dispatch($d294401b5ed67134$export$e324594224ef24da.configurePlugins(undefined));
            dispatch($d294401b5ed67134$export$e324594224ef24da.resetEditorState(query, false));
        },
    configurePlugins: (portalActions)=>({ getState: getState, setState: setState, dispatch: dispatch }, { intlRef: intlRef, onSearch: onSearch })=>{
            const state = getState();
            let { editorState: editorState } = state;
            const { enableRichInlineNodes: enableRichInlineNodes } = state;
            // Initialise our editor using inline functions which will delegate to our sweet state actions. This prevents
            // stale references when our functions are invoked by Prosemirror.
            const onSearchCommand = (pmState, pmDispatch, pmView)=>// Set keyboardShortcut arg to true as this action is invoked by the 'Enter' keyboard command
                dispatch($d294401b5ed67134$export$e324594224ef24da.onSearchCommand(pmState, pmDispatch, pmView, true));
            editorState = (0, $bkqOC.configurePlugins)(editorState, onSearch ? onSearchCommand : undefined, intlRef, $d294401b5ed67134$var$getScopedId(getState(), (0, $480e76317c70d1e5$export$ecb000296b5c29b4)), portalActions, enableRichInlineNodes);
            setState({
                editorState: editorState
            });
        },
    onApplyEditorTransaction: (transaction)=>({ getState: getState, setState: setState, dispatch: dispatch }, { onUpdate: onUpdate })=>{
            const { query: query, editorState: editorState, editorView: editorView, enableRichInlineNodes: enableRichInlineNodes, onDebugUnsafeMessage: onDebugUnsafeMessage } = getState();
            const oldSelection = editorState.selection;
            const updatedQuery = (0, $j3U9J.getNodeText)(transaction.doc, 0, transaction.doc.content.size);
            let updatedEditorState;
            try {
                updatedEditorState = editorState.apply(transaction);
            } catch (error) {
                // We've observed several errors in Splunk from this step but we're unsure how to reproduce it. It seems to be some type of
                // race condition where the transaction is applied to the editor state but the editor state is being updated in another transaction.
                if (error instanceof RangeError && editorView) {
                    const message = `Error occurred trying to update editor state with the message: ${error.message}`;
                    (0, $6Moo9.sendDebugMessage)(message, editorView, editorState, onDebugUnsafeMessage, {
                        stack: error.stack,
                        transaction: JSON.stringify(transaction)
                    });
                }
                throw error;
            }
            // Update state in our editor view
            if (editorView) editorView.updateState(updatedEditorState);
            setState({
                query: updatedQuery,
                editorState: updatedEditorState,
                lineNumbersVisible: $d294401b5ed67134$var$isLineNumbersVisible(updatedEditorState)
            });
            // Hydrate query if transaction has requested it or a query fragment has been pasted
            if (enableRichInlineNodes && (transaction.getMeta('hydrate') || transaction.getMeta('paste'))) dispatch((0, $fksm0.hydrateQuery)());
            if (query !== updatedQuery && !transaction.getMeta((0, $5ORvr.JQLAutocompletePluginKey))) // Open autocomplete on next update if query has changed and update wasn't triggered internally
            dispatch($d294401b5ed67134$export$e324594224ef24da.openAutocompleteOnNextUpdate());
            if (query !== updatedQuery || !updatedEditorState.selection.eq(oldSelection)) // Get autocomplete suggestions for new editor state
            dispatch($d294401b5ed67134$export$e324594224ef24da.getAutocompleteSuggestions(updatedEditorState));
            if (query !== updatedQuery) // Only dispatch update event if query has changed
            onUpdate && onUpdate(updatedQuery, (0, $3HQ0y.getJastFromState)(updatedEditorState));
        },
    resetEditorState: (query, addToHistory = true)=>({ getState: getState, dispatch: dispatch })=>{
            const { editorState: editorState, enableRichInlineNodes: enableRichInlineNodes } = getState();
            // Use the clipboard text parser to get our slice to ensure new lines are split into separate paragraphs
            const slice = (0, $bkqOC.clipboardTextParser)(query, editorState.doc.resolve(0));
            const resetQueryTransaction = editorState.tr.setMeta('addToHistory', addToHistory).replace(0, editorState.doc.content.size, slice);
            dispatch($d294401b5ed67134$export$e324594224ef24da.onApplyEditorTransaction(resetQueryTransaction));
            dispatch($d294401b5ed67134$export$e324594224ef24da.updateValidationState());
            if (enableRichInlineNodes) dispatch((0, $fksm0.hydrateQuery)());
        },
    initialiseEditorView: (editorViewNode, attributes, portalActions)=>({ getState: getState, setState: setState, dispatch: dispatch }, { onEditorMounted: onEditorMounted })=>{
            // Configure plugins that require portal rendering (i.e. autocomplete and rich inline nodes).
            dispatch($d294401b5ed67134$export$e324594224ef24da.configurePlugins(portalActions));
            const { editorState: editorState, resizeObserver: resizeObserver } = getState();
            const editorView = new (0, $b7EWj.EditorView)(editorViewNode, {
                state: editorState,
                dispatchTransaction: (transaction)=>dispatch($d294401b5ed67134$export$e324594224ef24da.onApplyEditorTransaction(transaction)),
                clipboardTextSerializer: $bkqOC.clipboardTextSerializer,
                clipboardTextParser: $bkqOC.clipboardTextParser,
                attributes: attributes
            });
            // Unobserve previously observed elements
            resizeObserver?.disconnect();
            // Observe size changes to update rect
            resizeObserver?.observe(editorViewNode);
            setState({
                editorView: editorView
            });
            onEditorMounted && onEditorMounted();
        },
    updateEditorView: (attributes)=>({ getState: getState })=>{
            const { editorView: editorView, onDebugUnsafeMessage: onDebugUnsafeMessage, editorState: editorState } = getState();
            if (editorView) try {
                editorView.update({
                    ...editorView.props,
                    attributes: attributes
                });
            } catch (error) {
                // We've observed several errors from this step but we're unsure how to reproduce it. It seems to be some type of
                // race condition whether the view is being updated with a mismatched selection in the UI. We'll catch the error
                // so the UI doesn't break trying to change attributes and fire a callback to debug the error.
                const message = `Error occurred trying to update attributes on the editor view with the message: ${error instanceof Error ? error.message : String(error)}`;
                const attributeDiff = Object.keys(attributes).reduce((result, key)=>{
                    const prevAttr = // @ts-ignore
                    editorView.props.attributes?.[key];
                    const nextAttr = attributes[key];
                    if (nextAttr !== prevAttr) {
                        // @ts-ignore
                        result[`prev_${key}`] = prevAttr;
                        // @ts-ignore
                        result[`next_${key}`] = nextAttr;
                    }
                    return result;
                }, {});
                (0, $6Moo9.sendDebugMessage)(message, editorView, editorState, onDebugUnsafeMessage, {
                    stack: error instanceof Error ? error.stack : '',
                    ...attributeDiff
                });
            }
        },
    setEditorViewContainer: (editorViewContainer)=>({ setState: setState })=>{
            setState({
                editorViewContainer: editorViewContainer,
                // Set initial rect
                editorViewContainerRect: editorViewContainer?.getBoundingClientRect()
            });
        },
    setEditorViewContainerScroll: (scroll)=>({ setState: setState })=>{
            setState({
                editorViewContainerScroll: scroll
            });
        },
    onSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { editorState: editorState, editorView: editorView } = getState();
            dispatch(// Set keyboardShortcut arg to false as this action is invoked directly by the search UI button
            $d294401b5ed67134$export$e324594224ef24da.onSearchCommand(editorState, editorView?.dispatch, editorView, false));
        },
    onSearchCommand: (pmState, pmDispatch, pmView, // Whether the search command was invoked via a keyboard shortcut
    keyboardShortcut)=>({ getState: getState, dispatch: dispatch }, { onSearch: onSearch, createAndFireAnalyticsEvent: createAndFireAnalyticsEvent })=>{
            if (!onSearch) return true;
            const jast = (0, $3HQ0y.getJastFromState)(pmState);
            const { query: query } = getState();
            onSearch(query, jast);
            createAndFireAnalyticsEvent({
                action: (0, $4cOHu.Action).CLICKED,
                actionSubject: (0, $4cOHu.ActionSubject).BUTTON,
                actionSubjectId: (0, $4cOHu.ActionSubjectId).EDITOR_SEARCH,
                eventType: (0, $6S5SS.EventType).UI,
                attributes: {
                    ...(0, $jc8Nj.computeJqlInsights)(jast),
                    keyboardShortcut: keyboardShortcut
                }
            });
            // Update JQL validation state
            dispatch($d294401b5ed67134$export$e324594224ef24da.updateValidationState());
            // Invoke command to select any errors in the query
            (0, $jwFim.selectErrorCommand)(pmState, pmDispatch, pmView);
            return true;
        },
    externalErrorMessageViewed: ()=>({ getState: getState }, { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent, externalMessages: externalMessages })=>{
            const { editorView: editorView, onDebugUnsafeMessage: onDebugUnsafeMessage, jqlError: jqlError, editorState: editorState } = getState();
            const externalErrors = externalMessages.filter(({ type: type })=>type === 'error');
            if (externalErrors.length > 0) {
                const hasClientError = jqlError !== null;
                const initialValue = {
                    hasClientError: hasClientError,
                    semanticErrorCount: 0,
                    syntaxErrorCount: 0,
                    syntaxErrorTypes: []
                };
                const attributes = externalErrors.reduce((result, { errorType: errorType })=>{
                    if (typeof errorType === 'string') {
                        result.syntaxErrorCount++;
                        result.syntaxErrorTypes.push(errorType);
                    } else result.semanticErrorCount++;
                    return result;
                }, initialValue);
                attributes.syntaxErrorTypes.sort();
                createAndFireAnalyticsEvent({
                    action: (0, $4cOHu.Action).VIEWED,
                    actionSubject: (0, $4cOHu.ActionSubject).ERROR_MESSAGE,
                    actionSubjectId: (0, $4cOHu.ActionSubjectId).JQL_RESULT,
                    eventType: (0, $6S5SS.EventType).UI,
                    attributes: attributes
                });
                // If we have JQL errors which have been externally provided but no errors in our JAST, then we may have gaps in
                // our client side validation. Let's monitor any errors we weren't expecting.
                if (editorView && !hasClientError && attributes.syntaxErrorCount > 0) {
                    const message = 'External JQL syntax error is shown without a client error.';
                    (0, $6Moo9.sendDebugMessage)(message, editorView, editorState, onDebugUnsafeMessage, {
                        syntaxErrorTypes: attributes.syntaxErrorTypes.join(',')
                    });
                }
            }
        },
    createAndFireAnalyticsEvent: (payload)=>(_, { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent })=>{
            createAndFireAnalyticsEvent(payload);
        }
};
const $d294401b5ed67134$var$Store = (0, $GtRbT.createStore)({
    name: 'jql-editor',
    initialState: $d294401b5ed67134$export$d4c72bab9d6cc13a,
    actions: $d294401b5ed67134$export$e324594224ef24da
});
const $d294401b5ed67134$export$8c7a43c7095015ee = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: null
});
const $d294401b5ed67134$export$e6e340c65601d57b = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.editorState
});
const $d294401b5ed67134$export$1465415f50708fb3 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.editorView
});
const $d294401b5ed67134$export$4fcd4d06ac62e583 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.isSearching
});
const $d294401b5ed67134$export$5aebe9a147f4d146 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.intlRef.current
});
const $d294401b5ed67134$export$2ae605545144a62d = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.autocompleteProvider
});
const $d294401b5ed67134$var$getScopedId = (state, idSuffix)=>`${state.idPrefix}_${idSuffix}`;
const $d294401b5ed67134$export$1f910160e5ac22b = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: $d294401b5ed67134$var$getScopedId
});
const $d294401b5ed67134$export$804f6b32c593d6a7 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.idPrefix
});
const $d294401b5ed67134$export$1705e93daf0a68e8 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: ({ editorViewHasFocus: editorViewHasFocus })=>editorViewHasFocus
});
const $d294401b5ed67134$export$cd4ed76dbe5a915b = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: ({ lineNumbersVisible: lineNumbersVisible })=>lineNumbersVisible
});
const $d294401b5ed67134$var$getAutocomplete = (state)=>state.autocomplete;
const $d294401b5ed67134$export$1e40b3ca02d92d21 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: $d294401b5ed67134$var$getAutocomplete
});
const $d294401b5ed67134$export$f6f95452c4f02406 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.jqlError
});
const $d294401b5ed67134$export$8a1f1243eb2951e7 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>(0, $3HQ0y.getJastFromState)(state.editorState).errors.length > 0
});
const $d294401b5ed67134$var$memoizedExternalMessagesSelector = (0, $4MchI.createSelector)((state)=>state.externalMessages, (externalMessages)=>{
    const byType = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(externalMessages, 'type');
    return {
        errors: byType.error || [],
        warnings: byType.warning || [],
        infos: byType.info || []
    };
});
const $d294401b5ed67134$export$11b40eaa1fecfce4 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: $d294401b5ed67134$var$memoizedExternalMessagesSelector
});
const $d294401b5ed67134$export$d8e633c51ca63412 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>{
        return state.customComponents?.ErrorMessage;
    }
});
const $d294401b5ed67134$var$memoizedAutocompleteOptionsSelector = (0, $4MchI.createSelector)((state)=>state.autocomplete.options.tokens, (state)=>state.autocomplete.options.functions, (state)=>state.autocomplete.options.values, (state)=>state.autocomplete.options.operators, (state)=>state.autocomplete.options.fields, (tokens, functions, values, operators, fields)=>[
        ...tokens,
        ...functions,
        ...values,
        ...operators,
        ...fields
    ]);
const $d294401b5ed67134$export$b0d1068703753b6a = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: $d294401b5ed67134$var$memoizedAutocompleteOptionsSelector
});
const $d294401b5ed67134$var$autocompleteIsLoadingSelector = (state)=>state.autocomplete.loading;
const $d294401b5ed67134$export$d7fd2dc4e60ba300 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: $d294401b5ed67134$var$autocompleteIsLoadingSelector
});
const $d294401b5ed67134$var$memoizedAutocompleteIsOpenSelector = (0, $4MchI.createSelector)((state)=>state.editorViewHasFocus, $d294401b5ed67134$var$memoizedAutocompleteOptionsSelector, $d294401b5ed67134$var$autocompleteIsLoadingSelector, (state)=>state.autocomplete.shouldStayClosed, (hasFocus, options, loading, shouldStayClosed)=>!shouldStayClosed && hasFocus && (options.length > 0 || loading));
const $d294401b5ed67134$export$9662437732e60d84 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: $d294401b5ed67134$var$memoizedAutocompleteIsOpenSelector
});
const $d294401b5ed67134$export$237e1111a05d57cb = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>{
        const { autocomplete: autocomplete, editorView: editorView, editorViewContainerRect: editorViewContainerRect, onDebugUnsafeMessage: onDebugUnsafeMessage, editorState: editorState } = state;
        const { replacePositionStart: replacePositionStart, offsetParentRect: offsetParentRect } = autocomplete;
        if (!editorView) // Should never™ happen
        return {
            top: 0,
            left: 0
        };
        let docTop;
        let docLeft;
        try {
            const autocompletePosition = (0, $6Moo9.getAutocompletePosition)(editorView, replacePositionStart);
            docTop = autocompletePosition.top;
            docLeft = autocompletePosition.left;
        } catch (error) {
            // We've observed several 'Invalid position: x' errors from this step but we're unsure how to reproduce it. It
            // seems to be some type of race condition whether the view is being updated with a mismatched selection in the
            // UI. We'll catch the error so the UI doesn't break and fire a callback to debug the error.
            const message = `Error occurred trying to get autocomplete position with the message: ${error instanceof Error ? error.message : String(error)}`;
            (0, $6Moo9.sendDebugMessage)(message, editorView, editorState, onDebugUnsafeMessage, {
                stack: error instanceof Error ? error.stack : ''
            });
            // Fallback to showing autocomplete at bottom left of editor view if we were unable to calculate the position.
            docTop = editorViewContainerRect?.bottom ?? 0;
            docLeft = editorViewContainerRect?.left ?? 0;
        }
        // In some situations, we can get an autocompleteTop that exceeds editor view container top/bottom boundaries,
        // e.g. when editor content overflows editor view container and selection start/end is not visible. To prevent
        // situations where autocomplete dropdown greatly overflows editor view container, we clamp this position.
        // We also offset top position returned by ProseMirror to ensure autocomplete is positioned consistently at
        // a grid size distance from editor input bottom in all situations where autocomplete is outside of the editor.
        const autocompleteTop = docTop;
        const viewportTop = editorViewContainerRect !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(autocompleteTop, editorViewContainerRect.top, editorViewContainerRect.bottom) : autocompleteTop;
        const left = docLeft - (offsetParentRect?.left ?? 0);
        const top = viewportTop - (offsetParentRect?.top ?? 0);
        return {
            left: left,
            top: top
        };
    }
});
const $d294401b5ed67134$export$b261abe91696e8d = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state, { id: id, fieldName: fieldName })=>{
        return state.hydratedValues[fieldName]?.get(id);
    }
});
const $d294401b5ed67134$export$a6881b2ed83fb629 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state, { id: id, fieldName: fieldName })=>{
        const user = state.hydratedValues[fieldName]?.get(id);
        return user && user.type === 'user' ? user : undefined;
    }
});
const $d294401b5ed67134$export$cde4996ca7f1bdb6 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state, { id: id, fieldName: fieldName })=>{
        const team = state.hydratedValues[fieldName]?.get(id);
        return team && team.type === 'team' ? team : undefined;
    }
});
const $d294401b5ed67134$export$6879df2c687d67b6 = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>{
        const ast = (0, $3HQ0y.getJastFromState)(state.editorState);
        const fieldsInQuery = (0, $6Moo9.getFieldNodes)(ast);
        const toReturn = [];
        Object.entries(state.hydratedValues).forEach(([fieldName])=>{
            state.hydratedValues[fieldName]?.forEach((value)=>{
                if (value.type === 'deprecated-field') {
                    if (fieldsInQuery.has(value.id.toLowerCase())) toReturn.push(value);
                }
            });
        });
        return toReturn;
    }
});
const $d294401b5ed67134$export$ce42380b06e92b5a = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.enableRichInlineNodes
});
const $d294401b5ed67134$export$9d5410a4ea95cc4f = (0, $iJq0l.createHook)($d294401b5ed67134$var$Store, {
    selector: (state)=>state.onSyntaxHelp
});
const $d294401b5ed67134$export$9f8863665f4f9c = (0, $6E16M.createContainer)($d294401b5ed67134$var$Store, {
    onInit: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { intlRef: intlRef, query: query, isSearching: isSearching, autocompleteProvider: autocompleteProvider, externalMessages: externalMessages, enableRichInlineNodes: enableRichInlineNodes, onDebugUnsafeMessage: onDebugUnsafeMessage, onSyntaxHelp: onSyntaxHelp, customComponents: customComponents })=>{
            setState({
                controlledQuery: query,
                query: query,
                externalMessages: externalMessages,
                isSearching: isSearching,
                intlRef: intlRef,
                autocompleteProvider: autocompleteProvider,
                enableRichInlineNodes: enableRichInlineNodes,
                // Generate unique identifiers for each JQL editor instance
                idPrefix: (0, $aXKmr.v4)(),
                resizeObserver: window.ResizeObserver !== undefined ? new window.ResizeObserver(()=>{
                    setState({
                        // We assume editor view container is the only element using the observer to avoid extra processing.
                        // If this instance is reused to observe more elements (which is a good practice to optimize performance),
                        // we would need to adjust this logic.
                        editorViewContainerRect: getState().editorViewContainer?.getBoundingClientRect()
                    });
                }) : undefined,
                onDebugUnsafeMessage: onDebugUnsafeMessage,
                onSyntaxHelp: onSyntaxHelp,
                customComponents: customComponents
            });
            dispatch($d294401b5ed67134$export$e324594224ef24da.initialiseEditorState());
        },
    onUpdate: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { query: controlledQueryProp, isSearching: isSearching, autocompleteProvider: autocompleteProvider, externalMessages: externalMessages, enableRichInlineNodes: enableRichInlineNodes, onDebugUnsafeMessage: onDebugUnsafeMessage, onSyntaxHelp: onSyntaxHelp, customComponents: customComponents })=>{
            const { controlledQuery: controlledQuery, query: query } = getState();
            // Track changes to our controlledQuery state
            if (controlledQuery !== controlledQueryProp) {
                setState({
                    controlledQuery: controlledQueryProp
                });
                // If the controlled query prop has changed and it doesn't match the query in our editor then we need to reset
                // the editor state.
                if (controlledQueryProp !== query) dispatch($d294401b5ed67134$export$e324594224ef24da.resetEditorState(controlledQueryProp));
            }
            setState({
                externalMessages: externalMessages,
                isSearching: isSearching,
                autocompleteProvider: autocompleteProvider,
                enableRichInlineNodes: enableRichInlineNodes,
                onDebugUnsafeMessage: onDebugUnsafeMessage,
                onSyntaxHelp: onSyntaxHelp,
                customComponents: customComponents
            });
        }
});

});
parcelRegister("2f1HK", function(module, exports) {

var $hyPlD = parcelRequire("hyPlD");

var $fQnJZ = parcelRequire("fQnJZ");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $1a1e4df8c91caf77$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $fQnJZ(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $fQnJZ(lower);
        lower = lower === lower ? lower : 0;
    }
    return $hyPlD($fQnJZ(number), lower, upper);
}
module.exports = $1a1e4df8c91caf77$var$clamp;

});
parcelRegister("hyPlD", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $cc8d7144fabccd11$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $cc8d7144fabccd11$var$baseClamp;

});


parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});

parcelRegister("b7EWj", function(module, exports) {
$parcel$export(module.exports, "Decoration", () => $81901ae0222f0506$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $81901ae0222f0506$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $81901ae0222f0506$export$eece2fccabbb77c5);

var $3lIcL = parcelRequire("3lIcL");

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $81901ae0222f0506$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $81901ae0222f0506$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $81901ae0222f0506$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $81901ae0222f0506$var$textRange = function(node, from, to) {
    let range = $81901ae0222f0506$var$reusedRange || ($81901ae0222f0506$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $81901ae0222f0506$var$clearReusedRange = function() {
    $81901ae0222f0506$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $81901ae0222f0506$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, -1) || $81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $81901ae0222f0506$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $81901ae0222f0506$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $81901ae0222f0506$var$hasBlockDesc(node) || $81901ae0222f0506$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $81901ae0222f0506$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $81901ae0222f0506$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $81901ae0222f0506$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $81901ae0222f0506$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $81901ae0222f0506$var$nodeSize(node);
        } else if (node.parentNode && !$81901ae0222f0506$var$hasBlockDesc(node)) {
            offset = $81901ae0222f0506$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $81901ae0222f0506$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$81901ae0222f0506$var$hasBlockDesc(node)) {
            offset = $81901ae0222f0506$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $81901ae0222f0506$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $81901ae0222f0506$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $81901ae0222f0506$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $81901ae0222f0506$var$nodeSize(node);
    }
}
function $81901ae0222f0506$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $81901ae0222f0506$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $81901ae0222f0506$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $81901ae0222f0506$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $81901ae0222f0506$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $81901ae0222f0506$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($81901ae0222f0506$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($81901ae0222f0506$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $81901ae0222f0506$var$nav = typeof navigator != "undefined" ? navigator : null;
const $81901ae0222f0506$var$doc = typeof document != "undefined" ? document : null;
const $81901ae0222f0506$var$agent = $81901ae0222f0506$var$nav && $81901ae0222f0506$var$nav.userAgent || "";
const $81901ae0222f0506$var$ie_edge = /Edge\/(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie_upto10 = /MSIE \d/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie = !!($81901ae0222f0506$var$ie_upto10 || $81901ae0222f0506$var$ie_11up || $81901ae0222f0506$var$ie_edge);
const $81901ae0222f0506$var$ie_version = $81901ae0222f0506$var$ie_upto10 ? document.documentMode : $81901ae0222f0506$var$ie_11up ? +$81901ae0222f0506$var$ie_11up[1] : $81901ae0222f0506$var$ie_edge ? +$81901ae0222f0506$var$ie_edge[1] : 0;
const $81901ae0222f0506$var$gecko = !$81901ae0222f0506$var$ie && /gecko\/(\d+)/i.test($81901ae0222f0506$var$agent);
$81901ae0222f0506$var$gecko && (/Firefox\/(\d+)/.exec($81901ae0222f0506$var$agent) || [
    0,
    0
])[1];
const $81901ae0222f0506$var$_chrome = !$81901ae0222f0506$var$ie && /Chrome\/(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$chrome = !!$81901ae0222f0506$var$_chrome;
const $81901ae0222f0506$var$chrome_version = $81901ae0222f0506$var$_chrome ? +$81901ae0222f0506$var$_chrome[1] : 0;
const $81901ae0222f0506$var$safari = !$81901ae0222f0506$var$ie && !!$81901ae0222f0506$var$nav && /Apple Computer/.test($81901ae0222f0506$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $81901ae0222f0506$var$ios = $81901ae0222f0506$var$safari && (/Mobile\/\w+/.test($81901ae0222f0506$var$agent) || !!$81901ae0222f0506$var$nav && $81901ae0222f0506$var$nav.maxTouchPoints > 2);
const $81901ae0222f0506$var$mac = $81901ae0222f0506$var$ios || ($81901ae0222f0506$var$nav ? /Mac/.test($81901ae0222f0506$var$nav.platform) : false);
const $81901ae0222f0506$var$windows = $81901ae0222f0506$var$nav ? /Win/.test($81901ae0222f0506$var$nav.platform) : false;
const $81901ae0222f0506$var$android = /Android \d/.test($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$webkit = !!$81901ae0222f0506$var$doc && "webkitFontSmoothing" in $81901ae0222f0506$var$doc.documentElement.style;
const $81901ae0222f0506$var$webkit_version = $81901ae0222f0506$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $81901ae0222f0506$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $81901ae0222f0506$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $81901ae0222f0506$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $81901ae0222f0506$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $81901ae0222f0506$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $81901ae0222f0506$var$windowRect(doc) : $81901ae0222f0506$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $81901ae0222f0506$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $81901ae0222f0506$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $81901ae0222f0506$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $81901ae0222f0506$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $81901ae0222f0506$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $81901ae0222f0506$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $81901ae0222f0506$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $81901ae0222f0506$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $81901ae0222f0506$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $81901ae0222f0506$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $81901ae0222f0506$var$scrollStack(view.dom)
    };
}
function $81901ae0222f0506$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $81901ae0222f0506$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $81901ae0222f0506$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $81901ae0222f0506$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $81901ae0222f0506$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $81901ae0222f0506$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $81901ae0222f0506$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($81901ae0222f0506$var$preventScrollSupported) return dom.focus($81901ae0222f0506$var$preventScrollSupported);
    let stored = $81901ae0222f0506$var$scrollStack(dom);
    dom.focus($81901ae0222f0506$var$preventScrollSupported == null ? {
        get preventScroll () {
            $81901ae0222f0506$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$81901ae0222f0506$var$preventScrollSupported) {
        $81901ae0222f0506$var$preventScrollSupported = false;
        $81901ae0222f0506$var$restoreScrollStack(stored, 0);
    }
}
function $81901ae0222f0506$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $81901ae0222f0506$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $81901ae0222f0506$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $81901ae0222f0506$var$findOffsetInNode(closest, coordsClosest);
}
function $81901ae0222f0506$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $81901ae0222f0506$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($81901ae0222f0506$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $81901ae0222f0506$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $81901ae0222f0506$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $81901ae0222f0506$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $81901ae0222f0506$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $81901ae0222f0506$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $81901ae0222f0506$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($81901ae0222f0506$var$inRect(coords, rect)) return $81901ae0222f0506$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $81901ae0222f0506$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $81901ae0222f0506$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$81901ae0222f0506$var$inRect(coords, box)) return null;
        elt = $81901ae0222f0506$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($81901ae0222f0506$var$safari) {
        for(let p = elt; node && p; p = $81901ae0222f0506$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $81901ae0222f0506$var$targetKludge(elt, coords);
    if (node) {
        if ($81901ae0222f0506$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($81901ae0222f0506$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $81901ae0222f0506$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $81901ae0222f0506$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $81901ae0222f0506$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $81901ae0222f0506$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($81901ae0222f0506$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $81901ae0222f0506$var$nonZero) || target.getBoundingClientRect();
}
const $81901ae0222f0506$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $81901ae0222f0506$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $81901ae0222f0506$var$webkit || $81901ae0222f0506$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($81901ae0222f0506$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($81901ae0222f0506$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $81901ae0222f0506$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $81901ae0222f0506$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $81901ae0222f0506$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $81901ae0222f0506$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $81901ae0222f0506$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $81901ae0222f0506$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $81901ae0222f0506$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $81901ae0222f0506$var$textRange(before, $81901ae0222f0506$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $81901ae0222f0506$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $81901ae0222f0506$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(node.nodeType == 3 ? $81901ae0222f0506$var$textRange(node) : node, -side), side >= 0);
}
function $81901ae0222f0506$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $81901ae0222f0506$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $81901ae0222f0506$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $81901ae0222f0506$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $81901ae0222f0506$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $81901ae0222f0506$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $81901ae0222f0506$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $81901ae0222f0506$var$maybeRTL = /[\u0590-\u08ac]/;
function $81901ae0222f0506$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$81901ae0222f0506$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $81901ae0222f0506$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $81901ae0222f0506$var$cachedState = null;
let $81901ae0222f0506$var$cachedDir = null;
let $81901ae0222f0506$var$cachedResult = false;
function $81901ae0222f0506$var$endOfTextblock(view, state, dir) {
    if ($81901ae0222f0506$var$cachedState == state && $81901ae0222f0506$var$cachedDir == dir) return $81901ae0222f0506$var$cachedResult;
    $81901ae0222f0506$var$cachedState = state;
    $81901ae0222f0506$var$cachedDir = dir;
    return $81901ae0222f0506$var$cachedResult = dir == "up" || dir == "down" ? $81901ae0222f0506$var$endOfTextblockVertical(view, state, dir) : $81901ae0222f0506$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $81901ae0222f0506$var$NOT_DIRTY = 0, $81901ae0222f0506$var$CHILD_DIRTY = 1, $81901ae0222f0506$var$CONTENT_DIRTY = 2, $81901ae0222f0506$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $81901ae0222f0506$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $81901ae0222f0506$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $81901ae0222f0506$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $81901ae0222f0506$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $81901ae0222f0506$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $81901ae0222f0506$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $81901ae0222f0506$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $81901ae0222f0506$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($81901ae0222f0506$var$gecko || $81901ae0222f0506$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $81901ae0222f0506$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($81901ae0222f0506$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $81901ae0222f0506$var$safari) && $81901ae0222f0506$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $81901ae0222f0506$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $81901ae0222f0506$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $81901ae0222f0506$var$WidgetViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $81901ae0222f0506$var$CompositionViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $81901ae0222f0506$var$MarkViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $3xw6l.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $81901ae0222f0506$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $81901ae0222f0506$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $81901ae0222f0506$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $81901ae0222f0506$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $81901ae0222f0506$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $81901ae0222f0506$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $81901ae0222f0506$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $81901ae0222f0506$var$NodeViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $3xw6l.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $81901ae0222f0506$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $81901ae0222f0506$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $81901ae0222f0506$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $81901ae0222f0506$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $3xw6l.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && node.eq(this.node) && $81901ae0222f0506$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $81901ae0222f0506$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $81901ae0222f0506$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $3xw6l.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $81901ae0222f0506$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $81901ae0222f0506$var$renderDescs(this.contentDOM, this.children, view);
            if ($81901ae0222f0506$var$ios) $81901ae0222f0506$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $3lIcL.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $81901ae0222f0506$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $81901ae0222f0506$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $81901ae0222f0506$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($81901ae0222f0506$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $81901ae0222f0506$var$patchOuterDeco(this.dom, this.nodeDOM, $81901ae0222f0506$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $81901ae0222f0506$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $81901ae0222f0506$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $81901ae0222f0506$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $81901ae0222f0506$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $81901ae0222f0506$var$TextViewDesc extends $81901ae0222f0506$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY || this.dirty != $81901ae0222f0506$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $81901ae0222f0506$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $81901ae0222f0506$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $81901ae0222f0506$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $81901ae0222f0506$var$TrailingHackViewDesc extends $81901ae0222f0506$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $81901ae0222f0506$var$CustomNodeViewDesc extends $81901ae0222f0506$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $81901ae0222f0506$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $81901ae0222f0506$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $81901ae0222f0506$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $81901ae0222f0506$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $81901ae0222f0506$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $81901ae0222f0506$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$81901ae0222f0506$var$OuterDecoLevel.prototype = Object.create(null);
const $81901ae0222f0506$var$noDeco = [
    new $81901ae0222f0506$var$OuterDecoLevel
];
function $81901ae0222f0506$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $81901ae0222f0506$var$noDeco;
    let top = needsWrap ? $81901ae0222f0506$var$noDeco[0] : new $81901ae0222f0506$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $81901ae0222f0506$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $81901ae0222f0506$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $81901ae0222f0506$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $81901ae0222f0506$var$noDeco && curComputed == $81901ae0222f0506$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $81901ae0222f0506$var$noDeco[0];
                curDOM = parent;
            }
        }
        $81901ae0222f0506$var$patchAttributes(curDOM, prev || $81901ae0222f0506$var$noDeco[0], deco);
    }
    return curDOM;
}
function $81901ae0222f0506$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $81901ae0222f0506$var$applyOuterDeco(dom, deco, node) {
    return $81901ae0222f0506$var$patchOuterDeco(dom, dom, $81901ae0222f0506$var$noDeco, $81901ae0222f0506$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $81901ae0222f0506$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $81901ae0222f0506$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $81901ae0222f0506$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $81901ae0222f0506$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $81901ae0222f0506$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $81901ae0222f0506$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $81901ae0222f0506$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $81901ae0222f0506$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $81901ae0222f0506$var$NODE_DIRTY && $81901ae0222f0506$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $81901ae0222f0506$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$81901ae0222f0506$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $81901ae0222f0506$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $81901ae0222f0506$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $81901ae0222f0506$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $81901ae0222f0506$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $81901ae0222f0506$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($81901ae0222f0506$var$safari || $81901ae0222f0506$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $81901ae0222f0506$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $81901ae0222f0506$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $81901ae0222f0506$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $81901ae0222f0506$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $81901ae0222f0506$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($81901ae0222f0506$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $81901ae0222f0506$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $81901ae0222f0506$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $81901ae0222f0506$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $81901ae0222f0506$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($81901ae0222f0506$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $3lIcL.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $81901ae0222f0506$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $3lIcL.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $81901ae0222f0506$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $81901ae0222f0506$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $81901ae0222f0506$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $81901ae0222f0506$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $81901ae0222f0506$var$syncNodeSelection(view, sel);
    if (!$81901ae0222f0506$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $81901ae0222f0506$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $81901ae0222f0506$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $81901ae0222f0506$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($81901ae0222f0506$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $3lIcL.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $81901ae0222f0506$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $81901ae0222f0506$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($81901ae0222f0506$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $81901ae0222f0506$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $81901ae0222f0506$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $81901ae0222f0506$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $81901ae0222f0506$var$brokenSelectBetweenUneditable = $81901ae0222f0506$var$safari || $81901ae0222f0506$var$chrome && $81901ae0222f0506$var$chrome_version < 63;
function $81901ae0222f0506$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($81901ae0222f0506$var$safari && after && after.contentEditable == "false") return $81901ae0222f0506$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $81901ae0222f0506$var$setEditable(after);
        else if (before) return $81901ae0222f0506$var$setEditable(before);
    }
}
function $81901ae0222f0506$var$setEditable(element) {
    element.contentEditable = "true";
    if ($81901ae0222f0506$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $81901ae0222f0506$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $81901ae0222f0506$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$81901ae0222f0506$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $81901ae0222f0506$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $81901ae0222f0506$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $81901ae0222f0506$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $3lIcL.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $81901ae0222f0506$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $81901ae0222f0506$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $81901ae0222f0506$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $81901ae0222f0506$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $3lIcL.TextSelection).between($anchor, $head, bias);
}
function $81901ae0222f0506$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $81901ae0222f0506$var$hasSelection(view);
}
function $81901ae0222f0506$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $81901ae0222f0506$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $81901ae0222f0506$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $81901ae0222f0506$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $3lIcL.Selection).findFrom($start, dir);
}
function $81901ae0222f0506$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $81901ae0222f0506$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $3lIcL.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $3lIcL.NodeSelection)) return $81901ae0222f0506$var$apply(view, next);
            return false;
        } else if (!($81901ae0222f0506$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $3lIcL.NodeSelection).isSelectable(node)) return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($81901ae0222f0506$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $3lIcL.NodeSelection) && sel.node.isInline) return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
        if (next) return $81901ae0222f0506$var$apply(view, next);
        return false;
    }
}
function $81901ae0222f0506$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $81901ae0222f0506$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $81901ae0222f0506$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $81901ae0222f0506$var$skipIgnoredNodesBefore(view) : $81901ae0222f0506$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $81901ae0222f0506$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($81901ae0222f0506$var$gecko && node.nodeType == 1 && offset < $81901ae0222f0506$var$nodeLen(node) && $81901ae0222f0506$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($81901ae0222f0506$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($81901ae0222f0506$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $81901ae0222f0506$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $81901ae0222f0506$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $81901ae0222f0506$var$nodeLen(node);
            }
        }
    }
    if (force) $81901ae0222f0506$var$setSelFocus(view, node, offset);
    else if (moveNode) $81901ae0222f0506$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $81901ae0222f0506$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $81901ae0222f0506$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($81901ae0222f0506$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($81901ae0222f0506$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $81901ae0222f0506$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $81901ae0222f0506$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $81901ae0222f0506$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $81901ae0222f0506$var$setSelFocus(view, moveNode, moveOffset);
}
function $81901ae0222f0506$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $81901ae0222f0506$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$81901ae0222f0506$var$hasBlockDesc(node)){
        offset = $81901ae0222f0506$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $81901ae0222f0506$var$textNodeBefore(node, offset) {
    while(node && !offset && !$81901ae0222f0506$var$hasBlockDesc(node)){
        offset = $81901ae0222f0506$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $81901ae0222f0506$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $81901ae0222f0506$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $81901ae0222f0506$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($81901ae0222f0506$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $81901ae0222f0506$var$selectionToDOM(view);
    }, 50);
}
function $81901ae0222f0506$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($81901ae0222f0506$var$chrome || $81901ae0222f0506$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $81901ae0222f0506$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $3lIcL.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($81901ae0222f0506$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $3lIcL.NodeSelection)) return $81901ae0222f0506$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $3lIcL.AllSelection) ? (0, $3lIcL.Selection).near(side, dir) : (0, $3lIcL.Selection).findFrom(side, dir);
        return beyond ? $81901ae0222f0506$var$apply(view, beyond) : false;
    }
    return false;
}
function $81901ae0222f0506$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $3lIcL.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $81901ae0222f0506$var$safariDownArrowBug(view) {
    if (!$81901ae0222f0506$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $81901ae0222f0506$var$switchEditable(view, child, "true");
        setTimeout(()=>$81901ae0222f0506$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $81901ae0222f0506$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $81901ae0222f0506$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $81901ae0222f0506$var$getMods(event);
    if (code == 8 || $81901ae0222f0506$var$mac && code == 72 && mods == "c") return $81901ae0222f0506$var$stopNativeHorizontalDelete(view, -1) || $81901ae0222f0506$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $81901ae0222f0506$var$mac && code == 68 && mods == "c") return $81901ae0222f0506$var$stopNativeHorizontalDelete(view, 1) || $81901ae0222f0506$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $81901ae0222f0506$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $81901ae0222f0506$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $81901ae0222f0506$var$selectHorizontally(view, dir, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $81901ae0222f0506$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $81901ae0222f0506$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $81901ae0222f0506$var$selectHorizontally(view, dir, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $81901ae0222f0506$var$mac && code == 80 && mods == "c") return $81901ae0222f0506$var$selectVertically(view, -1, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $81901ae0222f0506$var$mac && code == 78 && mods == "c") return $81901ae0222f0506$var$safariDownArrowBug(view) || $81901ae0222f0506$var$selectVertically(view, 1, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, 1);
    else if (mods == ($81901ae0222f0506$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $81901ae0222f0506$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $3xw6l.DOMSerializer).fromSchema(view.state.schema);
    let doc = $81901ae0222f0506$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $81901ae0222f0506$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $81901ae0222f0506$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $3xw6l.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $3xw6l.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $81901ae0222f0506$var$readHTML(html);
        if ($81901ae0222f0506$var$webkit) $81901ae0222f0506$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $3xw6l.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$81901ae0222f0506$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $81901ae0222f0506$var$addContext($81901ae0222f0506$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $3xw6l.Slice).maxOpen($81901ae0222f0506$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $81901ae0222f0506$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $81901ae0222f0506$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $81901ae0222f0506$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $81901ae0222f0506$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $81901ae0222f0506$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $3xw6l.Fragment).from(result);
    }
    return fragment;
}
function $81901ae0222f0506$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $3xw6l.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $3xw6l.Fragment).from($81901ae0222f0506$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $81901ae0222f0506$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $81901ae0222f0506$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $3xw6l.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $81901ae0222f0506$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $81901ae0222f0506$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $3xw6l.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $81901ae0222f0506$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $3xw6l.Slice)($81901ae0222f0506$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $3xw6l.Slice)($81901ae0222f0506$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $81901ae0222f0506$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $81901ae0222f0506$var$_detachedDoc = null;
function $81901ae0222f0506$var$detachedDoc() {
    return $81901ae0222f0506$var$_detachedDoc || ($81901ae0222f0506$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $81901ae0222f0506$var$_policy = null;
function $81901ae0222f0506$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$81901ae0222f0506$var$_policy) $81901ae0222f0506$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $81901ae0222f0506$var$_policy.createHTML(html);
}
function $81901ae0222f0506$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $81901ae0222f0506$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $81901ae0222f0506$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $81901ae0222f0506$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $81901ae0222f0506$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($81901ae0222f0506$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $81901ae0222f0506$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $3xw6l.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $3xw6l.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $81901ae0222f0506$var$handlers = {};
const $81901ae0222f0506$var$editHandlers = {};
const $81901ae0222f0506$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $81901ae0222f0506$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $81901ae0222f0506$var$initInput(view) {
    for(let event in $81901ae0222f0506$var$handlers){
        let handler = $81901ae0222f0506$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($81901ae0222f0506$var$eventBelongsToView(view, event) && !$81901ae0222f0506$var$runCustomHandler(view, event) && (view.editable || !(event.type in $81901ae0222f0506$var$editHandlers))) handler(view, event);
        }, $81901ae0222f0506$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($81901ae0222f0506$var$safari) view.dom.addEventListener("input", ()=>null);
    $81901ae0222f0506$var$ensureListeners(view);
}
function $81901ae0222f0506$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $81901ae0222f0506$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $81901ae0222f0506$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$81901ae0222f0506$var$runCustomHandler(view, event));
    });
}
function $81901ae0222f0506$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $81901ae0222f0506$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $81901ae0222f0506$var$dispatchEvent(view, event) {
    if (!$81901ae0222f0506$var$runCustomHandler(view, event) && $81901ae0222f0506$var$handlers[event.type] && (view.editable || !(event.type in $81901ae0222f0506$var$editHandlers))) $81901ae0222f0506$var$handlers[event.type](view, event);
}
$81901ae0222f0506$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($81901ae0222f0506$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($81901ae0222f0506$var$android && $81901ae0222f0506$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($81901ae0222f0506$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $81901ae0222f0506$var$captureKeyDown(view, event)) event.preventDefault();
    else $81901ae0222f0506$var$setSelectionOrigin(view, "key");
};
$81901ae0222f0506$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$81901ae0222f0506$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($81901ae0222f0506$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $81901ae0222f0506$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $3lIcL.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $81901ae0222f0506$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $81901ae0222f0506$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $81901ae0222f0506$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $81901ae0222f0506$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $81901ae0222f0506$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $3lIcL.NodeSelection).isSelectable(node)) {
        $81901ae0222f0506$var$updateSelection(view, new (0, $3lIcL.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $3lIcL.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $3lIcL.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $81901ae0222f0506$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $81901ae0222f0506$var$selectClickedNode(view, inside) : $81901ae0222f0506$var$selectClickedLeaf(view, inside));
}
function $81901ae0222f0506$var$handleDoubleClick(view, pos, inside, event) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $81901ae0222f0506$var$handleTripleClick(view, pos, inside, event) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $81901ae0222f0506$var$defaultTripleClick(view, inside, event);
}
function $81901ae0222f0506$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $3lIcL.NodeSelection).isSelectable(node)) $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $81901ae0222f0506$var$forceDOMFlush(view) {
    return $81901ae0222f0506$var$endComposition(view);
}
const $81901ae0222f0506$var$selectNodeModifier = $81901ae0222f0506$var$mac ? "metaKey" : "ctrlKey";
$81901ae0222f0506$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $81901ae0222f0506$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $81901ae0222f0506$var$isNear(event, view.input.lastClick) && !event[$81901ae0222f0506$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $81901ae0222f0506$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $81901ae0222f0506$var$handleDoubleClick : $81901ae0222f0506$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
class $81901ae0222f0506$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$81901ae0222f0506$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $3lIcL.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $81901ae0222f0506$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$81901ae0222f0506$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
        else if ($81901ae0222f0506$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $81901ae0222f0506$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $81901ae0222f0506$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $81901ae0222f0506$var$updateSelection(this.view, (0, $3lIcL.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$81901ae0222f0506$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $81901ae0222f0506$var$forceDOMFlush(view);
    $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
$81901ae0222f0506$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
$81901ae0222f0506$var$handlers.contextmenu = (view)=>$81901ae0222f0506$var$forceDOMFlush(view);
function $81901ae0222f0506$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($81901ae0222f0506$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $81901ae0222f0506$var$timeoutComposition = $81901ae0222f0506$var$android ? 5000 : -1;
$81901ae0222f0506$var$editHandlers.compositionstart = $81901ae0222f0506$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $3lIcL.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $81901ae0222f0506$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $81901ae0222f0506$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($81901ae0222f0506$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $81901ae0222f0506$var$scheduleComposeEnd(view, $81901ae0222f0506$var$timeoutComposition);
};
$81901ae0222f0506$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $81901ae0222f0506$var$scheduleComposeEnd(view, 20);
    }
};
function $81901ae0222f0506$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$81901ae0222f0506$var$endComposition(view), delay);
}
function $81901ae0222f0506$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $81901ae0222f0506$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $81901ae0222f0506$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $81901ae0222f0506$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $81901ae0222f0506$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $81901ae0222f0506$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $81901ae0222f0506$var$endComposition(view, restarting = false) {
    if ($81901ae0222f0506$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $81901ae0222f0506$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $81901ae0222f0506$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $81901ae0222f0506$var$brokenClipboardAPI = $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version < 15 || $81901ae0222f0506$var$ios && $81901ae0222f0506$var$webkit_version < 604;
$81901ae0222f0506$var$handlers.copy = $81901ae0222f0506$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $81901ae0222f0506$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $81901ae0222f0506$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $81901ae0222f0506$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $81901ae0222f0506$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $81901ae0222f0506$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $81901ae0222f0506$var$doPaste(view, target.value, null, plain, event);
        else $81901ae0222f0506$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $81901ae0222f0506$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $81901ae0222f0506$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $3xw6l.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $81901ae0222f0506$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $81901ae0222f0506$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$81901ae0222f0506$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$81901ae0222f0506$var$android) return;
    let data = $81901ae0222f0506$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $81901ae0222f0506$var$doPaste(view, $81901ae0222f0506$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $81901ae0222f0506$var$capturePaste(view, event);
};
class $81901ae0222f0506$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $81901ae0222f0506$var$dragCopyModifier = $81901ae0222f0506$var$mac ? "altKey" : "ctrlKey";
$81901ae0222f0506$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $3lIcL.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $3lIcL.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $3lIcL.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $81901ae0222f0506$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$81901ae0222f0506$var$chrome || $81901ae0222f0506$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($81901ae0222f0506$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$81901ae0222f0506$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $81901ae0222f0506$var$Dragging(slice, !event[$81901ae0222f0506$var$dragCopyModifier], node);
};
$81901ae0222f0506$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$81901ae0222f0506$var$editHandlers.dragover = $81901ae0222f0506$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$81901ae0222f0506$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $81901ae0222f0506$var$parseFromClipboard(view, $81901ae0222f0506$var$getText(event.dataTransfer), $81901ae0222f0506$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$81901ae0222f0506$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $3xw6l.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $lzEKq.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $3lIcL.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $3lIcL.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($81901ae0222f0506$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$81901ae0222f0506$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $81901ae0222f0506$var$selectionToDOM(view);
        }, 20);
    }
};
$81901ae0222f0506$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$81901ae0222f0506$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($81901ae0222f0506$var$chrome && $81901ae0222f0506$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $81901ae0222f0506$var$editHandlers)$81901ae0222f0506$var$handlers[prop] = $81901ae0222f0506$var$editHandlers[prop];
function $81901ae0222f0506$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $81901ae0222f0506$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $81901ae0222f0506$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $81901ae0222f0506$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $81901ae0222f0506$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $81901ae0222f0506$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$InlineType && $81901ae0222f0506$var$compareObjs(this.attrs, other.attrs) && $81901ae0222f0506$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $81901ae0222f0506$var$InlineType;
    }
    destroy() {}
}
class $81901ae0222f0506$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $81901ae0222f0506$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$NodeType && $81901ae0222f0506$var$compareObjs(this.attrs, other.attrs) && $81901ae0222f0506$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $81901ae0222f0506$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(pos, pos, new $81901ae0222f0506$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, new $81901ae0222f0506$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, new $81901ae0222f0506$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $81901ae0222f0506$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $81901ae0222f0506$var$WidgetType;
    }
}
const $81901ae0222f0506$var$none = [], $81901ae0222f0506$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $81901ae0222f0506$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $81901ae0222f0506$var$none;
        this.children = children.length ? children : $81901ae0222f0506$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $81901ae0222f0506$var$buildTree(decorations, doc, 0, $81901ae0222f0506$var$noSpec) : $81901ae0222f0506$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $81901ae0222f0506$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $81901ae0222f0506$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $81901ae0222f0506$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $81901ae0222f0506$export$93bf62eb445cec98(newLocal.sort($81901ae0222f0506$var$byPos), $81901ae0222f0506$var$none) : $81901ae0222f0506$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $81901ae0222f0506$var$empty) return $81901ae0222f0506$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $81901ae0222f0506$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $81901ae0222f0506$var$buildTree(found, childNode, baseOffset + 1, $81901ae0222f0506$var$noSpec));
            childIndex += 3;
        });
        let local = $81901ae0222f0506$var$moveSpans(childIndex ? $81901ae0222f0506$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $81901ae0222f0506$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($81901ae0222f0506$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $81901ae0222f0506$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $81901ae0222f0506$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $81901ae0222f0506$export$93bf62eb445cec98(local, children) : $81901ae0222f0506$var$empty;
    }
    forChild(offset, node) {
        if (this == $81901ae0222f0506$var$empty) return this;
        if (node.isLeaf) return $81901ae0222f0506$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $81901ae0222f0506$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $81901ae0222f0506$export$93bf62eb445cec98(local.sort($81901ae0222f0506$var$byPos), $81901ae0222f0506$var$none);
            return child ? new $81901ae0222f0506$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $81901ae0222f0506$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $81901ae0222f0506$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $81901ae0222f0506$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $81901ae0222f0506$var$empty) return $81901ae0222f0506$var$none;
        if (node.inlineContent || !this.local.some($81901ae0222f0506$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $81901ae0222f0506$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $81901ae0222f0506$export$93bf62eb445cec98.empty = new $81901ae0222f0506$export$93bf62eb445cec98([], []);
/**
@internal
*/ $81901ae0222f0506$export$93bf62eb445cec98.removeOverlap = $81901ae0222f0506$var$removeOverlap;
const $81901ae0222f0506$var$empty = $81901ae0222f0506$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $81901ae0222f0506$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $81901ae0222f0506$var$noSpec));
        return $81901ae0222f0506$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $81901ae0222f0506$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $81901ae0222f0506$var$empty) continue;
            if (result instanceof $81901ae0222f0506$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $81901ae0222f0506$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $81901ae0222f0506$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $81901ae0222f0506$var$removeOverlap(sorted ? result : result.sort($81901ae0222f0506$var$byPos)) : $81901ae0222f0506$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $81901ae0222f0506$var$empty;
            case 1:
                return members[0];
            default:
                return new $81901ae0222f0506$var$DecorationGroup(members.every((m)=>m instanceof $81901ae0222f0506$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $81901ae0222f0506$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $81901ae0222f0506$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $81901ae0222f0506$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $81901ae0222f0506$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $81901ae0222f0506$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $81901ae0222f0506$export$93bf62eb445cec98(newLocal.sort($81901ae0222f0506$var$byPos), children);
}
function $81901ae0222f0506$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $81901ae0222f0506$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $81901ae0222f0506$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $81901ae0222f0506$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $81901ae0222f0506$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $81901ae0222f0506$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $81901ae0222f0506$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $81901ae0222f0506$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $81901ae0222f0506$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $81901ae0222f0506$var$moveSpans(hasNulls ? $81901ae0222f0506$var$withoutNulls(spans) : spans, -offset).sort($81901ae0222f0506$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $81901ae0222f0506$export$93bf62eb445cec98(locals, children) : $81901ae0222f0506$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $81901ae0222f0506$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $81901ae0222f0506$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $81901ae0222f0506$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $81901ae0222f0506$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $81901ae0222f0506$var$insertAhead(array, i, deco) {
    while(i < array.length && $81901ae0222f0506$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $81901ae0222f0506$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $81901ae0222f0506$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($81901ae0222f0506$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $81901ae0222f0506$var$DecorationGroup.from(found);
}
const $81901ae0222f0506$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $81901ae0222f0506$var$useCharData = $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11;
class $81901ae0222f0506$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $81901ae0222f0506$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $81901ae0222f0506$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($81901ae0222f0506$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $81901ae0222f0506$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$81901ae0222f0506$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $81901ae0222f0506$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $81901ae0222f0506$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $81901ae0222f0506$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $81901ae0222f0506$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $81901ae0222f0506$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($81901ae0222f0506$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $81901ae0222f0506$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $81901ae0222f0506$var$selectionCollapsed(sel) && (readSel = $81901ae0222f0506$var$selectionFromDOM(view)) && readSel.eq((0, $3lIcL.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $81901ae0222f0506$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $81901ae0222f0506$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $81901ae0222f0506$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $81901ae0222f0506$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $81901ae0222f0506$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $81901ae0222f0506$var$cssChecked = new WeakMap();
let $81901ae0222f0506$var$cssCheckWarned = false;
function $81901ae0222f0506$var$checkCSS(view) {
    if ($81901ae0222f0506$var$cssChecked.has(view)) return;
    $81901ae0222f0506$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $81901ae0222f0506$var$gecko;
        if ($81901ae0222f0506$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $81901ae0222f0506$var$cssCheckWarned = true;
    }
}
function $81901ae0222f0506$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($81901ae0222f0506$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $81901ae0222f0506$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $81901ae0222f0506$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $81901ae0222f0506$var$rangeToSelectionRange(view, found) : null;
}
function $81901ae0222f0506$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $81901ae0222f0506$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$81901ae0222f0506$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($81901ae0222f0506$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $3xw6l.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $81901ae0222f0506$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $81901ae0222f0506$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($81901ae0222f0506$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $81901ae0222f0506$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $81901ae0222f0506$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $81901ae0222f0506$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $81901ae0222f0506$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($81901ae0222f0506$var$chrome && $81901ae0222f0506$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $81901ae0222f0506$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $81901ae0222f0506$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($81901ae0222f0506$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $81901ae0222f0506$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$81901ae0222f0506$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $3lIcL.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $81901ae0222f0506$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $3lIcL.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($81901ae0222f0506$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $3lIcL.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $81901ae0222f0506$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(8, "Backspace")))) {
        if ($81901ae0222f0506$var$android && $81901ae0222f0506$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($81901ae0222f0506$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($81901ae0222f0506$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $81901ae0222f0506$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$81901ae0222f0506$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $81901ae0222f0506$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $81901ae0222f0506$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($81901ae0222f0506$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $81901ae0222f0506$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $81901ae0222f0506$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $81901ae0222f0506$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $81901ae0222f0506$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $3xw6l.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $81901ae0222f0506$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $81901ae0222f0506$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($81901ae0222f0506$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $81901ae0222f0506$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $81901ae0222f0506$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $81901ae0222f0506$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $81901ae0222f0506$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $81901ae0222f0506$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $81901ae0222f0506$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $81901ae0222f0506$export$38b79e3fdcfcfd68 = $81901ae0222f0506$var$serializeForClipboard;
/**
@internal
*/ const $81901ae0222f0506$export$5d42ca91c11c9e4d = $81901ae0222f0506$var$parseFromClipboard;
/**
@internal
*/ const $81901ae0222f0506$export$76b14d3c719c32fc = $81901ae0222f0506$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $81901ae0222f0506$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $81901ae0222f0506$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($81901ae0222f0506$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $81901ae0222f0506$var$getEditable(this);
        $81901ae0222f0506$var$updateCursorWrapper(this);
        this.nodeViews = $81901ae0222f0506$var$buildNodeViews(this);
        this.docView = $81901ae0222f0506$var$docViewDesc(this.state.doc, $81901ae0222f0506$var$computeDocDeco(this), $81901ae0222f0506$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $81901ae0222f0506$var$DOMObserver(this, (from, to, typeOver, added)=>$81901ae0222f0506$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $81901ae0222f0506$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $81901ae0222f0506$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($81901ae0222f0506$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $81901ae0222f0506$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $81901ae0222f0506$var$buildNodeViews(this);
            if ($81901ae0222f0506$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $81901ae0222f0506$var$ensureListeners(this);
        this.editable = $81901ae0222f0506$var$getEditable(this);
        $81901ae0222f0506$var$updateCursorWrapper(this);
        let innerDeco = $81901ae0222f0506$var$viewDecorations(this), outerDeco = $81901ae0222f0506$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $81901ae0222f0506$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($81901ae0222f0506$var$ie || $81901ae0222f0506$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $81901ae0222f0506$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $81901ae0222f0506$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $81901ae0222f0506$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $81901ae0222f0506$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $81901ae0222f0506$var$anchorInRightPlace(this))) $81901ae0222f0506$var$selectionToDOM(this, forceSelUpdate);
            else {
                $81901ae0222f0506$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $81901ae0222f0506$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $3lIcL.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $81901ae0222f0506$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $81901ae0222f0506$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $81901ae0222f0506$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $3lIcL.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($81901ae0222f0506$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $81901ae0222f0506$var$focusPreventScroll(this.dom);
        $81901ae0222f0506$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $81901ae0222f0506$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $81901ae0222f0506$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $81901ae0222f0506$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $81901ae0222f0506$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $81901ae0222f0506$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $81901ae0222f0506$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $81901ae0222f0506$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $81901ae0222f0506$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $81901ae0222f0506$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $81901ae0222f0506$var$safari && this.root.nodeType === 11 && $81901ae0222f0506$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $81901ae0222f0506$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $81901ae0222f0506$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $81901ae0222f0506$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $81901ae0222f0506$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $81901ae0222f0506$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $81901ae0222f0506$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $81901ae0222f0506$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $81901ae0222f0506$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $81901ae0222f0506$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $81901ae0222f0506$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("jc8Nj", function(module, exports) {
$parcel$export(module.exports, "computeJqlInsights", () => $7925d1809e256c8d$export$a7c5229b9bd66697);

var $41qTw = parcelRequire("41qTw");

var $gniDX = parcelRequire("gniDX");
var $3xm7g = parcelRequire("3xm7g");
const $7925d1809e256c8d$export$ccd327fb940bd525 = (text)=>text.split(/(?:\r\n?|\n)/);
const $7925d1809e256c8d$export$c72d593d4a8bb45e = (text)=>{
    const match = (0, $3xm7g.COLLAPSED_CUSTOM_FIELD_PATTERN_NO_QUOTES).exec(text.toLowerCase());
    if (match) return `[${match[1]}]`;
    return undefined;
};
class $7925d1809e256c8d$var$JastAnalyticsListener {
    constructor(jast){
        // Default attributes
        this.attributes = {
            jqlFieldValueCount: {
                issueType: 0,
                project: 0,
                assignee: 0,
                reporter: 0,
                priority: 0,
                status: 0,
                resolution: 0,
                team: 0
            },
            jqlFieldIsUsed: {
                summary: false,
                due: false,
                resolutionDate: false,
                created: false,
                lastviewed: false,
                updated: false,
                team: false
            },
            jqlUsedFields: [],
            jqlUsedFieldsCount: 0,
            jqlUsedFieldsOrderBy: [],
            jqlLineCount: 0,
            jqlErrorCount: 0,
            jqlClauseCount: {
                orderBy: 0,
                leaf: 0,
                and: 0,
                not: 0,
                or: 0
            },
            jqlMaxCompoundClauseDepth: 0
        };
        this.usedFields = new Set();
        this.usedFieldsOrderBy = new Set();
        this.fieldValueCount = 0;
        // The current number of nested compound clauses for an AST node
        this.compoundClauseDepth = 0;
        this.getFieldName = (field)=>{
            return $7925d1809e256c8d$export$c72d593d4a8bb45e(field.value) || field.value.toLowerCase();
        };
        this.incrementFieldValueCount = ()=>{
            this.fieldValueCount += 1;
        };
        this.exitQuery = ()=>{
            // Track all fields used in the query using the term 'other' for non-privacy safe fields
            const privacySafeFields = new Set();
            this.usedFields.forEach((field)=>privacySafeFields.add((0, $gniDX.PRIVACY_SAFE_FIELDS).includes(field) ? field : 'other'));
            this.attributes.jqlUsedFields = Array.from(privacySafeFields).sort();
            this.attributes.jqlUsedFieldsCount = this.usedFields.size;
            this.attributes.jqlUsedFieldsOrderBy = Array.from(this.usedFieldsOrderBy);
        };
        this.enterCompoundClause = (compoundClause)=>{
            if (compoundClause.operator.value === (0, $f6415dda43b7f459$export$6d6d48d210d3ca97)) this.attributes.jqlClauseCount.and += 1;
            else if (compoundClause.operator.value === (0, $f6415dda43b7f459$export$7b8f0a728d79a753)) this.attributes.jqlClauseCount.or += 1;
            this.compoundClauseDepth += 1;
            if (this.compoundClauseDepth > this.attributes.jqlMaxCompoundClauseDepth) this.attributes.jqlMaxCompoundClauseDepth = this.compoundClauseDepth;
        };
        this.exitCompoundClause = ()=>{
            this.compoundClauseDepth -= 1;
        };
        this.enterTerminalClause = (terminalClause)=>{
            const field = this.getFieldName(terminalClause.field);
            switch(field){
                case 0, $gniDX.SUMMARY_FIELD:
                    this.attributes.jqlFieldIsUsed.summary = true;
                    break;
                case 0, $gniDX.DUE_DATE_FIELD:
                    this.attributes.jqlFieldIsUsed.due = true;
                    break;
                case 0, $gniDX.RESOLUTION_DATE_FIELD:
                    this.attributes.jqlFieldIsUsed.resolutionDate = true;
                    break;
                case 0, $gniDX.CREATED_FIELD:
                    this.attributes.jqlFieldIsUsed.created = true;
                    break;
                case 0, $gniDX.LAST_VIEWED_FIELD:
                    this.attributes.jqlFieldIsUsed.lastviewed = true;
                    break;
                case 0, $gniDX.UPDATED_FIELD:
                    this.attributes.jqlFieldIsUsed.updated = true;
                    break;
                case 0, $3xm7g.TEAM_CUSTOM_FIELD_TYPE:
                    this.attributes.jqlFieldIsUsed.team = true;
                    break;
            }
            this.attributes.jqlClauseCount.leaf += 1;
            // Track all fields used in the query
            this.usedFields.add(field);
            // Reset our count of RHS values for the field
            this.fieldValueCount = 0;
        };
        this.exitTerminalClause = (terminalClause)=>{
            switch(this.getFieldName(terminalClause.field)){
                case 0, $gniDX.ISSUE_TYPE_FIELD:
                case 0, $gniDX.TYPE_FIELD:
                    this.attributes.jqlFieldValueCount.issueType += this.fieldValueCount;
                    break;
                case 0, $gniDX.PROJECT_FIELD:
                    this.attributes.jqlFieldValueCount.project += this.fieldValueCount;
                    break;
                case 0, $gniDX.ASSIGNEE_FIELD:
                    this.attributes.jqlFieldValueCount.assignee += this.fieldValueCount;
                    break;
                case 0, $gniDX.REPORTER_FIELD:
                    this.attributes.jqlFieldValueCount.reporter += this.fieldValueCount;
                    break;
                case 0, $gniDX.PRIORITY_FIELD:
                    this.attributes.jqlFieldValueCount.priority += this.fieldValueCount;
                    break;
                case 0, $gniDX.STATUS_FIELD:
                    this.attributes.jqlFieldValueCount.status += this.fieldValueCount;
                    break;
                case 0, $gniDX.RESOLUTION_FIELD:
                    this.attributes.jqlFieldValueCount.resolution += this.fieldValueCount;
                    break;
                case 0, $3xm7g.TEAM_CUSTOM_FIELD_TYPE:
                    this.attributes.jqlFieldValueCount.team += this.fieldValueCount;
                    break;
                default:
                    break;
            }
        };
        this.enterNotClause = ()=>{
            this.attributes.jqlClauseCount.not += 1;
        };
        this.enterFunctionOperand = this.incrementFieldValueCount;
        this.enterKeywordOperand = this.incrementFieldValueCount;
        this.enterValueOperand = this.incrementFieldValueCount;
        this.enterOrderByField = (orderByField)=>{
            this.usedFieldsOrderBy.add(this.getFieldName(orderByField.field));
            this.attributes.jqlClauseCount.orderBy += 1;
        };
        this.attributes.jqlLineCount = $7925d1809e256c8d$export$ccd327fb940bd525(jast.represents).length;
        this.attributes.jqlErrorCount = jast.errors.length;
    }
}
const $7925d1809e256c8d$export$a7c5229b9bd66697 = (jast)=>{
    const listener = new $7925d1809e256c8d$var$JastAnalyticsListener(jast);
    (0, $41qTw.walkAST)(listener, jast);
    return listener.attributes;
};

});
parcelRegister("41qTw", function(module, exports) {
$parcel$export(module.exports, "walkAST", () => $669df150c3d9c2ae$export$a8de6ce748deffac);
const $669df150c3d9c2ae$export$a8de6ce748deffac = (listener, jast)=>{
    jast.query && $669df150c3d9c2ae$var$walkNode(listener, jast.query);
};
const $669df150c3d9c2ae$var$walkNode = (listener, node)=>{
    listener.enterEveryNode && listener.enterEveryNode(node);
    node.enterNode(listener);
    node.getChildren().forEach((child)=>$669df150c3d9c2ae$var$walkNode(listener, child));
    node.exitNode(listener);
    listener.exitEveryNode && listener.exitEveryNode(node);
};

});

parcelRegister("gniDX", function(module, exports) {
$parcel$export(module.exports, "ASSIGNEE_FIELD", () => $5660d2f8e01b4076$export$f7a08bf17a7ac661);
$parcel$export(module.exports, "CREATED_FIELD", () => $5660d2f8e01b4076$export$9063bfeedbc1236f);
$parcel$export(module.exports, "DUE_DATE_FIELD", () => $5660d2f8e01b4076$export$f4a47f55547a932c);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD", () => $5660d2f8e01b4076$export$2d5a62a3515ad4c6);
$parcel$export(module.exports, "LAST_VIEWED_FIELD", () => $5660d2f8e01b4076$export$eac61537b9fdb3be);
$parcel$export(module.exports, "PRIORITY_FIELD", () => $5660d2f8e01b4076$export$de14210faa5f2099);
$parcel$export(module.exports, "PROJECT_FIELD", () => $5660d2f8e01b4076$export$aa5680ad8f8be9fc);
$parcel$export(module.exports, "REPORTER_FIELD", () => $5660d2f8e01b4076$export$d64150fd9c66969c);
$parcel$export(module.exports, "RESOLUTION_DATE_FIELD", () => $5660d2f8e01b4076$export$f603d3cf4c8489e8);
$parcel$export(module.exports, "STATUS_FIELD", () => $5660d2f8e01b4076$export$3068d6fae4de53c8);
$parcel$export(module.exports, "SUMMARY_FIELD", () => $5660d2f8e01b4076$export$9b9fe8882c3e0da3);
$parcel$export(module.exports, "TYPE_FIELD", () => $5660d2f8e01b4076$export$e53b76a613c435e0);
$parcel$export(module.exports, "UPDATED_FIELD", () => $5660d2f8e01b4076$export$7101642b50bf10bc);
$parcel$export(module.exports, "RESOLUTION_FIELD", () => $5660d2f8e01b4076$export$252fb981af0e2e4e);
$parcel$export(module.exports, "PRIVACY_SAFE_FIELDS", () => $5660d2f8e01b4076$export$49017cdca0837b83);
const $5660d2f8e01b4076$export$f7a08bf17a7ac661 = 'assignee';
const $5660d2f8e01b4076$export$9063bfeedbc1236f = 'created';
const $5660d2f8e01b4076$export$f4a47f55547a932c = 'duedate';
const $5660d2f8e01b4076$export$28d0e5e03b779eff = 'issuekey';
const $5660d2f8e01b4076$export$2d5a62a3515ad4c6 = 'issuetype';
const $5660d2f8e01b4076$export$eac61537b9fdb3be = 'lastviewed';
const $5660d2f8e01b4076$export$de14210faa5f2099 = 'priority';
const $5660d2f8e01b4076$export$aa5680ad8f8be9fc = 'project';
const $5660d2f8e01b4076$export$d64150fd9c66969c = 'reporter';
const $5660d2f8e01b4076$export$ad2fb2fa5ecb427a = 'resolved';
const $5660d2f8e01b4076$export$f603d3cf4c8489e8 = 'resolutiondate';
const $5660d2f8e01b4076$export$3068d6fae4de53c8 = 'status';
const $5660d2f8e01b4076$export$f4d2dc00d9b9c983 = 'statuscategory';
const $5660d2f8e01b4076$export$9b9fe8882c3e0da3 = 'summary';
const $5660d2f8e01b4076$export$23ca38ad884e35f1 = 'text';
const $5660d2f8e01b4076$export$b3e1b98671aae084 = 'textfields';
const $5660d2f8e01b4076$export$e53b76a613c435e0 = 'type';
const $5660d2f8e01b4076$export$7101642b50bf10bc = 'updated';
const $5660d2f8e01b4076$export$c7761054d987f9ab = 'affectedversion';
const $5660d2f8e01b4076$export$9ae86b690ef8ceed = 'approvals';
const $5660d2f8e01b4076$export$4b5a561405c5f211 = 'category';
const $5660d2f8e01b4076$export$a3ff506aee89f5de = 'component';
const $5660d2f8e01b4076$export$6a045eda3865d703 = 'description';
const $5660d2f8e01b4076$export$b6b1af0981f1891e = 'development';
const $5660d2f8e01b4076$export$39df30b837789c3 = 'environment';
const $5660d2f8e01b4076$export$8723b724f0b3ac65 = 'epic link';
const $5660d2f8e01b4076$export$4b5030dff66bb705 = 'filter';
const $5660d2f8e01b4076$export$3ec395376855802f = 'fixversion';
const $5660d2f8e01b4076$export$a8945db82fc2e785 = 'labels';
const $5660d2f8e01b4076$export$bf9df74e065af482 = 'parent';
const $5660d2f8e01b4076$export$252fb981af0e2e4e = 'resolution';
const $5660d2f8e01b4076$export$64238d76a1dc0703 = 'sprint';
const $5660d2f8e01b4076$export$62edbfa1bb10b91 = 'assignee.property';
const $5660d2f8e01b4076$export$5afd9733860db123 = 'creator.property';
const $5660d2f8e01b4076$export$3ccfe20fd4420801 = 'issue.property';
const $5660d2f8e01b4076$export$d955a5d923cc59e6 = 'project.property';
const $5660d2f8e01b4076$export$ed42e707855fc6a4 = 'reporter.property';
const $5660d2f8e01b4076$export$3b63269c1c533321 = 'voter.property';
const $5660d2f8e01b4076$export$bd7061bb445305dd = 'watcher.property';
const $5660d2f8e01b4076$export$49017cdca0837b83 = [
    $5660d2f8e01b4076$export$f7a08bf17a7ac661,
    $5660d2f8e01b4076$export$9063bfeedbc1236f,
    $5660d2f8e01b4076$export$f4a47f55547a932c,
    $5660d2f8e01b4076$export$28d0e5e03b779eff,
    $5660d2f8e01b4076$export$2d5a62a3515ad4c6,
    $5660d2f8e01b4076$export$eac61537b9fdb3be,
    $5660d2f8e01b4076$export$de14210faa5f2099,
    $5660d2f8e01b4076$export$aa5680ad8f8be9fc,
    $5660d2f8e01b4076$export$d64150fd9c66969c,
    $5660d2f8e01b4076$export$ad2fb2fa5ecb427a,
    $5660d2f8e01b4076$export$f603d3cf4c8489e8,
    $5660d2f8e01b4076$export$3068d6fae4de53c8,
    $5660d2f8e01b4076$export$f4d2dc00d9b9c983,
    $5660d2f8e01b4076$export$9b9fe8882c3e0da3,
    $5660d2f8e01b4076$export$23ca38ad884e35f1,
    $5660d2f8e01b4076$export$b3e1b98671aae084,
    $5660d2f8e01b4076$export$e53b76a613c435e0,
    $5660d2f8e01b4076$export$7101642b50bf10bc,
    $5660d2f8e01b4076$export$c7761054d987f9ab,
    $5660d2f8e01b4076$export$9ae86b690ef8ceed,
    $5660d2f8e01b4076$export$4b5a561405c5f211,
    $5660d2f8e01b4076$export$a3ff506aee89f5de,
    $5660d2f8e01b4076$export$6a045eda3865d703,
    $5660d2f8e01b4076$export$b6b1af0981f1891e,
    $5660d2f8e01b4076$export$39df30b837789c3,
    $5660d2f8e01b4076$export$8723b724f0b3ac65,
    $5660d2f8e01b4076$export$4b5030dff66bb705,
    $5660d2f8e01b4076$export$3ec395376855802f,
    $5660d2f8e01b4076$export$a8945db82fc2e785,
    $5660d2f8e01b4076$export$bf9df74e065af482,
    $5660d2f8e01b4076$export$252fb981af0e2e4e,
    $5660d2f8e01b4076$export$64238d76a1dc0703,
    // entity properties
    $5660d2f8e01b4076$export$62edbfa1bb10b91,
    $5660d2f8e01b4076$export$5afd9733860db123,
    $5660d2f8e01b4076$export$3ccfe20fd4420801,
    $5660d2f8e01b4076$export$d955a5d923cc59e6,
    $5660d2f8e01b4076$export$ed42e707855fc6a4,
    $5660d2f8e01b4076$export$3b63269c1c533321,
    $5660d2f8e01b4076$export$bd7061bb445305dd
];

});

parcelRegister("3xm7g", function(module, exports) {
$parcel$export(module.exports, "TEAM_CUSTOM_FIELD_TYPE", () => $2d0bd590f2a114aa$export$7db5aa892c7d5359);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN", () => $2d0bd590f2a114aa$export$72fbd4b3f260d743);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN_NO_QUOTES", () => $2d0bd590f2a114aa$export$4b8ecf135de492a1);
// This is a list of field types expected as collapsed fields, e.g. of the form
// name[fieldtype]. The square brackets are retained to allow us to more easily
// differentiate these from regular fields.
// Currently these are being used in `jql-insights-listener.ts` to allow us to
// collect data about the usage of some custom field types.
// All field type names here must be in lower case
const $2d0bd590f2a114aa$export$7db5aa892c7d5359 = '[team]';
const $2d0bd590f2a114aa$export$72fbd4b3f260d743 = /^['"].+\[(\D+)]['"]$/i;
const $2d0bd590f2a114aa$export$4b8ecf135de492a1 = /^.+\[(\D+)]$/i;

});

const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';


parcelRegister("dEBM2", function(module, exports) {
$parcel$export(module.exports, "JQLAutocomplete", () => $c0b490496bca89a3$export$d8b474ffd49aa2d1);

var $jz1xX = parcelRequire("jz1xX");

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");

var $dJRhB = parcelRequire("dJRhB");

var $4rAkI = parcelRequire("4rAkI");

var $8Oxi7 = parcelRequire("8Oxi7");

var $3e63f = parcelRequire("3e63f");

var $bBlHv = parcelRequire("bBlHv");
class $c0b490496bca89a3$export$d8b474ffd49aa2d1 extends (0, $dJRhB.BaseAutocomplete) {
    /**
	 * Compute autocomplete suggestions for the given JQLParser and parse tree. Parse tree is used
	 * when determining the context for rule suggestions. When `tree` is undefined (e.g. if parsing
	 * failed due to a syntax error) then correct suggestions will still be returned, but contextual
	 * information like field/operator will not be included.
	 */ constructor(parser, ignoredTokens = (0, $8Oxi7.defaultIgnoredTokens), preferredRules = (0, $8Oxi7.defaultPreferredRules), delimiterTokens = (0, $8Oxi7.defaultDelimiterTokens), tree){
        super(parser, ignoredTokens, preferredRules, delimiterTokens);
        this.tree = tree;
    }
    /**
	 * Parse the provided text and return a new {@link JQLAutocomplete} object (**does** include
	 * {@link JQLRuleContext} data for rule suggestions).
	 *
	 * @param text Text to compute suggestions for.
	 * @param ignoredTokens Tokens which we do not want to return as suggestions. When not provided, {@link defaultIgnoredTokens} will be used.
	 * @param preferredRules Rules we want to return as suggestions. When not provided, {@link defaultPreferredRules} will be used.
	 * @param delimiterTokens Tokens to use as delimiters. When not provided, {@link defaultDelimiterTokens} will be used.
	 */ static fromText(text, ignoredTokens, preferredRules, delimiterTokens) {
        const charStream = (0, $jz1xX.CharStreams).fromString(text);
        const lexer = new (0, $bFJ48.JQLLexer)(charStream);
        const tokenStream = new (0, $jz1xX.CommonTokenStream)(lexer);
        const parser = new (0, $41LBU.JQLParser)(tokenStream);
        parser.removeErrorListeners();
        return new $c0b490496bca89a3$export$d8b474ffd49aa2d1(parser, ignoredTokens, preferredRules, delimiterTokens, parser.jqlQuery());
    }
    /**
	 * Return a new {@link JQLAutocomplete} object using the provided parser instance (**does not**
	 * include {@link JQLRuleContext} data for rule suggestions).
	 *
	 * @param parser Parser instance to compute suggestions for.
	 * @param ignoredTokens Tokens which we do not want to return as suggestions. When not provided, {@link defaultIgnoredTokens} will be used.
	 * @param preferredRules Rules we want to return as suggestions. When not provided, {@link defaultPreferredRules} will be used.
	 * @param delimiterTokens Tokens to use as delimiters. When not provided, {@link defaultDelimiterTokens} will be used.
	 */ static fromParser(parser, ignoredTokens, preferredRules, delimiterTokens) {
        return new $c0b490496bca89a3$export$d8b474ffd49aa2d1(parser, ignoredTokens, preferredRules, delimiterTokens);
    }
    /**
	 * Walk the parse tree and mutate the provided rules object to add context data for relevant rules.
	 *
	 * @override
	 */ assignRuleContextData(maybeCaretToken, rules) {
        if (this.tree === undefined) return rules;
        rules.forEach(([ruleSuggestion, ruleList], ruleNumber)=>{
            if ((0, $4rAkI.rulesWithContext).includes(ruleNumber)) {
                const ruleContextVisitor = new (0, $3e63f.RuleContextVisitor)(ruleSuggestion, ruleList, ruleNumber, this.getTokenStream(), maybeCaretToken);
                ruleSuggestion.context = this.tree?.accept(ruleContextVisitor) ?? null;
            }
        });
        return rules;
    }
    getJQLSuggestionsForCaretPosition(caretSelectionRange) {
        return this.mapToJQLSuggestions(this.getSuggestionsForCaretPosition(caretSelectionRange));
    }
    getJQLSuggestionsForTokenIndex(tokenIndex) {
        return this.mapToJQLSuggestions(this.getSuggestionsForTokenIndex(tokenIndex));
    }
    /**
	 * Map the provided rule suggestions keyed by parser rule index into {@link JQLRuleSuggestions}
	 * using a consumer-friendly rule name.
	 *
	 * Here we maintain a fixed subset of JQL parse rules which we return as rule suggestions. We map
	 * the parse rule index into a predefined string which consumers should use when interpreting
	 * rules.
	 *
	 * Why do we only support a subset of rules? Because otherwise we'd have 2 options:
	 * 1. Return all rules keyed by rule index. This means consumers need to import the JQLParser
	 * module to interpret the rule and will become more tightly coupled to ANTLR generated
	 * dependencies.
	 * 2. Return all rules keyed by the rule display name. This will make implementation more fragile
	 * as any change to rule names within our grammar has the potential to break all consumers.
	 *
	 * By only supporting a subset of rules, we can gradually evolve the list as new use cases emerge
	 * and ensure that consumers have a stable API they can build upon.
	 *
	 * @override
	 */ mapToJQLSuggestions({ tokens: tokens, rules: rules }) {
        const ruleSuggestions = {};
        rules.forEach(([ruleSuggestion, ruleList], key)=>{
            switch(key){
                case (0, $41LBU.JQLParser).RULE_jqlField:
                    ruleSuggestions.field = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlCustomField:
                    ruleSuggestions.customField = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlEqualsOperator:
                case (0, $41LBU.JQLParser).RULE_jqlLikeOperator:
                case (0, $41LBU.JQLParser).RULE_jqlComparisonOperator:
                case (0, $41LBU.JQLParser).RULE_jqlInOperator:
                case (0, $41LBU.JQLParser).RULE_jqlIsOperator:
                case (0, $41LBU.JQLParser).RULE_jqlWasOperator:
                case (0, $41LBU.JQLParser).RULE_jqlWasInOperator:
                case (0, $41LBU.JQLParser).RULE_jqlChangedOperator:
                    ruleSuggestions.operator = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlValue:
                    // Disable autocomplete for predicate operands.
                    // To be removed when we build proper autocomplete support.
                    if (!(0, $bBlHv.isPredicateOperand)(ruleList)) ruleSuggestions.value = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlListStart:
                    // Disable autocomplete for predicate operands.
                    // To be removed when we build proper autocomplete support.
                    if (!(0, $bBlHv.isPredicateOperand)(ruleList)) ruleSuggestions.list = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlFunction:
                    // Disable autocomplete for predicate operands.
                    // To be removed when we build proper autocomplete support.
                    if (!(0, $bBlHv.isPredicateOperand)(ruleList)) ruleSuggestions.function = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlFieldProperty:
                    ruleSuggestions.fieldProperty = ruleSuggestion;
                    break;
                case (0, $41LBU.JQLParser).RULE_jqlArgument:
                    for(let i = ruleList.length - 1; i >= 0; i--){
                        // The argument rule is shared between functions and field properties. We inspect the
                        // rule list to determine which rule our suggestion is scoped to.
                        if (ruleList[i] === (0, $41LBU.JQLParser).RULE_jqlFunction) {
                            ruleSuggestions.functionArgument = ruleSuggestion;
                            break;
                        }
                        if (ruleList[i] === (0, $41LBU.JQLParser).RULE_jqlPropertyArgument) {
                            ruleSuggestions.fieldPropertyArgument = ruleSuggestion;
                            break;
                        }
                        if (ruleList[i] === (0, $41LBU.JQLParser).RULE_jqlFieldProperty) {
                            ruleSuggestions.fieldPropertyId = ruleSuggestion;
                            break;
                        }
                    }
                    break;
                default:
            }
        });
        return {
            tokens: tokens,
            rules: ruleSuggestions
        };
    }
    isCaretAtUnclosedString(caretToken) {
        return (0, $4rAkI.unclosedStringTokens).includes(caretToken.type);
    }
    /**
	 *  This method is being overridden for a specific scenario where we encounter string inside an unclosed single quote or double quote.
	 *  If this method returns null then the Position calculation will be further processed by getReplacePosition in the base-autocomplete/
	 *
	 *  @override
	 *
	 */ overrideReplacePosition(replaceStartToken, maybeCaretToken, caretSelectionRange) {
        if (maybeCaretToken && this.isCaretAtUnclosedString(maybeCaretToken)) {
            const [start, stop] = caretSelectionRange;
            // If the replaceStartToken is not defined (i.e. cursor at beginning of string) or the caret is
            // positioned at a delimiter/hidden token then we want to append at selection start.
            // Otherwise we want our replacement to start from the beginning of specified token.
            const startPosition = replaceStartToken === undefined || this.isCaretAtDelimiterOrHiddenToken(replaceStartToken) ? start : Math.min(replaceStartToken.startIndex, start);
            return [
                startPosition,
                stop
            ];
        }
        return null;
    }
}

});
parcelRegister("dJRhB", function(module, exports) {
$parcel$export(module.exports, "BaseAutocomplete", () => $b71015d25ceb0401$export$615062c2f0682208);

var $i5xvl = parcelRequire("i5xvl");

var $jz1xX = parcelRequire("jz1xX");

var $4BpPc = parcelRequire("4BpPc");
class $b71015d25ceb0401$export$615062c2f0682208 {
    /**
	 * Compute autocomplete suggestions for the given Parser.
	 *
	 * @param parser Parser instance to compute suggestions for.
	 * @param ignoredTokens Tokens which we do not want to return as suggestions, used by [antlr4-c3](https://github.com/mike-lischke/antlr4-c3#ignored-tokens).
	 * @param preferredRules Rules we want to return as suggestions, used by [antlr4-c3](https://github.com/mike-lischke/antlr4-c3#preferred-rules).
	 * @param delimiterTokens Tokens to use as delimiters. When the caret is positioned at a delimiter
	 * token then we'll look for suggestions **after** the current token.
	 */ constructor(parser, ignoredTokens = new Set(), preferredRules = new Set(), delimiterTokens = new Set()){
        this.parser = parser;
        this.core = new (0, $i5xvl.CodeCompletionCore)(this.parser);
        this.core.ignoredTokens = ignoredTokens;
        this.core.preferredRules = preferredRules;
        // This ensures we get more specific matches for recursive rules, e.g. list operands `status in (`
        this.core.translateRulesTopDown = true;
        this.delimiterTokens = delimiterTokens;
    }
    getTokenStream() {
        return this.parser.inputStream;
    }
    /**
	 * Return the matched text for the current token and range of selected characters.
	 *
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 * @private
	 */ getMatchedText(maybeCaretToken, caretSelectionRange) {
        if (!maybeCaretToken) return '';
        // If the caret is at a delimiter or hidden token then our matched text should be computed
        // starting at the next token
        const startTokenIndex = this.isCaretAtDelimiterOrHiddenToken(maybeCaretToken) ? maybeCaretToken.tokenIndex + 1 : maybeCaretToken.tokenIndex;
        return (0, $4BpPc.getMatchedText)(this.getTokenStream(), startTokenIndex, maybeCaretToken, caretSelectionRange);
    }
    /**
	 * Map the provided collection of candidate tokens into {@link TokenSuggestions} using a
	 * consumer-friendly token name.
	 *
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 * @param collectedCandidateTokens Token suggestions from `antlr4-c3`
	 */ getCandidateTokens(maybeCaretToken, caretSelectionRange, collectedCandidateTokens) {
        const candidateTokens = [];
        collectedCandidateTokens.forEach((value, key)=>{
            const tokenSequence = [
                key,
                ...value
            ]; // handle token sequences that are always used together, e.g. ORDER + BY
            const tokenName = tokenSequence.map((tokenType)=>this.parser.vocabulary.getDisplayName(tokenType).replace(/^'|'$/g, '')).join(' ');
            if (tokenName) candidateTokens.push(tokenName);
        });
        candidateTokens.sort();
        const matchedText = this.getMatchedText(maybeCaretToken, caretSelectionRange);
        const replacePosition = this.getReplacePosition(maybeCaretToken, maybeCaretToken, caretSelectionRange);
        return {
            matchedText: matchedText,
            replacePosition: replacePosition,
            values: candidateTokens
        };
    }
    /**
	 * Map the provided collection of candidate rules into {@link RuleSuggestionsWithRuleList}. This
	 * allows subclasses to assign contextual data to each suggestion.
	 *
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 * @param collectedCandidateRules Rule suggestions from `antlr4-c3`
	 */ getCandidateRules(maybeCaretToken, caretSelectionRange, collectedCandidateRules) {
        const rules = this.mapCandidateRules(maybeCaretToken, caretSelectionRange, collectedCandidateRules);
        return this.assignRuleContextData(maybeCaretToken, rules);
    }
    /**
	 * Map the provided collection of candidate rules into {@link RuleSuggestionsWithRuleList}.
	 *
	 * @param collectedCandidateRules Rule suggestions from `antlr4-c3`
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 */ mapCandidateRules(maybeCaretToken, caretSelectionRange, collectedCandidateRules) {
        const rules = new Map();
        const tokens = this.getTokenStream();
        collectedCandidateRules.forEach(({ startTokenIndex: startTokenIndex, ruleList: ruleList }, key)=>{
            let defaultRule;
            const startToken = tokens.get(startTokenIndex);
            const replacePosition = this.getReplacePosition(startToken, maybeCaretToken, caretSelectionRange);
            if (!maybeCaretToken) // The only case where maybeCaretToken is not defined is when the cursor is at the beginning of
            // the string. In this case we can safely assume our start position is 0.
            defaultRule = {
                matchedText: '',
                replacePosition: replacePosition,
                context: null
            };
            else {
                const matchedText = (0, $4BpPc.getMatchedText)(tokens, startTokenIndex, maybeCaretToken, caretSelectionRange);
                defaultRule = {
                    matchedText: matchedText,
                    replacePosition: replacePosition,
                    context: null
                };
            }
            rules.set(key, [
                defaultRule,
                ruleList
            ]);
        });
        return rules;
    }
    /**
	 * Return the input token for a given caret position. If the caret is positioned at the start of
	 * the input, or no matching token could be found then `undefined` is returned.
	 *
	 * @param caretStartPosition Caret position.
	 * @private
	 */ getCaretToken(caretStartPosition) {
        if (caretStartPosition === 0) return undefined;
        const tokens = this.getTokenStream().getTokens();
        for (const token of tokens){
            if (caretStartPosition > token.startIndex && caretStartPosition <= token.stopIndex + 1 || token.type === (0, $jz1xX.Token).EOF) return token;
        }
        return undefined;
    }
    /**
	 * Determines if the provided token is one of the configured {@link delimiterTokens}.
	 *
	 * @param caretToken The token matched for a given caret position.
	 * @private
	 */ isCaretAtDelimiterToken(caretToken) {
        return this.delimiterTokens.has(caretToken.type);
    }
    /**
	 * Determine if the provided token is one of the configured {@link delimiterTokens}, or a hidden
	 * token. Hidden token refers to a token on ANTLR's HIDDEN_CHANNEL. This means the token is not
	 * represented in the parse tree and effectively ignored.
	 *
	 * @param caretToken The token matched for a given caret position.
	 * @protected
	 */ isCaretAtDelimiterOrHiddenToken(caretToken) {
        return this.isCaretAtDelimiterToken(caretToken) || caretToken.channel === (0, $jz1xX.Token).HIDDEN_CHANNEL;
    }
    /**
	 * This method has no default implementation. The class which wants to override a specific scenario to calculate replace position,
	 * will have to provide implementation. If this method returns null, the position will be calculated by {@see BaseAutocomplete#getReplacePosition}
	 *
	 * @param replaceStartToken The token which should be used when determining the replacement start
	 * position. For token suggestions this will match `maybeCaretToken`, for rules this will refer to
	 * the start token where the rule should be replaced.
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 * @protected
	 */ overrideReplacePosition(replaceStartToken, maybeCaretToken, caretSelectionRange) {
        return null;
    }
    /**
	 * Determine the range of characters that should be replaced for a token or rule suggestion.
	 * Token and rule replacement adheres to the following strategy:
	 * - If the caret selection is **inside** a token, then the entire token will be replaced.
	 * e.g. `s|tatu|s => story|`
	 * - If the caret selection starts **before** a token, then the selection will be replaced.
	 * e.g. `|statu|s => story|s`
	 * - If the caret selection spans **across** tokens, then the beginning of the start token, up
	 * until selection end, will be replaced. e.g. `s|tatus = op|en => story|en`
	 *
	 *
	 * @param replaceStartToken The token which should be used when determining the replacement start
	 * position. For token suggestions this will match `maybeCaretToken`, for rules this will refer to
	 * the start token where the rule should be replaced.
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 * @private
	 */ getReplacePosition(replaceStartToken, maybeCaretToken, caretSelectionRange) {
        // Replace position will be overridden, if only the grammar specific class has overriden method `overrideReplacePosition`
        // else the method `overrideReplacePosition` will return null and the calculation of position will continue further in the current method.
        const overriddenReplacePosition = this.overrideReplacePosition(replaceStartToken, maybeCaretToken, caretSelectionRange);
        if (overriddenReplacePosition) return overriddenReplacePosition;
        const [start, stop] = caretSelectionRange;
        // If the replaceStartToken is not defined (i.e. cursor at beginning of string) or the caret is
        // positioned at a delimiter/hidden token then we want to append at selection start.
        // Otherwise we want our replacement to start from the beginning of specified token.
        const startPosition = replaceStartToken === undefined || this.isCaretAtDelimiterOrHiddenToken(replaceStartToken) ? start : Math.min(replaceStartToken.startIndex, start);
        // If the maybeCaretToken is not defined (i.e. cursor at beginning of string) or the caret is
        // positioned at a delimiter/hidden token then we want to replace up until selection stop.
        // Otherwise we want our replacement to replace the entire token beneath the caret.
        const stopPosition = maybeCaretToken === undefined || this.isCaretAtDelimiterOrHiddenToken(maybeCaretToken) ? stop : Math.max(maybeCaretToken.stopIndex + 1, stop);
        return [
            startPosition,
            stopPosition
        ];
    }
    /**
	 * Return autocomplete suggestions for the provided caret position in the input stream.
	 *
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 */ getCandidates(maybeCaretToken, caretSelectionRange) {
        let caretTokenIndex;
        if (maybeCaretToken === undefined) caretTokenIndex = 0;
        else caretTokenIndex = this.isCaretAtDelimiterToken(maybeCaretToken) ? maybeCaretToken.tokenIndex + 1 : maybeCaretToken.tokenIndex;
        const collectedCandidates = this.core.collectCandidates(caretTokenIndex);
        const tokens = this.getCandidateTokens(maybeCaretToken, caretSelectionRange, collectedCandidates.tokens);
        const rules = this.getCandidateRules(maybeCaretToken, caretSelectionRange, collectedCandidates.rules);
        return {
            tokens: tokens,
            rules: rules
        };
    }
    /**
	 * Returns list of expected next tokens based on the provided caret position.
	 *
	 * @param caretSelectionRange The range of characters that are selected in the input stream. This
	 * will determine the `replacePosition` computed for the returned {@link Suggestions}.
	 */ getSuggestionsForCaretPosition(caretSelectionRange) {
        const maybeCaretToken = this.getCaretToken(caretSelectionRange[0]);
        return this.getCandidates(maybeCaretToken, caretSelectionRange);
    }
    /**
	 * Returns list of expected next tokens based on the provided token index.
	 *
	 * @param tokenIndex Index of the token to retrieve suggestions for.
	 */ getSuggestionsForTokenIndex(tokenIndex) {
        const caretToken = this.getTokenStream().get(tokenIndex);
        // When token index is provided, we behave as if the caret was at the end of the token
        const caretSelectionRange = [
            caretToken.stopIndex + 1,
            caretToken.stopIndex + 1
        ];
        return this.getCandidates(caretToken, caretSelectionRange);
    }
    /**
	 * Subclasses can override this method to assign contextual data to the provided `ruleSuggestions`.
	 * For example, a grammar may return the following rule for the RHS of a simple boolean expression:
	 * `loading === `
	 * ```
	 * {
	 *   rhs: {
	 *     matchedText: '',
	 *     replacePosition: [16, 16],
	 *     context: {}
	 *   }
	 * }
	 * ```
	 * The subclass can enrich this suggestion with the LHS variable reference. e.g.
	 * ```
	 * {
	 *   rhs: {
	 *     matchedText: '',
	 *     replacePosition: [16, 16],
	 *     context: {
	 *       lhs: 'loading'
	 *     }
	 *   }
	 * }
	 * ```
	 *
	 * @param maybeCaretToken The token to retrieve autocomplete suggestions for. When undefined we
	 * return suggestions for the beginning of the input.
	 * @param rules Map of {@link RuleSuggestion} to assign context data to keyed by parser rule index.
	 * @protected
	 */ assignRuleContextData(maybeCaretToken, rules) {
        return rules;
    }
}

});
parcelRegister("i5xvl", function(module, exports) {
"use strict";
/*
 * This file is released under the MIT license.
 * Copyright (c) 2016, 2021, Mike Lischke
 *
 * See LICENSE file for more info.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeCompletionCore = module.exports.CandidatesCollection = void 0;

var $jz1xX = parcelRequire("jz1xX");

var $9KX0v = parcelRequire("9KX0v");

var $6og9T = parcelRequire("6og9T");
// All the candidates which have been found. Tokens and rules are separated.
// Token entries include a list of tokens that directly follow them (see also the "following" member in the
// FollowSetWithPath class).
// Rule entries include the index of the starting token within the evaluated rule, along with a call stack of rules
// found during evaluation.
class $d2b2aef3c19b76bd$var$CandidatesCollection {
    constructor(){
        this.tokens = new Map();
        this.rules = new Map();
    }
}
module.exports.CandidatesCollection = $d2b2aef3c19b76bd$var$CandidatesCollection;
// A record for a follow set along with the path at which this set was found.
// If there is only a single symbol in the interval set then we also collect and store tokens which follow
// this symbol directly in its rule (i.e. there is no intermediate rule transition). Only single label transitions
// are considered. This is useful if you have a chain of tokens which can be suggested as a whole, because there is
// a fixed sequence in the grammar.
class $d2b2aef3c19b76bd$var$FollowSetWithPath {
    constructor(){
        this.path = [];
        this.following = [];
    }
}
// A list of follow sets (for a given state number) + all of them combined for quick hit tests + whether they are
// exhaustive (false if subsequent yet-unprocessed rules could add further tokens to the follow set, true otherwise).
// This data is static in nature (because the used ATN states are part of a static struct: the ATN).
// Hence it can be shared between all C3 instances, however it depends on the actual parser class (type).
class $d2b2aef3c19b76bd$var$FollowSetsHolder {
}
// The main class for doing the collection process.
class $d2b2aef3c19b76bd$var$CodeCompletionCore {
    constructor(parser){
        // Debugging options. Print human readable ATN state and other info.
        // Not dependent on showDebugOutput. Prints the collected rules + tokens to terminal.
        this.showResult = false;
        // Enables printing ATN state info to terminal.
        this.showDebugOutput = false;
        // Only relevant when showDebugOutput is true. Enables transition printing for a state.
        this.debugOutputWithTransitions = false;
        // Also depends on showDebugOutput. Enables call stack printing for each rule recursion.
        this.showRuleStack = false;
        // Specify if preferred rules should translated top-down (higher index rule returns first) or
        // bottom-up (lower index rule returns first).
        this.translateRulesTopDown = false;
        this.tokenStartIndex = 0;
        this.statesProcessed = 0;
        // A mapping of rule index + token stream position to end token positions.
        // A rule which has been visited before with the same input position will always produce the same output positions.
        this.shortcutMap = new Map();
        // The collected candidates (rules and tokens).
        this.candidates = new $d2b2aef3c19b76bd$var$CandidatesCollection();
        this.parser = parser;
        this.atn = parser.atn;
        this.vocabulary = parser.vocabulary;
        this.ruleNames = parser.ruleNames;
        this.ignoredTokens = new Set();
        this.preferredRules = new Set();
    }
    /**
     * This is the main entry point. The caret token index specifies the token stream index for the token which
     * currently covers the caret (or any other position you want to get code completion candidates for).
     * Optionally you can pass in a parser rule context which limits the ATN walk to only that or called rules.
     * This can significantly speed up the retrieval process but might miss some candidates (if they are outside of
     * the given context).
     *
     * @param caretTokenIndex The index of the token at the caret position.
     * @param context An option parser rule context to limit the search space.
     * @returns The collection of completion candidates.
     */ collectCandidates(caretTokenIndex, context) {
        this.shortcutMap.clear();
        this.candidates.rules.clear();
        this.candidates.tokens.clear();
        this.statesProcessed = 0;
        this.precedenceStack = [];
        this.tokenStartIndex = context ? context.start.tokenIndex : 0;
        const tokenStream = this.parser.inputStream;
        this.tokens = [];
        let offset = this.tokenStartIndex;
        while(true){
            const token = tokenStream.get(offset++);
            if (token.channel === $jz1xX.Token.DEFAULT_CHANNEL) {
                this.tokens.push(token);
                if (token.tokenIndex >= caretTokenIndex || token.type === $jz1xX.Token.EOF) break;
            }
            // Do not check for the token index here, as we want to end with the first unhidden token on or after
            // the caret.
            if (token.type === $jz1xX.Token.EOF) break;
        }
        const callStack = [];
        const startRule = context ? context.ruleIndex : 0;
        this.processRule(this.atn.ruleToStartState[startRule], 0, callStack, 0, 0);
        if (this.showResult) {
            console.log(`States processed: ${this.statesProcessed}`);
            console.log("\n\nCollected rules:\n");
            for (const rule of this.candidates.rules){
                let path = "";
                for (const token of rule[1].ruleList)path += this.ruleNames[token] + " ";
                console.log(this.ruleNames[rule[0]] + ", path: ", path);
            }
            const sortedTokens = new Set();
            for (const token of this.candidates.tokens){
                let value = this.vocabulary.getDisplayName(token[0]);
                for (const following of token[1])value += " " + this.vocabulary.getDisplayName(following);
                sortedTokens.add(value);
            }
            console.log("\n\nCollected tokens:\n");
            for (const symbol of sortedTokens)console.log(symbol);
            console.log("\n\n");
        }
        return this.candidates;
    }
    /**
     * Checks if the predicate associated with the given transition evaluates to true.
     *
     * @param transition The transition to check.
     * @returns the evaluation result of the predicate.
     */ checkPredicate(transition) {
        return transition.predicate.eval(this.parser, $jz1xX.ParserRuleContext.emptyContext());
    }
    /**
     * Walks the rule chain upwards or downwards (depending on translateRulesTopDown) to see if that matches any of the
     * preferred rules. If found, that rule is added to the collection candidates and true is returned.
     *
     * @param ruleWithStartTokenList The list to convert.
     * @returns true if any of the stack entries was converted.
     */ translateStackToRuleIndex(ruleWithStartTokenList) {
        if (this.preferredRules.size === 0) return false;
        // Change the direction we iterate over the rule stack
        if (this.translateRulesTopDown) // Loop over the rule stack from lowest to highest rule level. This will prioritize a lower preferred rule
        // if it is a child of a higher one that is also a preferred rule.
        for(let i = ruleWithStartTokenList.length - 1; i >= 0; i--){
            if (this.translateToRuleIndex(i, ruleWithStartTokenList)) return true;
        }
        else // Loop over the rule stack from highest to lowest rule level. This will prioritize a higher preferred rule
        // if it contains a lower one that is also a preferred rule.
        for(let i = 0; i < ruleWithStartTokenList.length; i++){
            if (this.translateToRuleIndex(i, ruleWithStartTokenList)) return true;
        }
        return false;
    }
    /**
     * Given the index of a rule from a rule chain, check if that matches any of the preferred rules. If it matches,
     * that rule is added to the collection candidates and true is returned.
     *
     * @param i The rule index.
     * @param ruleWithStartTokenList The list to check.
     * @returns true if the specified rule is in the list of preferred rules.
     */ translateToRuleIndex(i, ruleWithStartTokenList) {
        const { ruleIndex: ruleIndex, startTokenIndex: startTokenIndex } = ruleWithStartTokenList[i];
        if (this.preferredRules.has(ruleIndex)) {
            // Add the rule to our candidates list along with the current rule path,
            // but only if there isn't already an entry like that.
            const path = ruleWithStartTokenList.slice(0, i).map(({ ruleIndex: candidate })=>candidate);
            let addNew = true;
            for (const rule of this.candidates.rules){
                if (rule[0] !== ruleIndex || rule[1].ruleList.length !== path.length) continue;
                // Found an entry for this rule. Same path? If so don't add a new (duplicate) entry.
                if (path.every((v, j)=>v === rule[1].ruleList[j])) {
                    addNew = false;
                    break;
                }
            }
            if (addNew) {
                this.candidates.rules.set(ruleIndex, {
                    startTokenIndex: startTokenIndex,
                    ruleList: path
                });
                if (this.showDebugOutput) console.log("=====> collected: ", this.ruleNames[ruleIndex]);
            }
            return true;
        }
        return false;
    }
    /**
     * This method follows the given transition and collects all symbols within the same rule that directly follow it
     * without intermediate transitions to other rules and only if there is a single symbol for a transition.
     *
     * @param transition The transition from which to start.
     * @returns A list of toke types.
     */ getFollowingTokens(transition) {
        const result = [];
        const pipeline = [
            transition.target
        ];
        while(pipeline.length > 0){
            const state = pipeline.pop();
            if (state) state.getTransitions().forEach((outgoing)=>{
                if (outgoing.serializationType === 5 /* TransitionType.ATOM */ ) {
                    if (!outgoing.isEpsilon) {
                        const list = outgoing.label.toArray();
                        if (list.length === 1 && !this.ignoredTokens.has(list[0])) {
                            result.push(list[0]);
                            pipeline.push(outgoing.target);
                        }
                    } else pipeline.push(outgoing.target);
                }
            });
        }
        return result;
    }
    /**
     * Entry point for the recursive follow set collection function.
     *
     * @param start Start state.
     * @param stop Stop state.
     * @returns Follow sets.
     */ determineFollowSets(start, stop) {
        const sets = [];
        const stateStack = [];
        const ruleStack = [];
        const isExhaustive = this.collectFollowSets(start, stop, sets, stateStack, ruleStack);
        // Sets are split by path to allow translating them to preferred rules. But for quick hit tests
        // it is also useful to have a set with all symbols combined.
        const combined = new $6og9T.IntervalSet();
        for (const set of sets)combined.addAll(set.intervals);
        return {
            sets: sets,
            isExhaustive: isExhaustive,
            combined: combined
        };
    }
    /**
     * Collects possible tokens which could be matched following the given ATN state. This is essentially the same
     * algorithm as used in the LL1Analyzer class, but here we consider predicates also and use no parser rule context.
     *
     * @param s The state to continue from.
     * @param stopState The state which ends the collection routine.
     * @param followSets A pass through parameter to add found sets to.
     * @param stateStack A stack to avoid endless recursions.
     * @param ruleStack The current rule stack.
     * @returns true if the follow sets is exhaustive, i.e. we terminated before the rule end was reached, so no
     * subsequent rules could add tokens
     */ collectFollowSets(s, stopState, followSets, stateStack, ruleStack) {
        if (stateStack.find((x)=>x === s)) return true;
        stateStack.push(s);
        if (s === stopState || s.stateType === $9KX0v.ATNStateType.RULE_STOP) {
            stateStack.pop();
            return false;
        }
        let isExhaustive = true;
        for (const transition of s.getTransitions()){
            if (transition.serializationType === 3 /* TransitionType.RULE */ ) {
                const ruleTransition = transition;
                if (ruleStack.indexOf(ruleTransition.target.ruleIndex) !== -1) continue;
                ruleStack.push(ruleTransition.target.ruleIndex);
                const ruleFollowSetsIsExhaustive = this.collectFollowSets(transition.target, stopState, followSets, stateStack, ruleStack);
                ruleStack.pop();
                // If the subrule had an epsilon transition to the rule end, the tokens added to
                // the follow set are non-exhaustive and we should continue processing subsequent transitions post-rule
                if (!ruleFollowSetsIsExhaustive) {
                    const nextStateFollowSetsIsExhaustive = this.collectFollowSets(ruleTransition.followState, stopState, followSets, stateStack, ruleStack);
                    isExhaustive && (isExhaustive = nextStateFollowSetsIsExhaustive);
                }
            } else if (transition.serializationType === 4 /* TransitionType.PREDICATE */ ) {
                if (this.checkPredicate(transition)) {
                    const nextStateFollowSetsIsExhaustive = this.collectFollowSets(transition.target, stopState, followSets, stateStack, ruleStack);
                    isExhaustive && (isExhaustive = nextStateFollowSetsIsExhaustive);
                }
            } else if (transition.isEpsilon) {
                const nextStateFollowSetsIsExhaustive = this.collectFollowSets(transition.target, stopState, followSets, stateStack, ruleStack);
                isExhaustive && (isExhaustive = nextStateFollowSetsIsExhaustive);
            } else if (transition.serializationType === 9 /* TransitionType.WILDCARD */ ) {
                const set = new $d2b2aef3c19b76bd$var$FollowSetWithPath();
                set.intervals = $6og9T.IntervalSet.of($jz1xX.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType);
                set.path = ruleStack.slice();
                followSets.push(set);
            } else {
                let label = transition.label;
                if (label && label.size > 0) {
                    if (transition.serializationType === 8 /* TransitionType.NOT_SET */ ) label = label.complement($6og9T.IntervalSet.of($jz1xX.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    const set = new $d2b2aef3c19b76bd$var$FollowSetWithPath();
                    set.intervals = label;
                    set.path = ruleStack.slice();
                    set.following = this.getFollowingTokens(transition);
                    followSets.push(set);
                }
            }
        }
        stateStack.pop();
        return isExhaustive;
    }
    /**
     * Walks the ATN for a single rule only. It returns the token stream position for each path that could be matched
     * in this rule.
     * The result can be empty in case we hit only non-epsilon transitions that didn't match the current input or if we
     * hit the caret position.
     *
     * @param startState The start state.
     * @param tokenListIndex The token index we are currently at.
     * @param callStack The stack that indicates where in the ATN we are currently.
     * @param precedence The current precedence level.
     * @param indentation A value to determine the current indentation when doing debug prints.
     * @returns the set of token stream indexes (which depend on the ways that had to be taken).
     */ processRule(startState, tokenListIndex, callStack, precedence, indentation) {
        // Start with rule specific handling before going into the ATN walk.
        // Check first if we've taken this path with the same input before.
        let positionMap = this.shortcutMap.get(startState.ruleIndex);
        if (!positionMap) {
            positionMap = new Map();
            this.shortcutMap.set(startState.ruleIndex, positionMap);
        } else if (positionMap.has(tokenListIndex)) {
            if (this.showDebugOutput) console.log("=====> shortcut");
            return positionMap.get(tokenListIndex);
        }
        const result = new Set();
        // For rule start states we determine and cache the follow set, which gives us 3 advantages:
        // 1) We can quickly check if a symbol would be matched when we follow that rule. We can so check in advance
        //    and can save us all the intermediate steps if there is no match.
        // 2) We'll have all symbols that are collectable already together when we are at the caret on rule enter.
        // 3) We get this lookup for free with any 2nd or further visit of the same rule, which often happens
        //    in non trivial grammars, especially with (recursive) expressions and of course when invoking code
        //    completion multiple times.
        let setsPerState = $d2b2aef3c19b76bd$var$CodeCompletionCore.followSetsByATN.get(this.parser.constructor.name);
        if (!setsPerState) {
            setsPerState = new Map();
            $d2b2aef3c19b76bd$var$CodeCompletionCore.followSetsByATN.set(this.parser.constructor.name, setsPerState);
        }
        let followSets = setsPerState.get(startState.stateNumber);
        if (!followSets) {
            const stop = this.atn.ruleToStopState[startState.ruleIndex];
            followSets = this.determineFollowSets(startState, stop);
            setsPerState.set(startState.stateNumber, followSets);
        }
        // Get the token index where our rule starts from our (possibly filtered) token list
        const startTokenIndex = this.tokens[tokenListIndex].tokenIndex;
        callStack.push({
            startTokenIndex: startTokenIndex,
            ruleIndex: startState.ruleIndex
        });
        if (tokenListIndex >= this.tokens.length - 1) {
            if (this.preferredRules.has(startState.ruleIndex)) // No need to go deeper when collecting entries and we reach a rule that we want to collect anyway.
            this.translateStackToRuleIndex(callStack);
            else // Convert all follow sets to either single symbols or their associated preferred rule and add
            // the result to our candidates list.
            for (const set of followSets.sets){
                const fullPath = callStack.slice();
                // Rules derived from our followSet will always start at the same token as our current rule
                const followSetPath = set.path.map((path)=>({
                        startTokenIndex: startTokenIndex,
                        ruleIndex: path
                    }));
                fullPath.push(...followSetPath);
                if (!this.translateStackToRuleIndex(fullPath)) {
                    for (const symbol of set.intervals.toArray())if (!this.ignoredTokens.has(symbol)) {
                        if (this.showDebugOutput) console.log("=====> collected: ", this.vocabulary.getDisplayName(symbol));
                        if (!this.candidates.tokens.has(symbol)) // Following is empty if there is more than one entry in the set.
                        this.candidates.tokens.set(symbol, set.following);
                        else // More than one following list for the same symbol.
                        if (this.candidates.tokens.get(symbol) !== set.following) this.candidates.tokens.set(symbol, []);
                    }
                }
            }
            if (!followSets.isExhaustive) // If we're at the caret but the follow sets is non-exhaustive (empty or all tokens are optional),
            // we should continue to collect tokens following this rule
            result.add(tokenListIndex);
            callStack.pop();
            return result;
        } else {
            // Process the rule if we either could pass it without consuming anything (epsilon transition)
            // or if the current input symbol will be matched somewhere after this entry point.
            // Otherwise stop here.
            const currentSymbol = this.tokens[tokenListIndex].type;
            if (followSets.isExhaustive && !followSets.combined.contains(currentSymbol)) {
                callStack.pop();
                return result;
            }
        }
        if (startState.isPrecedenceRule) this.precedenceStack.push(precedence);
        // The current state execution pipeline contains all yet-to-be-processed ATN states in this rule.
        // For each such state we store the token index + a list of rules that lead to it.
        const statePipeline = [];
        let currentEntry;
        // Bootstrap the pipeline.
        statePipeline.push({
            state: startState,
            tokenListIndex: tokenListIndex
        });
        while(statePipeline.length > 0){
            currentEntry = statePipeline.pop();
            ++this.statesProcessed;
            const currentSymbol = this.tokens[currentEntry.tokenListIndex].type;
            const atCaret = currentEntry.tokenListIndex >= this.tokens.length - 1;
            if (this.showDebugOutput) {
                this.printDescription(indentation, currentEntry.state, this.generateBaseDescription(currentEntry.state), currentEntry.tokenListIndex);
                if (this.showRuleStack) this.printRuleState(callStack);
            }
            if (currentEntry.state.stateType === $9KX0v.ATNStateType.RULE_STOP) {
                // Record the token index we are at, to report it to the caller.
                result.add(currentEntry.tokenListIndex);
                continue;
            }
            const transitions = currentEntry.state.getTransitions();
            // We simulate here the same precedence handling as the parser does, which uses hard coded values.
            // For rules that are not left recursive this value is ignored (since there is no precedence transition).
            for (const transition of transitions)switch(transition.serializationType){
                case 3 /* TransitionType.RULE */ :
                    {
                        const ruleTransition = transition;
                        const endStatus = this.processRule(transition.target, currentEntry.tokenListIndex, callStack, ruleTransition.precedence, indentation + 1);
                        for (const position of endStatus)statePipeline.push({
                            state: transition.followState,
                            tokenListIndex: position
                        });
                        break;
                    }
                case 4 /* TransitionType.PREDICATE */ :
                    if (this.checkPredicate(transition)) statePipeline.push({
                        state: transition.target,
                        tokenListIndex: currentEntry.tokenListIndex
                    });
                    break;
                case 10 /* TransitionType.PRECEDENCE */ :
                    {
                        const predTransition = transition;
                        if (predTransition.precedence >= this.precedenceStack[this.precedenceStack.length - 1]) statePipeline.push({
                            state: transition.target,
                            tokenListIndex: currentEntry.tokenListIndex
                        });
                        break;
                    }
                case 9 /* TransitionType.WILDCARD */ :
                    if (atCaret) {
                        if (!this.translateStackToRuleIndex(callStack)) {
                            for (const token of $6og9T.IntervalSet.of($jz1xX.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType).toArray())if (!this.ignoredTokens.has(token)) this.candidates.tokens.set(token, []);
                        }
                    } else statePipeline.push({
                        state: transition.target,
                        tokenListIndex: currentEntry.tokenListIndex + 1
                    });
                    break;
                default:
                    {
                        if (transition.isEpsilon) {
                            // Jump over simple states with a single outgoing epsilon transition.
                            statePipeline.push({
                                state: transition.target,
                                tokenListIndex: currentEntry.tokenListIndex
                            });
                            continue;
                        }
                        let set = transition.label;
                        if (set && set.size > 0) {
                            if (transition.serializationType === 8 /* TransitionType.NOT_SET */ ) set = set.complement($6og9T.IntervalSet.of($jz1xX.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                            if (atCaret) {
                                if (!this.translateStackToRuleIndex(callStack)) {
                                    const list = set.toArray();
                                    const addFollowing = list.length === 1;
                                    for (const symbol of list)if (!this.ignoredTokens.has(symbol)) {
                                        if (this.showDebugOutput) console.log("=====> collected: ", this.vocabulary.getDisplayName(symbol));
                                        if (addFollowing) this.candidates.tokens.set(symbol, this.getFollowingTokens(transition));
                                        else this.candidates.tokens.set(symbol, []);
                                    }
                                }
                            } else if (set.contains(currentSymbol)) {
                                if (this.showDebugOutput) console.log("=====> consumed: ", this.vocabulary.getDisplayName(currentSymbol));
                                statePipeline.push({
                                    state: transition.target,
                                    tokenListIndex: currentEntry.tokenListIndex + 1
                                });
                            }
                        }
                    }
            }
        }
        callStack.pop();
        if (startState.isPrecedenceRule) this.precedenceStack.pop();
        // Cache the result, for later lookup to avoid duplicate walks.
        positionMap.set(tokenListIndex, result);
        return result;
    }
    generateBaseDescription(state) {
        const stateValue = state.stateNumber === $9KX0v.ATNState.INVALID_STATE_NUMBER ? "Invalid" : state.stateNumber;
        return `[${stateValue} ${$d2b2aef3c19b76bd$var$CodeCompletionCore.atnStateTypeMap[state.stateType]}] in ` + `${this.ruleNames[state.ruleIndex]}`;
    }
    printDescription(indentation, state, baseDescription, tokenIndex) {
        const indent = "  ".repeat(indentation);
        let output = indent;
        let transitionDescription = "";
        if (this.debugOutputWithTransitions) for (const transition of state.getTransitions()){
            let labels = "";
            const symbols = transition.label ? transition.label.toArray() : [];
            if (symbols.length > 2) // Only print start and end symbols to avoid large lists in debug output.
            labels = this.vocabulary.getDisplayName(symbols[0]) + " .. " + this.vocabulary.getDisplayName(symbols[symbols.length - 1]);
            else for (const symbol of symbols){
                if (labels.length > 0) labels += ", ";
                labels += this.vocabulary.getDisplayName(symbol);
            }
            if (labels.length === 0) labels = "\u03B5";
            transitionDescription += `\n${indent}\t(${labels}) [${transition.target.stateNumber} ` + `${$d2b2aef3c19b76bd$var$CodeCompletionCore.atnStateTypeMap[transition.target.stateType]}] in ` + `${this.ruleNames[transition.target.ruleIndex]}`;
        }
        if (tokenIndex >= this.tokens.length - 1) output += `<<${this.tokenStartIndex + tokenIndex}>> `;
        else output += `<${this.tokenStartIndex + tokenIndex}> `;
        console.log(output + "Current state: " + baseDescription + transitionDescription);
    }
    printRuleState(stack) {
        if (stack.length === 0) {
            console.log("<empty stack>");
            return;
        }
        for (const rule of stack)console.log(this.ruleNames[rule.ruleIndex]);
    }
}
$d2b2aef3c19b76bd$var$CodeCompletionCore.followSetsByATN = new Map();
$d2b2aef3c19b76bd$var$CodeCompletionCore.atnStateTypeMap = [
    "invalid",
    "basic",
    "rule start",
    "block start",
    "plus block start",
    "star block start",
    "token start",
    "rule stop",
    "block end",
    "star loop back",
    "star loop entry",
    "plus loop back",
    "loop end"
];
module.exports.CodeCompletionCore = $d2b2aef3c19b76bd$var$CodeCompletionCore;

});
parcelRegister("9KX0v", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $71a62e81cdab243f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $71a62e81cdab243f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $71a62e81cdab243f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$71a62e81cdab243f$var$__exportStar((parcelRequire("5sT1a")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("9elhd")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("kW9dT")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("lDQMG")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("9qlOq")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("6co2U")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("cYBtK")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("es7AZ")), module.exports);

// export * from "./ATNSerializer";
$71a62e81cdab243f$var$__exportStar((parcelRequire("lbAqv")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("17Oz4")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("9TBHo")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("6TKXw")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("elgsv")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("6Wwgi")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("aTslC")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("h0Oxm")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("fqwBK")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("doVqF")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("3AFtK")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("jQFYZ")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("jCDlF")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("3wiS8")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("axZym")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("4t2Am")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("5aiBr")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("2xNwj")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("aVhMe")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("khqMx")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("difGA")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("kkkg9")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("lAw71")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("hinaj")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("hv3tp")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("jWb5l")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("ermyP")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("lPekc")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("i50Cm")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("8OGST")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("j6qbp")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("en89P")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("itw6a")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("3fYXW")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("grncH")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("jjTpW")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("bYNsJ")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("l4uOS")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("j2EBs")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("6U6Db")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("l5c3t")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("9gMj2")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("dlxNc")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("haz8F")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("8Uwhy")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("2cmeG")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("8rjeX")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("evTXr")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("54SKF")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("U6v4o")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("acKOx")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("8DW9a")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("4mzjd")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("fO6gt")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("aj3zV")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("cLQen")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("izkyd")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("c0QqZ")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("i2NOt")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("9bmP2")), module.exports);

$71a62e81cdab243f$var$__exportStar((parcelRequire("4EBHJ")), module.exports);

});
parcelRegister("kW9dT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f3e060f6b5c851bb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f3e060f6b5c851bb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AmbiguityInfo = void 0;

var $jCDlF = parcelRequire("jCDlF");

var $esDFm = parcelRequire("esDFm");
/**
 * This class represents profiling event information for an ambiguity.
 * Ambiguities are decisions where a particular input resulted in an SLL
 * conflict, followed by LL prediction also reaching a conflict state
 * (indicating a true ambiguity in the grammar).
 *
 * This event may be reported during SLL prediction in cases where the
 * conflicting SLL configuration set provides sufficient information to
 * determine that the SLL conflict is truly an ambiguity. For example, if none
 * of the ATN configurations in the conflicting SLL configuration set have
 * traversed a global follow transition (i.e.
 * {@link ATNConfig#getReachesIntoOuterContext} is `false` for all
 * configurations), then the result of SLL prediction for that input is known to
 * be equivalent to the result of LL prediction for that input.
 *
 * In some cases, the minimum represented alternative in the conflicting LL
 * configuration set is not equal to the minimum represented alternative in the
 * conflicting SLL configuration set. Grammars and inputs which result in this
 * scenario are unable to use {@link PredictionMode#SLL}, which in turn means
 * they cannot use the two-stage parsing strategy to improve parsing performance
 * for that input.
 *
 * @see ParserATNSimulator#reportAmbiguity
 * @see ParserErrorListener#reportAmbiguity
 *
 * @since 4.3
 */ let $f3e060f6b5c851bb$var$AmbiguityInfo = class AmbiguityInfo extends $jCDlF.DecisionEventInfo {
    /**
     * Constructs a new instance of the {@link AmbiguityInfo} class with the
     * specified detailed ambiguity information.
     *
     * @param decision The decision number
     * @param state The final simulator state identifying the ambiguous
     * alternatives for the current input
     * @param ambigAlts The set of alternatives in the decision that lead to a valid parse.
     *                  The predicted alt is the min(ambigAlts)
     * @param input The input token stream
     * @param startIndex The start index for the current prediction
     * @param stopIndex The index at which the ambiguity was identified during
     * prediction
     */ constructor(decision, state, ambigAlts, input, startIndex, stopIndex){
        super(decision, state, input, startIndex, stopIndex, state.useContext);
        this.ambigAlts = ambigAlts;
    }
    /**
     * Gets the set of alternatives in the decision that lead to a valid parse.
     *
     * @since 4.5
     */ get ambiguousAlternatives() {
        return this.ambigAlts;
    }
};
$f3e060f6b5c851bb$var$__decorate([
    $esDFm.NotNull
], $f3e060f6b5c851bb$var$AmbiguityInfo.prototype, "ambigAlts", void 0);
$f3e060f6b5c851bb$var$__decorate([
    $esDFm.NotNull
], $f3e060f6b5c851bb$var$AmbiguityInfo.prototype, "ambiguousAlternatives", null);
$f3e060f6b5c851bb$var$AmbiguityInfo = $f3e060f6b5c851bb$var$__decorate([
    $f3e060f6b5c851bb$var$__param(1, $esDFm.NotNull),
    $f3e060f6b5c851bb$var$__param(2, $esDFm.NotNull),
    $f3e060f6b5c851bb$var$__param(3, $esDFm.NotNull)
], $f3e060f6b5c851bb$var$AmbiguityInfo);
module.exports.AmbiguityInfo = $f3e060f6b5c851bb$var$AmbiguityInfo;

});
parcelRegister("jCDlF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e49016b85c615f63$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e49016b85c615f63$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionEventInfo = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This is the base class for gathering detailed information about prediction
 * events which occur during parsing.
 *
 * Note that we could record the parser call stack at the time this event
 * occurred but in the presence of left recursive rules, the stack is kind of
 * meaningless. It's better to look at the individual configurations for their
 * individual stacks. Of course that is a {@link PredictionContext} object
 * not a parse tree node and so it does not have information about the extent
 * (start...stop) of the various subtrees. Examining the stack tops of all
 * configurations provide the return states for the rule invocations.
 * From there you can get the enclosing rule.
 *
 * @since 4.3
 */ let $e49016b85c615f63$var$DecisionEventInfo = class DecisionEventInfo {
    constructor(decision, state, input, startIndex, stopIndex, fullCtx){
        this.decision = decision;
        this.fullCtx = fullCtx;
        this.stopIndex = stopIndex;
        this.input = input;
        this.startIndex = startIndex;
        this.state = state;
    }
};
$e49016b85c615f63$var$__decorate([
    $esDFm.NotNull
], $e49016b85c615f63$var$DecisionEventInfo.prototype, "input", void 0);
$e49016b85c615f63$var$DecisionEventInfo = $e49016b85c615f63$var$__decorate([
    $e49016b85c615f63$var$__param(2, $esDFm.NotNull)
], $e49016b85c615f63$var$DecisionEventInfo);
module.exports.DecisionEventInfo = $e49016b85c615f63$var$DecisionEventInfo;

});


parcelRegister("6TKXw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.6094030-07:00
/**
 * Represents the type of recognizer an ATN applies to.
 *
 * @author Sam Harwell
 */ var $505c4e335e45adb4$var$ATNType;
(function(ATNType) {
    /**
     * A lexer grammar.
     */ ATNType[ATNType["LEXER"] = 0] = "LEXER";
    /**
     * A parser grammar.
     */ ATNType[ATNType["PARSER"] = 1] = "PARSER";
})($505c4e335e45adb4$var$ATNType = module.exports.ATNType || (module.exports.ATNType = {}));

});

parcelRegister("doVqF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createWithCodePointRange = module.exports.createWithCodePoint = void 0;

var $eIoqK = parcelRequire("eIoqK");

var $elgsv = parcelRequire("elgsv");

var $6og9T = parcelRequire("6og9T");

var $evTXr = parcelRequire("evTXr");

var $4mzjd = parcelRequire("4mzjd");
/**
 * Utility functions to create {@link AtomTransition}, {@link RangeTransition},
 * and {@link SetTransition} appropriately based on the range of the input.
 *
 * To keep the serialized ATN size small, we only inline atom and
 * range transitions for Unicode code points <= U+FFFF.
 *
 * Whenever we encounter a Unicode code point > U+FFFF, we represent that
 * as a set transition (even if it is logically an atom or a range).
 */ /**
 * If {@code codePoint} is <= U+FFFF, returns a new {@link AtomTransition}.
 * Otherwise, returns a new {@link SetTransition}.
 */ function $9c1a1076e4e29c7c$var$createWithCodePoint(target, codePoint) {
    if ($eIoqK.isSupplementaryCodePoint(codePoint)) return new $4mzjd.SetTransition(target, $6og9T.IntervalSet.of(codePoint));
    else return new $elgsv.AtomTransition(target, codePoint);
}
module.exports.createWithCodePoint = $9c1a1076e4e29c7c$var$createWithCodePoint;
/**
 * If {@code codePointFrom} and {@code codePointTo} are both
 * <= U+FFFF, returns a new {@link RangeTransition}.
 * Otherwise, returns a new {@link SetTransition}.
 */ function $9c1a1076e4e29c7c$var$createWithCodePointRange(target, codePointFrom, codePointTo) {
    if ($eIoqK.isSupplementaryCodePoint(codePointFrom) || $eIoqK.isSupplementaryCodePoint(codePointTo)) return new $4mzjd.SetTransition(target, $6og9T.IntervalSet.of(codePointFrom, codePointTo));
    else return new $evTXr.RangeTransition(target, codePointFrom, codePointTo);
}
module.exports.createWithCodePointRange = $9c1a1076e4e29c7c$var$createWithCodePointRange;

});

parcelRegister("jQFYZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e733708c9b49980a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e733708c9b49980a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextSensitivityInfo = void 0;

var $jCDlF = parcelRequire("jCDlF");

var $esDFm = parcelRequire("esDFm");
/**
 * This class represents profiling event information for a context sensitivity.
 * Context sensitivities are decisions where a particular input resulted in an
 * SLL conflict, but LL prediction produced a single unique alternative.
 *
 * In some cases, the unique alternative identified by LL prediction is not
 * equal to the minimum represented alternative in the conflicting SLL
 * configuration set. Grammars and inputs which result in this scenario are
 * unable to use {@link PredictionMode#SLL}, which in turn means they cannot use
 * the two-stage parsing strategy to improve parsing performance for that
 * input.
 *
 * @see ParserATNSimulator#reportContextSensitivity
 * @see ParserErrorListener#reportContextSensitivity
 *
 * @since 4.3
 */ let $e733708c9b49980a$var$ContextSensitivityInfo = class ContextSensitivityInfo extends $jCDlF.DecisionEventInfo {
    /**
     * Constructs a new instance of the {@link ContextSensitivityInfo} class
     * with the specified detailed context sensitivity information.
     *
     * @param decision The decision number
     * @param state The final simulator state containing the unique
     * alternative identified by full-context prediction
     * @param input The input token stream
     * @param startIndex The start index for the current prediction
     * @param stopIndex The index at which the context sensitivity was
     * identified during full-context prediction
     */ constructor(decision, state, input, startIndex, stopIndex){
        super(decision, state, input, startIndex, stopIndex, true);
    }
};
$e733708c9b49980a$var$ContextSensitivityInfo = $e733708c9b49980a$var$__decorate([
    $e733708c9b49980a$var$__param(1, $esDFm.NotNull),
    $e733708c9b49980a$var$__param(2, $esDFm.NotNull)
], $e733708c9b49980a$var$ContextSensitivityInfo);
module.exports.ContextSensitivityInfo = $e733708c9b49980a$var$ContextSensitivityInfo;

});

parcelRegister("3wiS8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2902ffdf7ed01a07$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionInfo = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This class contains profiling gathered for a particular decision.
 *
 * Parsing performance in ANTLR 4 is heavily influenced by both static factors
 * (e.g. the form of the rules in the grammar) and dynamic factors (e.g. the
 * choice of input and the state of the DFA cache at the time profiling
 * operations are started). For best results, gather and use aggregate
 * statistics from a large sample of inputs representing the inputs expected in
 * production before using the results to make changes in the grammar.
 *
 * @since 4.3
 */ class $2902ffdf7ed01a07$var$DecisionInfo {
    /**
     * Constructs a new instance of the {@link DecisionInfo} class to contain
     * statistics for a particular decision.
     *
     * @param decision The decision number
     */ constructor(decision){
        /**
         * The total number of times {@link ParserATNSimulator#adaptivePredict} was
         * invoked for this decision.
         */ this.invocations = 0;
        /**
         * The total time spent in {@link ParserATNSimulator#adaptivePredict} for
         * this decision, in nanoseconds.
         *
         * The value of this field contains the sum of differential results obtained
         * by {@link System#nanoTime()}, and is not adjusted to compensate for JIT
         * and/or garbage collection overhead. For best accuracy, use a modern JVM
         * implementation that provides precise results from
         * {@link System#nanoTime()}, and perform profiling in a separate process
         * which is warmed up by parsing the input prior to profiling. If desired,
         * call {@link ATNSimulator#clearDFA} to reset the DFA cache to its initial
         * state before starting the profiling measurement pass.
         */ this.timeInPrediction = 0;
        /**
         * The sum of the lookahead required for SLL prediction for this decision.
         * Note that SLL prediction is used before LL prediction for performance
         * reasons even when {@link PredictionMode#LL} or
         * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} is used.
         */ this.SLL_TotalLook = 0;
        /**
         * Gets the minimum lookahead required for any single SLL prediction to
         * complete for this decision, by reaching a unique prediction, reaching an
         * SLL conflict state, or encountering a syntax error.
         */ this.SLL_MinLook = 0;
        /**
         * Gets the maximum lookahead required for any single SLL prediction to
         * complete for this decision, by reaching a unique prediction, reaching an
         * SLL conflict state, or encountering a syntax error.
         */ this.SLL_MaxLook = 0;
        /**
         * The sum of the lookahead required for LL prediction for this decision.
         * Note that LL prediction is only used when SLL prediction reaches a
         * conflict state.
         */ this.LL_TotalLook = 0;
        /**
         * Gets the minimum lookahead required for any single LL prediction to
         * complete for this decision. An LL prediction completes when the algorithm
         * reaches a unique prediction, a conflict state (for
         * {@link PredictionMode#LL}, an ambiguity state (for
         * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}, or a syntax error.
         */ this.LL_MinLook = 0;
        /**
         * Gets the maximum lookahead required for any single LL prediction to
         * complete for this decision. An LL prediction completes when the algorithm
         * reaches a unique prediction, a conflict state (for
         * {@link PredictionMode#LL}, an ambiguity state (for
         * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}, or a syntax error.
         */ this.LL_MaxLook = 0;
        /**
         * A collection of {@link ContextSensitivityInfo} instances describing the
         * context sensitivities encountered during LL prediction for this decision.
         *
         * @see ContextSensitivityInfo
         */ this.contextSensitivities = [];
        /**
         * A collection of {@link ErrorInfo} instances describing the parse errors
         * identified during calls to {@link ParserATNSimulator#adaptivePredict} for
         * this decision.
         *
         * @see ErrorInfo
         */ this.errors = [];
        /**
         * A collection of {@link AmbiguityInfo} instances describing the
         * ambiguities encountered during LL prediction for this decision.
         *
         * @see AmbiguityInfo
         */ this.ambiguities = [];
        /**
         * A collection of {@link PredicateEvalInfo} instances describing the
         * results of evaluating individual predicates during prediction for this
         * decision.
         *
         * @see PredicateEvalInfo
         */ this.predicateEvals = [];
        /**
         * The total number of ATN transitions required during SLL prediction for
         * this decision. An ATN transition is determined by the number of times the
         * DFA does not contain an edge that is required for prediction, resulting
         * in on-the-fly computation of that edge.
         *
         * If DFA caching of SLL transitions is employed by the implementation, ATN
         * computation may cache the computed edge for efficient lookup during
         * future parsing of this decision. Otherwise, the SLL parsing algorithm
         * will use ATN transitions exclusively.
         *
         * @see #SLL_ATNTransitions
         * @see ParserATNSimulator#computeTargetState
         * @see LexerATNSimulator#computeTargetState
         */ this.SLL_ATNTransitions = 0;
        /**
         * The total number of DFA transitions required during SLL prediction for
         * this decision.
         *
         * If the ATN simulator implementation does not use DFA caching for SLL
         * transitions, this value will be 0.
         *
         * @see ParserATNSimulator#getExistingTargetState
         * @see LexerATNSimulator#getExistingTargetState
         */ this.SLL_DFATransitions = 0;
        /**
         * Gets the total number of times SLL prediction completed in a conflict
         * state, resulting in fallback to LL prediction.
         *
         * Note that this value is not related to whether or not
         * {@link PredictionMode#SLL} may be used successfully with a particular
         * grammar. If the ambiguity resolution algorithm applied to the SLL
         * conflicts for this decision produce the same result as LL prediction for
         * this decision, {@link PredictionMode#SLL} would produce the same overall
         * parsing result as {@link PredictionMode#LL}.
         */ this.LL_Fallback = 0;
        /**
         * The total number of ATN transitions required during LL prediction for
         * this decision. An ATN transition is determined by the number of times the
         * DFA does not contain an edge that is required for prediction, resulting
         * in on-the-fly computation of that edge.
         *
         * If DFA caching of LL transitions is employed by the implementation, ATN
         * computation may cache the computed edge for efficient lookup during
         * future parsing of this decision. Otherwise, the LL parsing algorithm will
         * use ATN transitions exclusively.
         *
         * @see #LL_DFATransitions
         * @see ParserATNSimulator#computeTargetState
         * @see LexerATNSimulator#computeTargetState
         */ this.LL_ATNTransitions = 0;
        /**
         * The total number of DFA transitions required during LL prediction for
         * this decision.
         *
         * If the ATN simulator implementation does not use DFA caching for LL
         * transitions, this value will be 0.
         *
         * @see ParserATNSimulator#getExistingTargetState
         * @see LexerATNSimulator#getExistingTargetState
         */ this.LL_DFATransitions = 0;
        this.decision = decision;
    }
    toString() {
        return "{decision=" + this.decision + ", contextSensitivities=" + this.contextSensitivities.length + ", errors=" + this.errors.length + ", ambiguities=" + this.ambiguities.length + ", SLL_lookahead=" + this.SLL_TotalLook + ", SLL_ATNTransitions=" + this.SLL_ATNTransitions + ", SLL_DFATransitions=" + this.SLL_DFATransitions + ", LL_Fallback=" + this.LL_Fallback + ", LL_lookahead=" + this.LL_TotalLook + ", LL_ATNTransitions=" + this.LL_ATNTransitions + "}";
    }
}
$2902ffdf7ed01a07$var$__decorate([
    $esDFm.Override
], $2902ffdf7ed01a07$var$DecisionInfo.prototype, "toString", null);
module.exports.DecisionInfo = $2902ffdf7ed01a07$var$DecisionInfo;

});

parcelRegister("5aiBr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3c2c5111db0c2f15$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3c2c5111db0c2f15$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorInfo = void 0;

var $jCDlF = parcelRequire("jCDlF");

var $esDFm = parcelRequire("esDFm");
/**
 * This class represents profiling event information for a syntax error
 * identified during prediction. Syntax errors occur when the prediction
 * algorithm is unable to identify an alternative which would lead to a
 * successful parse.
 *
 * @see Parser#notifyErrorListeners(Token, String, RecognitionException)
 * @see ANTLRErrorListener#syntaxError
 *
 * @since 4.3
 */ let $3c2c5111db0c2f15$var$ErrorInfo = class ErrorInfo extends $jCDlF.DecisionEventInfo {
    /**
     * Constructs a new instance of the {@link ErrorInfo} class with the
     * specified detailed syntax error information.
     *
     * @param decision The decision number
     * @param state The final simulator state reached during prediction
     * prior to reaching the {@link ATNSimulator#ERROR} state
     * @param input The input token stream
     * @param startIndex The start index for the current prediction
     * @param stopIndex The index at which the syntax error was identified
     */ constructor(decision, state, input, startIndex, stopIndex){
        super(decision, state, input, startIndex, stopIndex, state.useContext);
    }
};
$3c2c5111db0c2f15$var$ErrorInfo = $3c2c5111db0c2f15$var$__decorate([
    $3c2c5111db0c2f15$var$__param(1, $esDFm.NotNull),
    $3c2c5111db0c2f15$var$__param(2, $esDFm.NotNull)
], $3c2c5111db0c2f15$var$ErrorInfo);
module.exports.ErrorInfo = $3c2c5111db0c2f15$var$ErrorInfo;

});

parcelRegister("aVhMe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("difGA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:29.0172086-07:00
/**
 * Represents the serialization type of a {@link LexerAction}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ var $9ad91fac966ab038$var$LexerActionType;
(function(LexerActionType) {
    /**
     * The type of a {@link LexerChannelAction} action.
     */ LexerActionType[LexerActionType["CHANNEL"] = 0] = "CHANNEL";
    /**
     * The type of a {@link LexerCustomAction} action.
     */ LexerActionType[LexerActionType["CUSTOM"] = 1] = "CUSTOM";
    /**
     * The type of a {@link LexerModeAction} action.
     */ LexerActionType[LexerActionType["MODE"] = 2] = "MODE";
    /**
     * The type of a {@link LexerMoreAction} action.
     */ LexerActionType[LexerActionType["MORE"] = 3] = "MORE";
    /**
     * The type of a {@link LexerPopModeAction} action.
     */ LexerActionType[LexerActionType["POP_MODE"] = 4] = "POP_MODE";
    /**
     * The type of a {@link LexerPushModeAction} action.
     */ LexerActionType[LexerActionType["PUSH_MODE"] = 5] = "PUSH_MODE";
    /**
     * The type of a {@link LexerSkipAction} action.
     */ LexerActionType[LexerActionType["SKIP"] = 6] = "SKIP";
    /**
     * The type of a {@link LexerTypeAction} action.
     */ LexerActionType[LexerActionType["TYPE"] = 7] = "TYPE";
})($9ad91fac966ab038$var$LexerActionType = module.exports.LexerActionType || (module.exports.LexerActionType = {}));

});

parcelRegister("itw6a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d733d589c385b6aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d733d589c385b6aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookaheadEventInfo = void 0;

var $jCDlF = parcelRequire("jCDlF");

var $esDFm = parcelRequire("esDFm");
/**
 * This class represents profiling event information for tracking the lookahead
 * depth required in order to make a prediction.
 *
 * @since 4.3
 */ let $d733d589c385b6aa$var$LookaheadEventInfo = class LookaheadEventInfo extends $jCDlF.DecisionEventInfo {
    /**
     * Constructs a new instance of the {@link LookaheadEventInfo} class with
     * the specified detailed lookahead information.
     *
     * @param decision The decision number
     * @param state The final simulator state containing the necessary
     * information to determine the result of a prediction, or `undefined` if
     * the final state is not available
     * @param input The input token stream
     * @param startIndex The start index for the current prediction
     * @param stopIndex The index at which the prediction was finally made
     * @param fullCtx `true` if the current lookahead is part of an LL
     * prediction; otherwise, `false` if the current lookahead is part of
     * an SLL prediction
     */ constructor(decision, state, predictedAlt, input, startIndex, stopIndex, fullCtx){
        super(decision, state, input, startIndex, stopIndex, fullCtx);
        this.predictedAlt = predictedAlt;
    }
};
$d733d589c385b6aa$var$LookaheadEventInfo = $d733d589c385b6aa$var$__decorate([
    $d733d589c385b6aa$var$__param(3, $esDFm.NotNull)
], $d733d589c385b6aa$var$LookaheadEventInfo);
module.exports.LookaheadEventInfo = $d733d589c385b6aa$var$LookaheadEventInfo;

});

parcelRegister("9gMj2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6bfb144822a52577$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6bfb144822a52577$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateEvalInfo = void 0;

var $jCDlF = parcelRequire("jCDlF");

var $esDFm = parcelRequire("esDFm");
/**
 * This class represents profiling event information for semantic predicate
 * evaluations which occur during prediction.
 *
 * @see ParserATNSimulator#evalSemanticContext
 *
 * @since 4.3
 */ let $6bfb144822a52577$var$PredicateEvalInfo = class PredicateEvalInfo extends $jCDlF.DecisionEventInfo {
    /**
     * Constructs a new instance of the {@link PredicateEvalInfo} class with the
     * specified detailed predicate evaluation information.
     *
     * @param state The simulator state
     * @param decision The decision number
     * @param input The input token stream
     * @param startIndex The start index for the current prediction
     * @param stopIndex The index at which the predicate evaluation was
     * triggered. Note that the input stream may be reset to other positions for
     * the actual evaluation of individual predicates.
     * @param semctx The semantic context which was evaluated
     * @param evalResult The results of evaluating the semantic context
     * @param predictedAlt The alternative number for the decision which is
     * guarded by the semantic context `semctx`. See {@link #predictedAlt}
     * for more information.
     *
     * @see ParserATNSimulator#evalSemanticContext(SemanticContext, ParserRuleContext, int)
     * @see SemanticContext#eval(Recognizer, RuleContext)
     */ constructor(state, decision, input, startIndex, stopIndex, semctx, evalResult, predictedAlt){
        super(decision, state, input, startIndex, stopIndex, state.useContext);
        this.semctx = semctx;
        this.evalResult = evalResult;
        this.predictedAlt = predictedAlt;
    }
};
$6bfb144822a52577$var$PredicateEvalInfo = $6bfb144822a52577$var$__decorate([
    $6bfb144822a52577$var$__param(0, $esDFm.NotNull),
    $6bfb144822a52577$var$__param(2, $esDFm.NotNull),
    $6bfb144822a52577$var$__param(5, $esDFm.NotNull)
], $6bfb144822a52577$var$PredicateEvalInfo);
module.exports.PredicateEvalInfo = $6bfb144822a52577$var$PredicateEvalInfo;

});

parcelRegister("8rjeX", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $624fc50ef64f8083$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $624fc50ef64f8083$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfilingATNSimulator = void 0;

var $kW9dT = parcelRequire("kW9dT");

var $lDQMG = parcelRequire("lDQMG");

var $lbAqv = parcelRequire("lbAqv");

var $jQFYZ = parcelRequire("jQFYZ");

var $3wiS8 = parcelRequire("3wiS8");

var $5aiBr = parcelRequire("5aiBr");

var $esDFm = parcelRequire("esDFm");

var $itw6a = parcelRequire("itw6a");

var $l4uOS = parcelRequire("l4uOS");

var $9gMj2 = parcelRequire("9gMj2");

var $8DW9a = parcelRequire("8DW9a");

var $fO6gt = parcelRequire("fO6gt");
/**
 * @since 4.3
 */ class $624fc50ef64f8083$var$ProfilingATNSimulator extends $l4uOS.ParserATNSimulator {
    constructor(parser){
        super(parser.interpreter.atn, parser);
        this._startIndex = 0;
        this._sllStopIndex = 0;
        this._llStopIndex = 0;
        this.currentDecision = 0;
        /** At the point of LL failover, we record how SLL would resolve the conflict so that
         *  we can determine whether or not a decision / input pair is context-sensitive.
         *  If LL gives a different result than SLL's predicted alternative, we have a
         *  context sensitivity for sure. The converse is not necessarily true, however.
         *  It's possible that after conflict resolution chooses minimum alternatives,
         *  SLL could get the same answer as LL. Regardless of whether or not the result indicates
         *  an ambiguity, it is not treated as a context sensitivity because LL prediction
         *  was not required in order to produce a correct prediction for this decision and input sequence.
         *  It may in fact still be a context sensitivity but we don't know by looking at the
         *  minimum alternatives for the current input.
         */ this.conflictingAltResolvedBySLL = 0;
        this.optimize_ll1 = false;
        this.reportAmbiguities = true;
        this.numDecisions = this.atn.decisionToState.length;
        this.decisions = [];
        for(let i = 0; i < this.numDecisions; i++)this.decisions.push(new $3wiS8.DecisionInfo(i));
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext !== undefined) return super.adaptivePredict(input, decision, outerContext, useContext);
        try {
            this._input = input;
            this._startIndex = input.index;
            // it's possible for SLL to reach a conflict state without consuming any input
            this._sllStopIndex = this._startIndex - 1;
            this._llStopIndex = -1;
            this.currentDecision = decision;
            this.currentState = undefined;
            this.conflictingAltResolvedBySLL = $lDQMG.ATN.INVALID_ALT_NUMBER;
            let start = $igDjg.hrtime();
            let alt = super.adaptivePredict(input, decision, outerContext);
            let stop = $igDjg.hrtime();
            let nanoseconds = (stop[0] - start[0]) * 1000000000;
            if (nanoseconds === 0) nanoseconds = stop[1] - start[1];
            else // Add nanoseconds from start to end of that second, plus start of the end second to end
            nanoseconds += 1000000000 - start[1] + stop[1];
            this.decisions[decision].timeInPrediction += nanoseconds;
            this.decisions[decision].invocations++;
            let SLL_k = this._sllStopIndex - this._startIndex + 1;
            this.decisions[decision].SLL_TotalLook += SLL_k;
            this.decisions[decision].SLL_MinLook = this.decisions[decision].SLL_MinLook === 0 ? SLL_k : Math.min(this.decisions[decision].SLL_MinLook, SLL_k);
            if (SLL_k > this.decisions[decision].SLL_MaxLook) {
                this.decisions[decision].SLL_MaxLook = SLL_k;
                this.decisions[decision].SLL_MaxLookEvent = new $itw6a.LookaheadEventInfo(decision, undefined, alt, input, this._startIndex, this._sllStopIndex, false);
            }
            if (this._llStopIndex >= 0) {
                let LL_k = this._llStopIndex - this._startIndex + 1;
                this.decisions[decision].LL_TotalLook += LL_k;
                this.decisions[decision].LL_MinLook = this.decisions[decision].LL_MinLook === 0 ? LL_k : Math.min(this.decisions[decision].LL_MinLook, LL_k);
                if (LL_k > this.decisions[decision].LL_MaxLook) {
                    this.decisions[decision].LL_MaxLook = LL_k;
                    this.decisions[decision].LL_MaxLookEvent = new $itw6a.LookaheadEventInfo(decision, undefined, alt, input, this._startIndex, this._llStopIndex, true);
                }
            }
            return alt;
        } finally{
            this._input = undefined;
            this.currentDecision = -1;
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        let state = super.getStartState(dfa, input, outerContext, useContext);
        this.currentState = state;
        return state;
    }
    computeStartState(dfa, globalContext, useContext) {
        let state = super.computeStartState(dfa, globalContext, useContext);
        this.currentState = state;
        return state;
    }
    computeReachSet(dfa, previous, t, contextCache) {
        if (this._input === undefined) throw new Error("Invalid state");
        let reachState = super.computeReachSet(dfa, previous, t, contextCache);
        if (reachState == null) // no reach on current lookahead symbol. ERROR.
        this.decisions[this.currentDecision].errors.push(new $5aiBr.ErrorInfo(this.currentDecision, previous, this._input, this._startIndex, this._input.index));
        this.currentState = reachState;
        return reachState;
    }
    getExistingTargetState(previousD, t) {
        if (this.currentState === undefined || this._input === undefined) throw new Error("Invalid state");
        // this method is called after each time the input position advances
        if (this.currentState.useContext) this._llStopIndex = this._input.index;
        else this._sllStopIndex = this._input.index;
        let existingTargetState = super.getExistingTargetState(previousD, t);
        if (existingTargetState != null) {
            // this method is directly called by execDFA; must construct a SimulatorState
            // to represent the current state for this case
            this.currentState = new $fO6gt.SimulatorState(this.currentState.outerContext, existingTargetState, this.currentState.useContext, this.currentState.remainingOuterContext);
            if (this.currentState.useContext) this.decisions[this.currentDecision].LL_DFATransitions++;
            else this.decisions[this.currentDecision].SLL_DFATransitions++; // count only if we transition over a DFA state
            if (existingTargetState === $lbAqv.ATNSimulator.ERROR) {
                let state = new $fO6gt.SimulatorState(this.currentState.outerContext, previousD, this.currentState.useContext, this.currentState.remainingOuterContext);
                this.decisions[this.currentDecision].errors.push(new $5aiBr.ErrorInfo(this.currentDecision, state, this._input, this._startIndex, this._input.index));
            }
        }
        return existingTargetState;
    }
    computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let targetState = super.computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache);
        if (useContext) this.decisions[this.currentDecision].LL_ATNTransitions++;
        else this.decisions[this.currentDecision].SLL_ATNTransitions++;
        return targetState;
    }
    evalSemanticContextImpl(pred, parserCallStack, alt) {
        if (this.currentState === undefined || this._input === undefined) throw new Error("Invalid state");
        let result = super.evalSemanticContextImpl(pred, parserCallStack, alt);
        if (!(pred instanceof $8DW9a.SemanticContext.PrecedencePredicate)) {
            let fullContext = this._llStopIndex >= 0;
            let stopIndex = fullContext ? this._llStopIndex : this._sllStopIndex;
            this.decisions[this.currentDecision].predicateEvals.push(new $9gMj2.PredicateEvalInfo(this.currentState, this.currentDecision, this._input, this._startIndex, stopIndex, pred, result, alt));
        }
        return result;
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (this._input === undefined) throw new Error("Invalid state");
        if (prediction !== this.conflictingAltResolvedBySLL) this.decisions[this.currentDecision].contextSensitivities.push(new $jQFYZ.ContextSensitivityInfo(this.currentDecision, acceptState, this._input, startIndex, stopIndex));
        super.reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (conflictingAlts != null) this.conflictingAltResolvedBySLL = conflictingAlts.nextSetBit(0);
        else this.conflictingAltResolvedBySLL = conflictState.s0.configs.getRepresentedAlternatives().nextSetBit(0);
        this.decisions[this.currentDecision].LL_Fallback++;
        super.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex);
    }
    reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.currentState === undefined || this._input === undefined) throw new Error("Invalid state");
        let prediction;
        if (ambigAlts != null) prediction = ambigAlts.nextSetBit(0);
        else prediction = configs.getRepresentedAlternatives().nextSetBit(0);
        if (this.conflictingAltResolvedBySLL !== $lDQMG.ATN.INVALID_ALT_NUMBER && prediction !== this.conflictingAltResolvedBySLL) // Even though this is an ambiguity we are reporting, we can
        // still detect some context sensitivities.  Both SLL and LL
        // are showing a conflict, hence an ambiguity, but if they resolve
        // to different minimum alternatives we have also identified a
        // context sensitivity.
        this.decisions[this.currentDecision].contextSensitivities.push(new $jQFYZ.ContextSensitivityInfo(this.currentDecision, this.currentState, this._input, startIndex, stopIndex));
        this.decisions[this.currentDecision].ambiguities.push(new $kW9dT.AmbiguityInfo(this.currentDecision, this.currentState, ambigAlts, this._input, startIndex, stopIndex));
        super.reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs);
    }
    // ---------------------------------------------------------------------
    getDecisionInfo() {
        return this.decisions;
    }
    getCurrentState() {
        return this.currentState;
    }
}
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override,
    $624fc50ef64f8083$var$__param(0, $esDFm.NotNull)
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "adaptivePredict", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "getStartState", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "computeStartState", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "computeReachSet", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "getExistingTargetState", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "computeTargetState", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "evalSemanticContextImpl", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "reportContextSensitivity", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "reportAttemptingFullContext", null);
$624fc50ef64f8083$var$__decorate([
    $esDFm.Override,
    $624fc50ef64f8083$var$__param(0, $esDFm.NotNull),
    $624fc50ef64f8083$var$__param(5, $esDFm.NotNull),
    $624fc50ef64f8083$var$__param(6, $esDFm.NotNull)
], $624fc50ef64f8083$var$ProfilingATNSimulator.prototype, "reportAmbiguity", null);
module.exports.ProfilingATNSimulator = $624fc50ef64f8083$var$ProfilingATNSimulator;

});

parcelRegister("9bmP2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransitionType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:37.8530496-07:00
var $01b9a8a5d1959acb$var$TransitionType;
(function(TransitionType) {
    // constants for serialization
    TransitionType[TransitionType["EPSILON"] = 1] = "EPSILON";
    TransitionType[TransitionType["RANGE"] = 2] = "RANGE";
    TransitionType[TransitionType["RULE"] = 3] = "RULE";
    TransitionType[TransitionType["PREDICATE"] = 4] = "PREDICATE";
    TransitionType[TransitionType["ATOM"] = 5] = "ATOM";
    TransitionType[TransitionType["ACTION"] = 6] = "ACTION";
    TransitionType[TransitionType["SET"] = 7] = "SET";
    TransitionType[TransitionType["NOT_SET"] = 8] = "NOT_SET";
    TransitionType[TransitionType["WILDCARD"] = 9] = "WILDCARD";
    TransitionType[TransitionType["PRECEDENCE"] = 10] = "PRECEDENCE";
})($01b9a8a5d1959acb$var$TransitionType = module.exports.TransitionType || (module.exports.TransitionType = {}));

});



parcelRegister("4BpPc", function(module, exports) {
$parcel$export(module.exports, "getMatchedText", () => $eda7a2f1ca57f649$export$83ee138904b6afa9);

var $4Q2DM = parcelRequire("4Q2DM");
const $eda7a2f1ca57f649$export$83ee138904b6afa9 = (tokenStream, startTokenIndex, stopToken, caretSelectionRange)=>{
    const matchedText = tokenStream.getText((0, $4Q2DM.Interval).of(startTokenIndex, stopToken.tokenIndex));
    const [caretStartPosition] = caretSelectionRange;
    const tokenStopPosition = stopToken.stopIndex + 1;
    // We only want to return the text preceding the caret. If our caret starts before our stop token
    // ends then we need to slice all the characters after the caret from our matched text.
    if (caretStartPosition < tokenStopPosition) {
        const end = caretStartPosition - tokenStopPosition;
        return matchedText.slice(0, end);
    }
    return matchedText;
};

});


parcelRegister("4rAkI", function(module, exports) {
$parcel$export(module.exports, "WHERE_CLAUSE", () => $038a1ac7dbaeca58$export$fcc2350cc056716b);
$parcel$export(module.exports, "ORDER_BY_CLAUSE", () => $038a1ac7dbaeca58$export$70f282bc9dee0);
$parcel$export(module.exports, "operators", () => $038a1ac7dbaeca58$export$ccbce4efa7f8029b);
$parcel$export(module.exports, "rulesWithContext", () => $038a1ac7dbaeca58$export$89ca914af2cf3d89);
$parcel$export(module.exports, "unclosedStringTokens", () => $038a1ac7dbaeca58$export$83a88291963ac646);

var $41LBU = parcelRequire("41LBU");
const $038a1ac7dbaeca58$export$fcc2350cc056716b = 'where';
const $038a1ac7dbaeca58$export$70f282bc9dee0 = 'orderBy';
const $038a1ac7dbaeca58$export$ccbce4efa7f8029b = [
    '=',
    '!=',
    '>',
    '<',
    '>=',
    '<=',
    'in',
    'not in',
    '~',
    '!~',
    'is',
    'is not',
    'was',
    'was in',
    'was not in',
    'was not',
    'changed'
];
const $038a1ac7dbaeca58$export$74cb906d74b3b55 = [
    'after',
    'before',
    'on',
    'during',
    'by',
    'from',
    'to'
];
const $038a1ac7dbaeca58$export$89ca914af2cf3d89 = [
    (0, $41LBU.JQLParser).RULE_jqlField,
    (0, $41LBU.JQLParser).RULE_jqlEqualsOperator,
    (0, $41LBU.JQLParser).RULE_jqlLikeOperator,
    (0, $41LBU.JQLParser).RULE_jqlComparisonOperator,
    (0, $41LBU.JQLParser).RULE_jqlInOperator,
    (0, $41LBU.JQLParser).RULE_jqlIsOperator,
    (0, $41LBU.JQLParser).RULE_jqlWasOperator,
    (0, $41LBU.JQLParser).RULE_jqlWasInOperator,
    (0, $41LBU.JQLParser).RULE_jqlChangedOperator,
    (0, $41LBU.JQLParser).RULE_jqlValue,
    (0, $41LBU.JQLParser).RULE_jqlListStart,
    (0, $41LBU.JQLParser).RULE_jqlFunction
];
const $038a1ac7dbaeca58$export$83a88291963ac646 = [
    (0, $41LBU.JQLParser).UNCLOSED_QUOTE_STRING,
    (0, $41LBU.JQLParser).UNCLOSED_SQUOTE_STRING
];

});

parcelRegister("8Oxi7", function(module, exports) {
$parcel$export(module.exports, "defaultIgnoredTokens", () => $04e5c80c35704dfd$export$670c1d340f270c75);
$parcel$export(module.exports, "defaultPreferredRules", () => $04e5c80c35704dfd$export$559aada45718501d);
$parcel$export(module.exports, "defaultDelimiterTokens", () => $04e5c80c35704dfd$export$291dfc9819c46993);

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");
const $04e5c80c35704dfd$export$670c1d340f270c75 = new Set([
    (0, $bFJ48.JQLLexer).EOF,
    (0, $bFJ48.JQLLexer).LPAREN,
    (0, $bFJ48.JQLLexer).RPAREN,
    (0, $bFJ48.JQLLexer).LBRACKET,
    (0, $bFJ48.JQLLexer).RBRACKET,
    (0, $bFJ48.JQLLexer).STRING,
    (0, $bFJ48.JQLLexer).QUOTE_STRING,
    (0, $bFJ48.JQLLexer).SQUOTE_STRING,
    (0, $bFJ48.JQLLexer).POSNUMBER,
    (0, $bFJ48.JQLLexer).NEGNUMBER,
    (0, $bFJ48.JQLLexer).BANG,
    (0, $bFJ48.JQLLexer).CUSTOMFIELD,
    (0, $bFJ48.JQLLexer).COMMA
]);
const $04e5c80c35704dfd$export$6edc316f30bb7a82 = [
    (0, $41LBU.JQLParser).RULE_jqlFieldProperty
];
const $04e5c80c35704dfd$var$operatorRules = [
    (0, $41LBU.JQLParser).RULE_jqlEqualsOperator,
    (0, $41LBU.JQLParser).RULE_jqlLikeOperator,
    (0, $41LBU.JQLParser).RULE_jqlComparisonOperator,
    (0, $41LBU.JQLParser).RULE_jqlInOperator,
    (0, $41LBU.JQLParser).RULE_jqlIsOperator,
    (0, $41LBU.JQLParser).RULE_jqlWasOperator,
    (0, $41LBU.JQLParser).RULE_jqlWasInOperator,
    (0, $41LBU.JQLParser).RULE_jqlChangedOperator
];
const $04e5c80c35704dfd$var$operandRules = [
    (0, $41LBU.JQLParser).RULE_jqlValue,
    (0, $41LBU.JQLParser).RULE_jqlFunction,
    // If a new list can be started at caret position, autocomplete will return a special `list` rule
    // that consumers can use do special handling. In the case of JQL editor, this means showing
    // operands before the opening parenthesis has been typed, and then auto-inserting it for the user.
    (0, $41LBU.JQLParser).RULE_jqlListStart
];
const $04e5c80c35704dfd$export$559aada45718501d = new Set([
    (0, $41LBU.JQLParser).RULE_jqlField,
    ...$04e5c80c35704dfd$var$operatorRules,
    ...$04e5c80c35704dfd$var$operandRules,
    ...$04e5c80c35704dfd$export$6edc316f30bb7a82,
    // Disable token suggestions for predicate operands.
    // To be removed when we build proper autocomplete support.
    (0, $41LBU.JQLParser).RULE_jqlPredicateOperand
]);
const $04e5c80c35704dfd$export$291dfc9819c46993 = new Set([
    (0, $bFJ48.JQLLexer).LPAREN,
    (0, $bFJ48.JQLLexer).COMMA
]);

});

parcelRegister("3e63f", function(module, exports) {
$parcel$export(module.exports, "RuleContextVisitor", () => $a17dbcbcaac57ef1$export$264a3b8d4812a152);

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");

var $4rAkI = parcelRequire("4rAkI");

var $bBlHv = parcelRequire("bBlHv");
class $a17dbcbcaac57ef1$export$264a3b8d4812a152 {
    constructor(ruleSuggestion, ruleList, rule, tokenStream, maybeCaretToken){
        this.visitJqlQuery = (ctx)=>{
            const whereCtx = ctx.jqlWhere();
            const orderByCtx = ctx.jqlOrderBy();
            const ctxToVisit = this.getCtxToVisit([
                whereCtx,
                orderByCtx
            ]);
            const ruleContext = {
                ...ctxToVisit?.accept(this)
            };
            if (this.rule === (0, $41LBU.JQLParser).RULE_jqlField) ruleContext.clause = this.ruleList.includes((0, $41LBU.JQLParser).RULE_jqlWhere) ? (0, $4rAkI.WHERE_CLAUSE) : (0, $4rAkI.ORDER_BY_CLAUSE);
            return ruleContext;
        };
        this.visitJqlWhere = (ctx)=>{
            return ctx.jqlOrClause().accept(this);
        };
        this.visitJqlOrderBy = ()=>{
            return {};
        };
        this.visitJqlOrClause = (ctx)=>{
            const ctxToVisit = this.getCtxToVisit(ctx.jqlAndClause());
            return {
                ...ctxToVisit?.accept(this)
            };
        };
        this.visitJqlAndClause = (ctx)=>{
            const ctxToVisit = this.getCtxToVisit(ctx.jqlNotClause());
            return {
                ...ctxToVisit?.accept(this)
            };
        };
        this.visitJqlNotClause = (ctx)=>{
            const ctxToVisit = this.getCtxToVisit([
                ctx.jqlNotClause(),
                ctx.jqlSubClause(),
                ctx.jqlTerminalClause()
            ]);
            return {
                ...ctxToVisit?.accept(this)
            };
        };
        this.visitJqlSubClause = (ctx)=>{
            const orCtx = ctx.jqlOrClause();
            return {
                ...orCtx?.accept(this)
            };
        };
        this.visitJqlTerminalClause = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            const rhsCtx = ctx.jqlTerminalClauseRhs();
            const { errorNodes: errorNodes, ...rhsRuleContext } = rhsCtx.accept(this);
            return {
                ...fieldCtx.accept(this),
                ...rhsRuleContext,
                ...this.getCtxFromErrorNodes(errorNodes)
            };
        };
        this.visitJqlField = (ctx)=>{
            if (this.rule === (0, $41LBU.JQLParser).RULE_jqlField) return {};
            return {
                field: this.tokenStream.getText(ctx)
            };
        };
        this.visitJqlNumberField = (ctx)=>{
            return this.visitJqlField(ctx);
        };
        this.visitJqlNonNumberField = (ctx)=>{
            return this.visitJqlField(ctx);
        };
        this.visitJqlEqualsClause = (ctx)=>{
            // We can skip visiting operand in this case as this clause type doesn't support list operands
            return ctx.jqlEqualsOperator().accept(this);
        };
        this.visitJqlEqualsOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlLikeClause = (ctx)=>{
            // We can skip visiting operand in this case as this clause type doesn't support list operands
            return ctx.jqlLikeOperator().accept(this);
        };
        this.visitJqlLikeOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlComparisonClause = (ctx)=>{
            // We can skip visiting operand in this case as this clause type doesn't support list operands
            return ctx.jqlComparisonOperator().accept(this);
        };
        this.visitJqlComparisonOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlInClause = (ctx)=>{
            const operatorContext = ctx.jqlInOperator().accept(this);
            const listCtx = ctx.jqlList();
            if (listCtx !== undefined && this.isReplacePosAtCtx(listCtx)) return {
                ...operatorContext,
                ...listCtx.accept(this)
            };
            return {
                ...operatorContext
            };
        };
        this.visitJqlInOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlIsClause = (ctx)=>{
            // We can skip visiting operand in this case as this clause type doesn't support list operands
            return ctx.jqlIsOperator().accept(this);
        };
        this.visitJqlIsOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlWasClause = (ctx)=>{
            // We can skip visiting operand in this case as this clause type doesn't support list operands
            return ctx.jqlWasOperator().accept(this);
        };
        this.visitJqlWasOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlWasInClause = (ctx)=>{
            const operatorContext = ctx.jqlWasInOperator().accept(this);
            const listCtx = ctx.jqlList();
            if (listCtx !== undefined && this.isReplacePosAtCtx(listCtx)) return {
                ...operatorContext,
                ...listCtx.accept(this)
            };
            return {
                ...operatorContext
            };
        };
        this.visitJqlWasInOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlChangedClause = (ctx)=>{
            // We can skip visiting operand in this case as this clause type doesn't support list operands
            return ctx.jqlChangedOperator().accept(this);
        };
        this.visitJqlChangedOperator = (ctx)=>{
            return this.visitOperator(ctx);
        };
        this.visitJqlList = (ctx)=>{
            const [_, leftParenStop] = (0, $bBlHv.getPositionFromParserRule)(ctx.jqlListStart());
            try {
                const [rightParenStart] = (0, $bBlHv.getPositionFromParserRule)(ctx.jqlListEnd());
                if (this.replacePositionStart >= leftParenStop && this.replacePositionStart <= rightParenStart) return {
                    isList: true
                };
            } catch (error) {
                // There are some queries (e.g. "project in (jsw jsd") where visiting `jqlListEnd` context
                // results in an error, as RPAREN token doesn't exist and parse tree contains an error node
                // that prevents ANTLR from recovering. For context purposes, this means we are inside the list.
                return {
                    isList: true
                };
            }
            return {};
        };
        this.visitOperator = (ctx)=>{
            // In some situations, e.g. "project was in|", autocomplete returns both operator and operand
            // rules as candidates. For the operand rule, we want to have "was" as operator in context, even
            // though the parse tree in this case says that the operator is "was in". For this reason, we
            // get text before replace position start and check if result is one of the supported operators.
            const textBeforeReplacePosition = this.tokenStream.getText(ctx).substring(0, this.replacePositionStart - ctx.start.startIndex);
            const maybeOperator = (0, $bBlHv.normalizeText)(textBeforeReplacePosition);
            if ((0, $bBlHv.isOperator)(maybeOperator)) return {
                operator: maybeOperator
            };
            return {};
        };
        /**
	 * Returns whether replace position start for our candidate lies within the provided rule context,
	 * or it's a whitespace token starting where the rule context ends. In those cases, we can assume
	 * the provided rule context contains the relevant contextual data for our candidate rule.
	 *
	 * NOTE: This assumption is not airtight and there could be scenarios which violate this
	 * assumption if we introduce new candidates or context nodes in the future.
	 */ this.isReplacePosAtCtx = (ctx)=>{
            const [start, stop] = (0, $bBlHv.getPositionFromParserRule)(ctx);
            return this.replacePositionStart >= start && this.replacePositionStart <= stop || !!this.maybeCaretToken && this.maybeCaretToken.type === (0, $bFJ48.JQLLexer).MATCHWS && this.maybeCaretToken.startIndex === stop;
        };
        /**
	 * Given a list of parser rule contexts, this function returns which one should be visited
	 * based on replace position start (i.e. the parser rule context that contains the relevant
	 * information for our candidate rule).
	 *
	 * This can be called by visitor functions to select the adequate child rule context to visit,
	 * for instance when we have multiple terminal clauses in a compound clause.
	 */ this.getCtxToVisit = (contexts)=>{
            const definedContexts = contexts.filter((context)=>context !== undefined);
            for(let i = 0; i < definedContexts.length; i++){
                const ctx = definedContexts[i];
                if (this.isReplacePosAtCtx(ctx)) return ctx;
            }
            return undefined;
        };
        /**
	 * Recover from the clause type ambiguities described in {@link visitChildren}.
	 */ this.getCtxFromErrorNodes = (errorNodes)=>{
            if (errorNodes !== undefined) {
                const textBeforeReplacePosition = errorNodes.filter((errorNode)=>errorNode.payload.startIndex < this.replacePositionStart).map((errorNode)=>errorNode.payload.text).join(' ');
                const maybeOperator = (0, $bBlHv.normalizeText)(textBeforeReplacePosition);
                if ((0, $bBlHv.isOperator)(maybeOperator)) return {
                    operator: maybeOperator
                };
            }
            return {};
        };
        /**
	 * If this function is called, it means parse tree contains error nodes. In some situations, this
	 * is due to ambiguities we can recover from (e.g. "issuetype was ", which can be a WAS or WAS IN
	 * clause). To help return the right context in these cases, we expose error nodes in the current
	 * rule context, allowing upstream visitors to decide how to handle them.
	 */ this.visitChildren = (node)=>{
            const errorNodes = [];
            for(let i = 0; i < node.childCount; i++)errorNodes.push(node.getChild(i));
            return {
                errorNodes: errorNodes
            };
        };
        this.visit = ()=>{
            throw new Error('Unsupported operation visit(ParseTree)');
        };
        this.visitErrorNode = ()=>{
            throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
        };
        this.visitTerminal = ()=>{
            throw new Error('Unsupported operation visitTerminal(TerminalNode)');
        };
        this.ruleList = ruleList;
        this.rule = rule;
        this.tokenStream = tokenStream;
        this.maybeCaretToken = maybeCaretToken;
        [this.replacePositionStart] = ruleSuggestion.replacePosition;
    }
}

});
parcelRegister("bBlHv", function(module, exports) {
$parcel$export(module.exports, "isPredicateOperand", () => $70af188b887738f2$export$f6f5e3a2b03ff413);
$parcel$export(module.exports, "getPositionFromParserRule", () => $70af188b887738f2$export$568d319b3dcae60e);
$parcel$export(module.exports, "normalizeText", () => $70af188b887738f2$export$7c2714a5250b9239);
$parcel$export(module.exports, "isOperator", () => $70af188b887738f2$export$4e40859592ee7ac2);

var $41LBU = parcelRequire("41LBU");

var $4rAkI = parcelRequire("4rAkI");
const $70af188b887738f2$export$f6f5e3a2b03ff413 = (ruleStack)=>{
    return ruleStack.includes((0, $41LBU.JQLParser).RULE_jqlPredicateOperand);
};
const $70af188b887738f2$export$568d319b3dcae60e = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex + 1
    ];
const $70af188b887738f2$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ').trim();
const $70af188b887738f2$export$4e40859592ee7ac2 = (maybeOperator)=>(0, $4rAkI.operators).includes(maybeOperator);

});



parcelRegister("4cOHu", function(module, exports) {
$parcel$export(module.exports, "Action", () => $95c3df4ade0ed5bd$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $95c3df4ade0ed5bd$export$7f97440769de1377);
$parcel$export(module.exports, "ActionSubjectId", () => $95c3df4ade0ed5bd$export$cb7d54f314e067cb);
var $95c3df4ade0ed5bd$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["CLICKED"] = "clicked";
    Action["RETRIEVE_FAILED"] = "retrieveFailed";
    Action["RETRIEVED"] = "retrieved";
    Action["SELECTED"] = "selected";
    Action["VIEWED"] = "viewed";
    return Action;
}({});
var $95c3df4ade0ed5bd$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["BUTTON"] = "button";
    ActionSubject["AUTOCOMPLETE_OPTION"] = "autocompleteOption";
    ActionSubject["ERROR_MESSAGE"] = "errorMessage";
    return ActionSubject;
}({});
var $95c3df4ade0ed5bd$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_EXPAND"] = "jqlEditorExpand";
    ActionSubjectId["EDITOR_SEARCH"] = "jqlEditorSearch";
    ActionSubjectId["EDITOR_HELP"] = "jqlEditorHelp";
    ActionSubjectId["JQL_RESULT"] = "jqlResult";
    return ActionSubjectId;
}({});

});

parcelRegister("jwFim", function(module, exports) {
$parcel$export(module.exports, "selectErrorCommand", () => $e2ee1de0c473c442$export$3cf85dffc81ad10f);

var $3lIcL = parcelRequire("3lIcL");

var $cic90 = parcelRequire("cic90");

var $ab4Yl = parcelRequire("ab4Yl");

var $3HQ0y = parcelRequire("3HQ0y");
const $e2ee1de0c473c442$export$3cf85dffc81ad10f = (state, _, view)=>{
    const jast = (0, $3HQ0y.getJastFromState)(state);
    const error = jast.errors.length > 0 ? jast.errors[0] : null;
    if (!(error instanceof (0, $cic90.JQLSyntaxError)) || !view) return false;
    const transaction = state.tr;
    const documentFrom = (0, $ab4Yl.default)(transaction.doc, error.start);
    const documentTo = (0, $ab4Yl.default)(transaction.doc, error.stop);
    const selection = (0, $3lIcL.TextSelection).create(transaction.doc, documentFrom, documentTo);
    transaction.setSelection(selection);
    transaction.scrollIntoView();
    view.focus();
    view.dispatch(transaction);
    return true;
};

});
parcelRegister("ab4Yl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb5c2e3d50ee29d9$export$2e2bcd8739ae039);

var $bkqOC = parcelRequire("bkqOC");
/**
 * Recursively find the PM node which includes our text position. This method tracks the offset of PM nodes in order
 * to compute the correct document position according to the rules identified here: https://prosemirror.net/docs/guide/#doc.indexing.
 *
 * If for some reason the text position can not be found in the node then the position at which the current node ends
 * will be returned.
 *
 * @param node Node to search
 * @param parentNodePos Current document and text position within the parent when entering the current node.
 * @param textPosition Text position to find in the Prosemirror document.
 */ const $bb5c2e3d50ee29d9$var$enterNode = (node, parentNodePos, textPosition)=>{
    let nodePos = {
        ...parentNodePos
    };
    const isDocNode = node.type === (0, $bkqOC.JQLEditorSchema).nodes.doc;
    // Enter non-leaf node
    if (!node.isLeaf && !isDocNode) {
        nodePos.doc += 1;
        if (node.isBlock) {
            if (nodePos.enteredInitialBlock) // Every time we enter a block node (after the initial block),
            // we need to increment text position to account for newline char.
            nodePos.text += 1;
            nodePos.enteredInitialBlock = true;
        }
        // If we've entered a new block and now have a matching node then return the current node position.
        if (nodePos.text === textPosition) return nodePos;
        // If text position matches last position of a node view, return its outer document position
        if (node.isAtom && textPosition === nodePos.text + node.content.size) {
            nodePos.doc += node.content.size + 1;
            nodePos.text += node.content.size;
            return nodePos;
        }
    }
    if (node.isText) {
        // If our expected text position lies within the text nodes content, then return the associated document position.
        if (textPosition >= nodePos.text && textPosition <= nodePos.text + node.nodeSize) {
            const textOffset = textPosition - nodePos.text;
            nodePos.doc += textOffset;
            nodePos.text += textOffset;
            return nodePos;
        } else {
            // Otherwise increment our accumulated document/text position
            nodePos.doc += node.nodeSize;
            nodePos.text += node.nodeSize;
        }
    }
    for(let i = 0; i < node.childCount; i++){
        nodePos = $bb5c2e3d50ee29d9$var$enterNode(node.child(i), nodePos, textPosition);
        // If we have a matching node after iterating this nodes children then return the current node position.
        if (nodePos.text === textPosition) return nodePos;
    }
    // Exit non-leaf node
    if (!node.isLeaf && !isDocNode) nodePos.doc += 1;
    return nodePos;
};
/**
 * Return the Prosemirror document position that maps to the provided plain text position.
 *
 * @param doc Prosemirror document
 * @param textPosition Text position to find in the Prosemirror document.
 */ const $bb5c2e3d50ee29d9$var$getDocumentPosition = (doc, textPosition)=>{
    const currentPos = {
        doc: 0,
        text: 0,
        enteredInitialBlock: false
    };
    const matchingNodePos = $bb5c2e3d50ee29d9$var$enterNode(doc, currentPos, textPosition);
    return matchingNodePos.doc;
};
var $bb5c2e3d50ee29d9$export$2e2bcd8739ae039 = $bb5c2e3d50ee29d9$var$getDocumentPosition;

});
parcelRegister("bkqOC", function(module, exports) {
$parcel$export(module.exports, "JQLEditorSchema", () => $c381a64ba0b6e84f$export$5db66e5d5ad380ac);
$parcel$export(module.exports, "clipboardTextSerializer", () => $c381a64ba0b6e84f$export$31d6ecfc7a959697);
$parcel$export(module.exports, "clipboardTextParser", () => $c381a64ba0b6e84f$export$301a0df6d625ad63);
$parcel$export(module.exports, "defaultEditorState", () => $c381a64ba0b6e84f$export$279ca549b85389fb);
$parcel$export(module.exports, "configurePlugins", () => $c381a64ba0b6e84f$export$1b0133438d22575f);

var $huH03 = parcelRequire("huH03");

var $dEkUJ = parcelRequire("dEkUJ");

var $x7sgX = parcelRequire("x7sgX");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $apqw1 = parcelRequire("apqw1");

var $guexm = parcelRequire("guexm");
var $3HQ0y = parcelRequire("3HQ0y");
var $esdm6 = parcelRequire("esdm6");
var $ldpRb = parcelRequire("ldpRb");
var $a5NiY = parcelRequire("a5NiY");


var $Ly2Gm = parcelRequire("Ly2Gm");

var $f49d6 = parcelRequire("f49d6");

var $j3U9J = parcelRequire("j3U9J");

var $eU8L7 = parcelRequire("eU8L7");
const $c381a64ba0b6e84f$var$createMarkWithStyle = (tokenType)=>{
    const mark = document.createElement('span');
    mark.className = `mark-token-${tokenType}`;
    mark.setAttribute('data-token-type', tokenType);
    mark.setAttribute('spellcheck', 'false');
    return mark;
};
const $c381a64ba0b6e84f$export$5db66e5d5ad380ac = new (0, $3xw6l.Schema)({
    nodes: {
        doc: {
            content: 'paragraph+'
        },
        paragraph: {
            content: `(text|${(0, $46481d3a70b8323b$export$631debe5726024e8)})*`,
            toDOM: ()=>[
                    'p',
                    {
                        spellcheck: 'false'
                    },
                    0
                ],
            parseDOM: [
                {
                    tag: 'p'
                }
            ]
        },
        text: {},
        ...(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))((0, $Ly2Gm.richInlineNodes), (spec, name)=>(0, $f49d6.createNodeSpec)(name, spec.attrs))
    },
    marks: {
        token: {
            toDOM: ({ attrs: attrs })=>$c381a64ba0b6e84f$var$createMarkWithStyle(attrs.tokenType),
            attrs: {
                tokenType: {}
            }
        },
        cursor: {
            toDOM: ()=>{
                return document.createElement('span');
            }
        }
    }
});
const $c381a64ba0b6e84f$var$domParser = (0, $3xw6l.DOMParser).fromSchema($c381a64ba0b6e84f$export$5db66e5d5ad380ac);
const $c381a64ba0b6e84f$export$31d6ecfc7a959697 = (slice)=>{
    return (0, $j3U9J.getFragmentText)(slice.content, 0, slice.content.size);
};
const $c381a64ba0b6e84f$export$301a0df6d625ad63 = (text, $context)=>{
    const dom = document.createElement('div');
    // Split each line of text and wrap each in a p tag.
    (0, $eU8L7.splitTextByNewLine)(text).forEach((block)=>{
        dom.appendChild(document.createElement('p')).textContent = block;
    });
    return $c381a64ba0b6e84f$var$domParser.parseSlice(dom, {
        context: $context,
        preserveWhitespace: true
    });
};
const $c381a64ba0b6e84f$export$279ca549b85389fb = (0, $3lIcL.EditorState).create({
    schema: $c381a64ba0b6e84f$export$5db66e5d5ad380ac
});
const $c381a64ba0b6e84f$export$1b0133438d22575f = (editorState, onSearchCommand, intlRef, mainId, portalActions, enableRichInlineNodes)=>{
    return editorState.reconfigure({
        plugins: [
            (0, $apqw1.history)(),
            // Other plugins rely on having AST as part of the state during a transaction, this plugin should be kept first
            (0, $3HQ0y.default)(intlRef),
            (0, $esdm6.default)(),
            ...portalActions !== undefined ? [
                (0, $guexm.default)(portalActions, enableRichInlineNodes),
                ...enableRichInlineNodes ? [
                    (0, $ldpRb.default)(portalActions)
                ] : []
            ] : [],
            (0, $a5NiY.default)(mainId),
            // Keeping these at the bottom allows plugins to define custom key bindings to override default behavior
            (0, $x7sgX.keymap)({
                'Mod-z': (0, $apqw1.undo),
                'Mod-Shift-z': (0, $apqw1.redo),
                'Mod-y': (0, $apqw1.redo),
                // Mimic default Enter behavior in PM's base keymap, allowing to insert new lines even when autocomplete is open
                'Shift-Enter': (0, $dEkUJ.baseKeymap).Enter
            }),
            ...!onSearchCommand ? [] : [
                $c381a64ba0b6e84f$var$keymapNoRepeat({
                    'Mod-Enter': onSearchCommand,
                    Enter: onSearchCommand
                })
            ],
            (0, $x7sgX.keymap)((0, $dEkUJ.baseKeymap))
        ]
    });
};
const $c381a64ba0b6e84f$var$noopCommand = ()=>true;
function $c381a64ba0b6e84f$var$keymapNoRepeat(bindings) {
    const handler = (0, $x7sgX.keydownHandler)(bindings);
    const proxyBindings = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(bindings, ()=>$c381a64ba0b6e84f$var$noopCommand);
    const proxyHandler = (0, $x7sgX.keydownHandler)(proxyBindings);
    return new (0, $3lIcL.Plugin)({
        props: {
            handleKeyDown: (view, event)=>{
                if (event.repeat) return proxyHandler(view, event);
                return handler(view, event);
            }
        }
    });
}

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});

parcelRegister("dEkUJ", function(module, exports) {
$parcel$export(module.exports, "deleteSelection", () => $9eff3bdfd297a823$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $9eff3bdfd297a823$export$52b8a4af68d19794);
$parcel$export(module.exports, "exitCode", () => $9eff3bdfd297a823$export$634b78845598ff5b);
$parcel$export(module.exports, "createParagraphNear", () => $9eff3bdfd297a823$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlock", () => $9eff3bdfd297a823$export$e99155638ff4dff0);
$parcel$export(module.exports, "selectAll", () => $9eff3bdfd297a823$export$90aca4adda6ff0f5);
$parcel$export(module.exports, "toggleMark", () => $9eff3bdfd297a823$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $9eff3bdfd297a823$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $9eff3bdfd297a823$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $9eff3bdfd297a823$export$4a0c2b85b1f0a889);

var $lzEKq = parcelRequire("lzEKq");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");
/**
Delete the selection, if there is one.
*/ const $9eff3bdfd297a823$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $9eff3bdfd297a823$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $lzEKq.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($9eff3bdfd297a823$var$textblockAt(before, "end") || (0, $3lIcL.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $lzEKq.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $3xw6l.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($9eff3bdfd297a823$var$textblockAt(before, "end") ? (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $3lIcL.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $9eff3bdfd297a823$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutBefore($cursor);
    return $cut ? $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $9eff3bdfd297a823$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutAfter($cursor);
    return $cut ? $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $lzEKq.replaceStep)(state.doc, beforePos, afterPos, (0, $3xw6l.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $lzEKq.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $9eff3bdfd297a823$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $9eff3bdfd297a823$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $9eff3bdfd297a823$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $3lIcL.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $9eff3bdfd297a823$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $9eff3bdfd297a823$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($9eff3bdfd297a823$var$textblockAt(after, "start") || (0, $3lIcL.NodeSelection).isSelectable(after))) {
        let delStep = (0, $lzEKq.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $3xw6l.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($9eff3bdfd297a823$var$textblockAt(after, "start") ? (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $3lIcL.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $9eff3bdfd297a823$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $9eff3bdfd297a823$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $3lIcL.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $9eff3bdfd297a823$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $3lIcL.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $lzEKq.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $lzEKq.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $9eff3bdfd297a823$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $3lIcL.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $lzEKq.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $lzEKq.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $9eff3bdfd297a823$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $lzEKq.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $9eff3bdfd297a823$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $9eff3bdfd297a823$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $9eff3bdfd297a823$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $9eff3bdfd297a823$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $3lIcL.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $9eff3bdfd297a823$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $9eff3bdfd297a823$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $lzEKq.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $lzEKq.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $9eff3bdfd297a823$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $lzEKq.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $9eff3bdfd297a823$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $3lIcL.TextSelection) || state.selection instanceof (0, $3lIcL.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $lzEKq.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $lzEKq.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $9eff3bdfd297a823$export$e99155638ff4dff0 = $9eff3bdfd297a823$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $9eff3bdfd297a823$export$eeb429476568b72b = (state, dispatch)=>{
    return $9eff3bdfd297a823$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $9eff3bdfd297a823$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $9eff3bdfd297a823$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $3lIcL.AllSelection)(state.doc)));
    return true;
};
function $9eff3bdfd297a823$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $lzEKq.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $9eff3bdfd297a823$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $3xw6l.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $3xw6l.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $3xw6l.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $lzEKq.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $3xw6l.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $lzEKq.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $3lIcL.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $lzEKq.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $9eff3bdfd297a823$var$textblockAt(after, "start", true) && $9eff3bdfd297a823$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $3xw6l.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $3xw6l.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $lzEKq.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $3xw6l.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $9eff3bdfd297a823$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $9eff3bdfd297a823$export$c3a64f3c9604a1b1 = $9eff3bdfd297a823$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $9eff3bdfd297a823$export$a66c1876556415e5 = $9eff3bdfd297a823$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $9eff3bdfd297a823$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $lzEKq.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $9eff3bdfd297a823$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $9eff3bdfd297a823$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $9eff3bdfd297a823$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $3lIcL.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $3lIcL.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $9eff3bdfd297a823$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$9eff3bdfd297a823$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $9eff3bdfd297a823$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $9eff3bdfd297a823$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $lzEKq.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $9eff3bdfd297a823$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $9eff3bdfd297a823$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $9eff3bdfd297a823$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $9eff3bdfd297a823$var$backspace = $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$e9a518a637d1e641, $9eff3bdfd297a823$export$979097b097459299, $9eff3bdfd297a823$export$52b8a4af68d19794);
let $9eff3bdfd297a823$var$del = $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$e9a518a637d1e641, $9eff3bdfd297a823$export$bf432e340007f9ef, $9eff3bdfd297a823$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $9eff3bdfd297a823$export$eb36e8971b04df36 = {
    "Enter": $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$a5d02b4b65e94f91, $9eff3bdfd297a823$export$d0f80ac1b4510888, $9eff3bdfd297a823$export$a3574cc681852c08, $9eff3bdfd297a823$export$e99155638ff4dff0),
    "Mod-Enter": $9eff3bdfd297a823$export$634b78845598ff5b,
    "Backspace": $9eff3bdfd297a823$var$backspace,
    "Mod-Backspace": $9eff3bdfd297a823$var$backspace,
    "Shift-Backspace": $9eff3bdfd297a823$var$backspace,
    "Delete": $9eff3bdfd297a823$var$del,
    "Mod-Delete": $9eff3bdfd297a823$var$del,
    "Mod-a": $9eff3bdfd297a823$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $9eff3bdfd297a823$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $9eff3bdfd297a823$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $9eff3bdfd297a823$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $9eff3bdfd297a823$export$c3a64f3c9604a1b1,
    "Ctrl-e": $9eff3bdfd297a823$export$a66c1876556415e5
};
for(let key in $9eff3bdfd297a823$export$eb36e8971b04df36)$9eff3bdfd297a823$export$f292ad8dbd5063c8[key] = $9eff3bdfd297a823$export$eb36e8971b04df36[key];
const $9eff3bdfd297a823$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $9eff3bdfd297a823$export$4a0c2b85b1f0a889 = $9eff3bdfd297a823$var$mac ? $9eff3bdfd297a823$export$f292ad8dbd5063c8 : $9eff3bdfd297a823$export$eb36e8971b04df36;

});

parcelRegister("x7sgX", function(module, exports) {
$parcel$export(module.exports, "keymap", () => $0638dd97826018c9$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $0638dd97826018c9$export$53f558754f8b9fd1);

var $1rXzn = parcelRequire("1rXzn");

var $3lIcL = parcelRequire("3lIcL");
const $0638dd97826018c9$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $0638dd97826018c9$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($0638dd97826018c9$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $0638dd97826018c9$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$0638dd97826018c9$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $0638dd97826018c9$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $0638dd97826018c9$export$5043418e2ef368d5(bindings) {
    return new (0, $3lIcL.Plugin)({
        props: {
            handleKeyDown: $0638dd97826018c9$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $0638dd97826018c9$export$53f558754f8b9fd1(bindings) {
    let map = $0638dd97826018c9$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $1rXzn.keyName)(event), baseName, direct = map[$0638dd97826018c9$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$0638dd97826018c9$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $1rXzn.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$0638dd97826018c9$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});
parcelRegister("1rXzn", function(module, exports) {
$parcel$export(module.exports, "base", () => $10e6855a98fb7649$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $10e6855a98fb7649$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $10e6855a98fb7649$export$fb33aafd75404f4c);
var $10e6855a98fb7649$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $10e6855a98fb7649$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $10e6855a98fb7649$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $10e6855a98fb7649$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $10e6855a98fb7649$var$i = 0; $10e6855a98fb7649$var$i < 10; $10e6855a98fb7649$var$i++)$10e6855a98fb7649$export$e2253033e6e1df16[48 + $10e6855a98fb7649$var$i] = $10e6855a98fb7649$export$e2253033e6e1df16[96 + $10e6855a98fb7649$var$i] = String($10e6855a98fb7649$var$i);
// The function keys
for(var $10e6855a98fb7649$var$i = 1; $10e6855a98fb7649$var$i <= 24; $10e6855a98fb7649$var$i++)$10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$i + 111] = "F" + $10e6855a98fb7649$var$i;
// And the alphabetic keys
for(var $10e6855a98fb7649$var$i = 65; $10e6855a98fb7649$var$i <= 90; $10e6855a98fb7649$var$i++){
    $10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$i] = String.fromCharCode($10e6855a98fb7649$var$i + 32);
    $10e6855a98fb7649$export$fba63a578e423eb[$10e6855a98fb7649$var$i] = String.fromCharCode($10e6855a98fb7649$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $10e6855a98fb7649$var$code in $10e6855a98fb7649$export$e2253033e6e1df16)if (!$10e6855a98fb7649$export$fba63a578e423eb.hasOwnProperty($10e6855a98fb7649$var$code)) $10e6855a98fb7649$export$fba63a578e423eb[$10e6855a98fb7649$var$code] = $10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$code];
function $10e6855a98fb7649$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $10e6855a98fb7649$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $10e6855a98fb7649$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $10e6855a98fb7649$export$fba63a578e423eb : $10e6855a98fb7649$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});


parcelRegister("apqw1", function(module, exports) {
$parcel$export(module.exports, "closeHistory", () => $6534b921447e7d51$export$181a649d919c589e);
$parcel$export(module.exports, "history", () => $6534b921447e7d51$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $6534b921447e7d51$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $6534b921447e7d51$export$1688e416fee0a49e);

var $7VXOm = parcelRequire("7VXOm");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $eGOwo = parcelRequire("eGOwo");

var $6rJ4n = parcelRequire("6rJ4n");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $6534b921447e7d51$var$max_empty_items = 500;
class $6534b921447e7d51$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            const next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        const transform = state.tr;
        let selection, remaining;
        const addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $6534b921447e7d51$var$Item(item.map));
                const step = item.step.map(remap.slice(mapFrom));
                let map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $6534b921447e7d51$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $6534b921447e7d51$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        const newItems = [];
        let eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            const step = transform.steps[i].invert(transform.docs[i]);
            let item = new $6534b921447e7d51$var$Item(transform.mapping.maps[i], step, selection), merged;
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line no-cond-assign
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        const overflow = eventCount - histOptions.depth;
        if (overflow > $6534b921447e7d51$var$DEPTH_OVERFLOW) {
            oldItems = $6534b921447e7d51$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $6534b921447e7d51$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        const maps = new (0, $lzEKq.Mapping)();
        this.items.forEach((item, i)=>{
            const mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return this;
        return new $6534b921447e7d51$var$Branch(this.items.append(array.map((map)=>new $6534b921447e7d51$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        const rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        const mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            const pos = mapping.getMirror(--iRebased);
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line eqeqeq
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            const map = mapping.maps[pos];
            if (item.step) {
                const step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                const selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $6534b921447e7d51$var$Item(map, step, selection));
            } else rebasedItems.push(new $6534b921447e7d51$var$Item(map));
        }, start);
        const newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $6534b921447e7d51$var$Item(mapping.maps[i]));
        const items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $6534b921447e7d51$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $6534b921447e7d51$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        const remap = this.remapping(0, upto);
        let mapFrom = remap.maps.length;
        const items = [];
        let events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                const step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    const selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const newItem = new $6534b921447e7d51$var$Item(map.invert(), step, selection);
                    let merged;
                    const last = items.length - 1;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line no-cond-assign
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $6534b921447e7d51$var$Branch((0, $7VXOm.default).from(items.reverse()), events);
    }
    static{
        this.empty = new $6534b921447e7d51$var$Branch((0, $7VXOm.default).empty, 0);
    }
}
function $6534b921447e7d51$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return items.slice(cutPoint);
}
class $6534b921447e7d51$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            const step = other.step.merge(this.step);
            if (step) return new $6534b921447e7d51$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $6534b921447e7d51$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition, /**
		 * ===
		 * FORK ADDITION START
		 * Allow for "history slicing" which groups together changes regardless of time / position adjacency
		 */ historySliceActive, trackedSteps, selectionBookmark){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
        this.historySliceActive = historySliceActive;
        this.trackedSteps = trackedSteps;
        this.selectionBookmark = selectionBookmark;
    }
}
const $6534b921447e7d51$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $6534b921447e7d51$var$applyTransaction(history, state, tr, options) {
    const historyTr = tr.getMeta($6534b921447e7d51$var$historyKey);
    let rebased;
    if (historyTr) return historyTr.historyState;
    /**
	 * ===
	 * FORK ADDITION START
	 * If history slicing is active, we want to continue the current slice
	 */ if ((0, $eGOwo.fg)('platform_editor_ai_aifc_undo_redo')) {
        if ((tr.getMeta('startHistorySlice') === true || history?.historySliceActive) && tr.getMeta('endHistorySlice') !== true) {
            if (tr.getMeta('addToHistory') === false) {
                // For addToHistory=false transactions during a slice, we need to:
                // 1. Update the mapping for done/undone branches
                // 2. Map the existing steps
                // 3. Update the document to rebaseline
                const mappedRanges = history.prevRanges ? $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : null;
                return new $6534b921447e7d51$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition, true, (0, $6rJ4n.mapInvertableSteps)(history.trackedSteps, tr), history.selectionBookmark);
            }
            const startHistorySlice = tr.getMeta('startHistorySlice') === true;
            const newTrackedSteps = [
                ...history.trackedSteps || [],
                ...tr.steps.map((s, idx)=>new (0, $6rJ4n.InvertableStep)(s, s.invert(tr.docs[idx])))
            ];
            const mappedRanges = history.prevRanges ? $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new $6534b921447e7d51$var$HistoryState(history.done, startHistorySlice ? $6534b921447e7d51$var$Branch.empty : history.undone, mappedRanges, history.prevTime, history.prevComposition, true, newTrackedSteps, startHistorySlice ? state.selection.getBookmark() : history.selectionBookmark);
        } else if (tr.getMeta('endHistorySlice') === true && history.historySliceActive) {
            const trackedSteps = history.historySliceActive ? history.trackedSteps || [] : [];
            // Create transform that represents the changes made during the slice
            // Use the original slice document as the base
            const transform = (0, $6rJ4n.createTransformFromSteps)(trackedSteps, tr.doc);
            const mappedRanges = history.prevRanges ? $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new $6534b921447e7d51$var$HistoryState(history.done.addMaps(tr.mapping.maps).addTransform(transform, history.selectionBookmark, options, $6534b921447e7d51$var$mustPreserveItems(state)), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition);
        }
    }
    /**
	 * FORK ADDITION END
	 * ===
	 */ if (tr.getMeta($6534b921447e7d51$var$closeHistoryKey)) history = new $6534b921447e7d51$var$HistoryState(history.done, history.undone, null, 0, -1);
    const appended = tr.getMeta('appendedTransaction');
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($6534b921447e7d51$var$historyKey)) {
        if (appended.getMeta($6534b921447e7d51$var$historyKey).redo) return new $6534b921447e7d51$var$HistoryState(history.done.addTransform(tr, undefined, options, $6534b921447e7d51$var$mustPreserveItems(state)), history.undone, $6534b921447e7d51$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $6534b921447e7d51$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $6534b921447e7d51$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta('addToHistory') !== false && !(appended && appended.getMeta('addToHistory') === false)) {
        // Group transforms that occur in quick succession into one event.
        const composition = tr.getMeta('composition');
        const newGroup = // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevTime == 0 || !appended && // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !$6534b921447e7d51$var$isAdjacentTo(tr, history.prevRanges));
        const prevRanges = appended ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : $6534b921447e7d51$var$rangesFor(tr.mapping.maps);
        return new $6534b921447e7d51$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $6534b921447e7d51$var$mustPreserveItems(state)), $6534b921447e7d51$var$Branch.empty, prevRanges, tr.time, // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        composition == null ? history.prevComposition : composition);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line no-cond-assign
    } else if (rebased = tr.getMeta('rebased')) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $6534b921447e7d51$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $6534b921447e7d51$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $6534b921447e7d51$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $6534b921447e7d51$var$rangesFor(maps) {
    const result = [];
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $6534b921447e7d51$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    const result = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $6534b921447e7d51$var$histTransaction(history, state, redo) {
    const preserveItems = $6534b921447e7d51$var$mustPreserveItems(state);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    const histOptions = $6534b921447e7d51$var$historyKey.get(state).spec.config;
    const pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const selection = pop.selection.resolve(pop.transform.doc);
    const added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    /**
	 * ===
	 * FORK ADDITION START
	 * If history slicing is active when we undo/redo, when we perform an undo/redo we want to
	 * map and keep the relevant steps in the new history state
	 */ const newHist = history.historySliceActive && (0, $eGOwo.fg)('platform_editor_ai_aifc_undo_redo') ? new $6534b921447e7d51$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1, history.historySliceActive, (0, $6rJ4n.mapInvertableSteps)(history.trackedSteps, pop.transform), history.selectionBookmark?.map(pop.transform.mapping)) : new $6534b921447e7d51$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    /**
	 * FORK ADDITION END
	 * ===
	 */ return pop.transform.setSelection(selection).setMeta($6534b921447e7d51$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $6534b921447e7d51$var$cachedPreserveItems = false, $6534b921447e7d51$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $6534b921447e7d51$var$mustPreserveItems(state) {
    const plugins = state.plugins;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if ($6534b921447e7d51$var$cachedPreserveItemsPlugins != plugins) {
        $6534b921447e7d51$var$cachedPreserveItems = false;
        $6534b921447e7d51$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)// To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (plugins[i].spec.historyPreserveItems) {
            $6534b921447e7d51$var$cachedPreserveItems = true;
            break;
        }
    }
    return $6534b921447e7d51$var$cachedPreserveItems;
}
function $6534b921447e7d51$export$181a649d919c589e(tr) {
    return tr.setMeta($6534b921447e7d51$var$closeHistoryKey, true);
}
const $6534b921447e7d51$var$historyKey = new (0, $3lIcL.PluginKey)('history');
const $6534b921447e7d51$var$closeHistoryKey = new (0, $3lIcL.PluginKey)('closeHistory');
function $6534b921447e7d51$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $3lIcL.Plugin)({
        key: $6534b921447e7d51$var$historyKey,
        state: {
            init () {
                return new $6534b921447e7d51$var$HistoryState($6534b921447e7d51$var$Branch.empty, $6534b921447e7d51$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $6534b921447e7d51$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    const inputType = e.inputType;
                    const command = // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line eqeqeq
                    inputType == 'historyUndo' ? $6534b921447e7d51$export$21f930c44940fd98 : inputType == 'historyRedo' ? $6534b921447e7d51$export$1688e416fee0a49e : null;
                    if (!command || !view.editable) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $6534b921447e7d51$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        const hist = $6534b921447e7d51$var$historyKey.getState(state);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            const tr = $6534b921447e7d51$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
const $6534b921447e7d51$export$21f930c44940fd98 = $6534b921447e7d51$var$buildCommand(false, true);
const $6534b921447e7d51$export$1688e416fee0a49e = $6534b921447e7d51$var$buildCommand(true, true);
const $6534b921447e7d51$export$24b5d280435f3a3f = $6534b921447e7d51$var$buildCommand(false, false);
const $6534b921447e7d51$export$3774e54bae7be19b = $6534b921447e7d51$var$buildCommand(true, false);
function $6534b921447e7d51$export$f8a176c2b9a10bdb(state) {
    const hist = $6534b921447e7d51$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
function $6534b921447e7d51$export$3ffe6b288e7d941b(state) {
    const hist = $6534b921447e7d51$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("7VXOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c6c408b4e1a2afa$export$2e2bcd8739ae039);
var $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $5c6c408b4e1a2afa$var$RopeSequence = function RopeSequence() {};
$5c6c408b4e1a2afa$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $5c6c408b4e1a2afa$var$RopeSequence.from(other);
    return !this.length && other || other.length < $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $5c6c408b4e1a2afa$var$RopeSequence.from(other).append(this);
};
$5c6c408b4e1a2afa$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $5c6c408b4e1a2afa$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $5c6c408b4e1a2afa$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$5c6c408b4e1a2afa$var$RopeSequence.from = function from(values) {
    if (values instanceof $5c6c408b4e1a2afa$var$RopeSequence) return values;
    return values && values.length ? new $5c6c408b4e1a2afa$var$Leaf(values) : $5c6c408b4e1a2afa$var$RopeSequence.empty;
};
var $5c6c408b4e1a2afa$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($5c6c408b4e1a2afa$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$5c6c408b4e1a2afa$var$RopeSequence.empty = new $5c6c408b4e1a2afa$var$Leaf([]);
var $5c6c408b4e1a2afa$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($5c6c408b4e1a2afa$var$RopeSequence);
var $5c6c408b4e1a2afa$export$2e2bcd8739ae039 = $5c6c408b4e1a2afa$var$RopeSequence;

});

parcelRegister("6rJ4n", function(module, exports) {
$parcel$export(module.exports, "InvertableStep", () => $38ee939df848c8d1$export$ebdc1f934f4dd665);
$parcel$export(module.exports, "createTransformFromSteps", () => $38ee939df848c8d1$export$6137dcc98f08e76);
$parcel$export(module.exports, "mapInvertableSteps", () => $38ee939df848c8d1$export$3cddda3829daa1af);

var $lzEKq = parcelRequire("lzEKq");
class $38ee939df848c8d1$export$ebdc1f934f4dd665 {
    constructor(step, inverted){
        this.step = step;
        this.inverted = inverted;
    }
}
function $38ee939df848c8d1$export$6137dcc98f08e76(steps, finalDoc) {
    for (const step of steps.slice().reverse())try {
        const result = step.inverted.apply(finalDoc);
        if (result.failed === null && result.doc) finalDoc = result.doc;
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    let tr = new (0, $lzEKq.Transform)(finalDoc);
    for (const step of steps)try {
        tr = tr.step(step.step);
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    return tr;
}
function $38ee939df848c8d1$export$3cddda3829daa1af(steps, tr) {
    if (steps === undefined) return undefined;
    return steps.map((step)=>{
        const newStep = step.step.map(tr.mapping);
        const newInvertedStep = step.inverted.map(tr.mapping);
        if (newStep && newInvertedStep) return new $38ee939df848c8d1$export$ebdc1f934f4dd665(newStep, newInvertedStep);
        return undefined;
    }).filter((s)=>!!s);
}

});


parcelRegister("guexm", function(module, exports) {
$parcel$export(module.exports, "default", () => $904b08e7796a8a20$export$2e2bcd8739ae039);

var $x7sgX = parcelRequire("x7sgX");

var $3lIcL = parcelRequire("3lIcL");

var $cPOPZ = parcelRequire("cPOPZ");

var $5ORvr = parcelRequire("5ORvr");

var $jNbmQ = parcelRequire("jNbmQ");
const $904b08e7796a8a20$var$getKeyHandler = (keymap, key)=>(state, dispatch, view)=>{
        const binding = keymap.getKeyBinding(key);
        return binding ? binding(state, dispatch, view) : false;
    };
const $904b08e7796a8a20$var$autocompletePlugin = (portalActions, enableRichInlineNodes)=>{
    // Empty keymap passed down to the React component so it can register key bindings
    const keymap = new (0, $cPOPZ.PluginKeymap)();
    return new (0, $3lIcL.Plugin)({
        key: (0, $5ORvr.JQLAutocompletePluginKey),
        view: (editorView)=>{
            const view = new (0, $jNbmQ.default)(editorView, keymap, portalActions, enableRichInlineNodes);
            // Initialise view to mount the react component
            view.init();
            return view;
        },
        props: {
            handleKeyDown: (0, $x7sgX.keydownHandler)({
                [(0, $5ORvr.ARROW_UP_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.ARROW_UP_KEY)),
                [(0, $5ORvr.ARROW_DOWN_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.ARROW_DOWN_KEY)),
                [(0, $5ORvr.CMD_ARROW_UP_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.CMD_ARROW_UP_KEY)),
                [(0, $5ORvr.CMD_ARROW_DOWN_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.CMD_ARROW_DOWN_KEY)),
                [(0, $5ORvr.HOME_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.HOME_KEY)),
                [(0, $5ORvr.END_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.END_KEY)),
                [(0, $5ORvr.ESCAPE_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.ESCAPE_KEY)),
                [(0, $5ORvr.ENTER_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.ENTER_KEY)),
                [(0, $5ORvr.TAB_KEY)]: $904b08e7796a8a20$var$getKeyHandler(keymap, (0, $5ORvr.TAB_KEY))
            })
        }
    });
};
var $904b08e7796a8a20$export$2e2bcd8739ae039 = $904b08e7796a8a20$var$autocompletePlugin;

});
parcelRegister("cPOPZ", function(module, exports) {
$parcel$export(module.exports, "PluginKeymap", () => $65aea9e0cc9a4b48$export$c7395d4a3be03aae);
class $65aea9e0cc9a4b48$export$c7395d4a3be03aae {
    bindKey(key, handler) {
        this.keymap = {
            ...this.keymap,
            [key]: handler
        };
    }
    bindMultipleKeys(keys, handler) {
        keys.forEach((key)=>{
            this.keymap = {
                ...this.keymap,
                [key]: handler
            };
        });
    }
    unbindKey(key) {
        const { [key]: keyToUnbind, ...rest } = this.keymap;
        this.keymap = rest;
    }
    getKeyBinding(key) {
        return this.keymap[key];
    }
    constructor(){
        this.keymap = {};
    }
}

});

parcelRegister("5ORvr", function(module, exports) {
$parcel$export(module.exports, "AUTOCOMPLETE_PLUGIN_NAME", () => $9e3c59e9ace8cfa5$export$c130161fcd50bb6b);
$parcel$export(module.exports, "ARROW_UP_KEY", () => $9e3c59e9ace8cfa5$export$36188ba4065969e9);
$parcel$export(module.exports, "ARROW_DOWN_KEY", () => $9e3c59e9ace8cfa5$export$e97017589cb5cf07);
$parcel$export(module.exports, "CMD_ARROW_UP_KEY", () => $9e3c59e9ace8cfa5$export$31faaf515cbd6893);
$parcel$export(module.exports, "CMD_ARROW_DOWN_KEY", () => $9e3c59e9ace8cfa5$export$415626818e0ba51c);
$parcel$export(module.exports, "HOME_KEY", () => $9e3c59e9ace8cfa5$export$d383b538eb82e8da);
$parcel$export(module.exports, "END_KEY", () => $9e3c59e9ace8cfa5$export$72154b7fbc942254);
$parcel$export(module.exports, "ENTER_KEY", () => $9e3c59e9ace8cfa5$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $9e3c59e9ace8cfa5$export$728705b4513abbb5);
$parcel$export(module.exports, "TAB_KEY", () => $9e3c59e9ace8cfa5$export$da8c7facc28740b1);
$parcel$export(module.exports, "defaultAutocompleteProvider", () => $9e3c59e9ace8cfa5$export$76c2b289340c3f7a);
$parcel$export(module.exports, "JQLAutocompletePluginKey", () => $9e3c59e9ace8cfa5$export$4ef7d2c870e6773a);

var $lB9jX = parcelRequire("lB9jX");

var $3lIcL = parcelRequire("3lIcL");
const $9e3c59e9ace8cfa5$export$c130161fcd50bb6b = 'jql-autocomplete-plugin';
const $9e3c59e9ace8cfa5$export$36188ba4065969e9 = 'ArrowUp';
const $9e3c59e9ace8cfa5$export$e97017589cb5cf07 = 'ArrowDown';
const $9e3c59e9ace8cfa5$export$31faaf515cbd6893 = 'Cmd-ArrowUp';
const $9e3c59e9ace8cfa5$export$415626818e0ba51c = 'Cmd-ArrowDown';
const $9e3c59e9ace8cfa5$export$d383b538eb82e8da = 'Home'; // === Fn-Left in Mac
const $9e3c59e9ace8cfa5$export$72154b7fbc942254 = 'End'; // === Fn-Right in Mac
const $9e3c59e9ace8cfa5$export$4162dbd8c730437 = 'Enter';
const $9e3c59e9ace8cfa5$export$728705b4513abbb5 = 'Escape';
const $9e3c59e9ace8cfa5$export$da8c7facc28740b1 = 'Tab';
const $9e3c59e9ace8cfa5$export$76c2b289340c3f7a = {
    onFields: ()=>(0, $lB9jX.empty)(),
    onOperators: ()=>(0, $lB9jX.empty)(),
    onValues: ()=>(0, $lB9jX.empty)(),
    onFunctions: ()=>(0, $lB9jX.empty)()
};
const $9e3c59e9ace8cfa5$export$4ef7d2c870e6773a = new (0, $3lIcL.PluginKey)($9e3c59e9ace8cfa5$export$c130161fcd50bb6b);

});

parcelRegister("jNbmQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b76d8b222efdba29$export$2e2bcd8739ae039);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $8okjU = parcelRequire("8okjU");

var $eGOwo = parcelRequire("eGOwo");

var $ab4Yl = parcelRequire("ab4Yl");

var $fy0uC = parcelRequire("fy0uC");

var $gdlEp = parcelRequire("gdlEp");

var $5ORvr = parcelRequire("5ORvr");
/**
 * Returns whether an opening parenthesis should be automatically inserted for this option (e.g. after a list operator)
 */ const $b76d8b222efdba29$var$shouldInsertOpeningParenthesis = ({ type: type, context: context, isListFunction: isListFunction })=>{
    if (type === 'value' || type === 'function' || type === 'keyword') {
        const operator = context?.operator;
        if (operator && (0, $8okjU.isListOperator)(operator) && !context?.isList && !isListFunction) return true;
    }
    return false;
};
class $b76d8b222efdba29$export$2e2bcd8739ae039 extends (0, $fy0uC.default) {
    constructor(view, keymap, portalActions, enableRichInlineNodes){
        super(portalActions, (0, $5ORvr.AUTOCOMPLETE_PLUGIN_NAME), 'main'), this.getComponent = ()=>{
            return 0, $gdlEp.default;
        }, this.getInitialComponentProps = ()=>{
            return {
                keymap: this.keymap,
                onClick: this.onReplaceSuggestion
            };
        }, this.onReplaceSuggestion = (option)=>{
            const [from, to] = option.replacePosition;
            const transaction = this.view.state.tr;
            transaction.setMeta((0, $5ORvr.JQLAutocompletePluginKey), true);
            // Request query hydration if we are inserting a user node
            if (this.enableRichInlineNodes && option.type === 'value' && option.valueType === 'user') transaction.setMeta('hydrate', true);
            if (this.enableRichInlineNodes && option.type === 'value' && option.valueType === 'team' && (0, $eGOwo.fg)('jira_update_jql_teams')) transaction.setMeta('hydrate', true);
            const documentFrom = (0, $ab4Yl.default)(transaction.doc, from);
            const documentTo = (0, $ab4Yl.default)(transaction.doc, to);
            // Change current selection to the mapped replace position
            transaction.setSelection((0, $3lIcL.TextSelection).create(transaction.doc, documentTo, documentFrom));
            // Replace selected range with the selected autocomplete option
            transaction.replaceSelection(this.getSliceForSuggestion(option));
            this.view.focus();
            this.view.dispatch(transaction);
        }, this.getSliceForSuggestion = (option)=>{
            const { value: value, name: name, nameOnRichInlineNode: nameOnRichInlineNode, valueType: valueType, context: context } = option;
            const nodes = [];
            if ($b76d8b222efdba29$var$shouldInsertOpeningParenthesis(option)) nodes.push(this.view.state.schema.text('('));
            const textContent = this.view.state.schema.text(value);
            if (!this.enableRichInlineNodes) nodes.push(textContent);
            else switch(valueType){
                case 'user':
                    {
                        const attributes = {
                            type: 'user',
                            id: value,
                            name: nameOnRichInlineNode ?? name,
                            fieldName: context?.field
                        };
                        nodes.push(this.view.state.schema.nodes.user.create(attributes, textContent));
                        break;
                    }
                default:
                    nodes.push(textContent);
                    break;
            }
            return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(nodes), 0, 0);
        };
        this.view = view;
        this.keymap = keymap;
        this.enableRichInlineNodes = enableRichInlineNodes;
    }
    isSameState(state, prevState) {
        return prevState.doc.eq(state.doc) && prevState.selection.eq(state.selection);
    }
}

});
parcelRegister("fy0uC", function(module, exports) {
$parcel$export(module.exports, "default", () => $29dbaf0115d8db59$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6WhQS = parcelRequire("6WhQS");
class $29dbaf0115d8db59$export$2e2bcd8739ae039 {
    /**
	 * Construct a Prosemirror plugin view which will render a React component in a portal.
	 *
	 * @param portalActions Provides callback functions which can be invoked to create and destroy a portal.
	 * @param portalKey Unique identifier for the plugin component.
	 * @param containerKey Key representing the HTML container the React component will be portalled into.
	 * @protected
	 */ constructor(portalActions, portalKey, containerKey){
        this.componentSubject = new (0, $6WhQS.Subject)();
        this.init = ()=>{
            const Component = this.getComponent();
            const PortallingComponent = ()=>{
                const [state, setState] = (0, $eJOHy.useState)(()=>this.getInitialComponentProps());
                (0, $eJOHy.useEffect)(()=>{
                    // Subscribe to the RxJS subject so concrete subclasses can emit events to re-render the plugin component.
                    const subscription = this.componentSubject.subscribe((updatedProps)=>{
                        setState(updatedProps);
                    });
                    return ()=>subscription.unsubscribe();
                }, []);
                return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...state
                });
            };
            // Dispatch onCreatePortal which will allow the handler to create a new portalled React component
            this.portalActions.onCreatePortal(this.portalKey, /*#__PURE__*/ (0, $gt9Am.jsx)(PortallingComponent, {}), this.containerKey);
        };
        this.portalActions = portalActions;
        this.portalKey = portalKey;
        this.containerKey = containerKey;
    }
    destroy() {
        // Dispatch onDestroyPortal which will allow the handler to remove the portalled React component.
        this.portalActions.onDestroyPortal(this.portalKey);
    }
}

});

parcelRegister("gdlEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6385ba3f4f26a41$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6S5SS = parcelRequire("6S5SS");

var $4cOHu = parcelRequire("4cOHu");

var $9IGks = parcelRequire("9IGks");

var $dgsFS = parcelRequire("dgsFS");
const $f6385ba3f4f26a41$var$Autocomplete = ({ keymap: keymap, onClick: onClick })=>{
    const [options] = (0, $9IGks.useAutocompleteOptions)();
    const [loading] = (0, $9IGks.useAutocompleteLoading)();
    const [, { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent }] = (0, $9IGks.useStoreActions)();
    const handleClick = (0, $eJOHy.useCallback)((option, analyticsAttributes)=>{
        onClick(option);
        createAndFireAnalyticsEvent({
            action: (0, $4cOHu.Action).SELECTED,
            actionSubject: (0, $4cOHu.ActionSubject).AUTOCOMPLETE_OPTION,
            eventType: (0, $6S5SS.EventType).TRACK,
            attributes: {
                ...analyticsAttributes
            }
        });
    }, [
        createAndFireAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dgsFS.default), {
        options: options,
        loading: loading,
        keymap: keymap,
        onClick: handleClick
    });
};
var $f6385ba3f4f26a41$export$2e2bcd8739ae039 = $f6385ba3f4f26a41$var$Autocomplete;

});
parcelRegister("dgsFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f40dcbfd517299c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8qmYl = parcelRequire("8qmYl");

var $7ep4S = parcelRequire("7ep4S");

var $hpDm2 = parcelRequire("hpDm2");


var $9IGks = parcelRequire("9IGks");

var $5ORvr = parcelRequire("5ORvr");

var $42FIa = parcelRequire("42FIa");

var $aOPUp = parcelRequire("aOPUp");

var $iSAQy = parcelRequire("iSAQy");
const $5f40dcbfd517299c$var$getPreviousOptionId = (options, selectedOptionId)=>{
    if (!selectedOptionId) return options[options.length - 1].id;
    const index = options.findIndex((option)=>option.id === selectedOptionId);
    if (index === -1) return options[options.length - 1].id;
    if (index > 0) return options[index - 1].id;
    return undefined;
};
const $5f40dcbfd517299c$var$getNextOptionId = (options, selectedOptionId)=>{
    if (!selectedOptionId) return options[0].id;
    const index = options.findIndex((option)=>option.id === selectedOptionId);
    if (index === -1) return options[0].id;
    if (index < options.length - 1) return options[index + 1].id;
    return undefined;
};
const $5f40dcbfd517299c$var$AutocompleteDropdown = ({ options: options, loading: loading, keymap: keymap, onClick: onClick })=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const selectedItemRef = (0, $eJOHy.useRef)(null);
    const [navigatingWithKeyboard, setNavigatingWithKeyboard] = (0, $eJOHy.useState)(false);
    const [intl] = (0, $9IGks.useIntl)();
    const [editorView] = (0, $9IGks.useEditorView)();
    const [, { onEditorViewFocus: onEditorViewFocus, onEditorViewBlur: onEditorViewBlur }] = (0, $9IGks.useStoreActions)();
    const [{ selectedOptionId: selectedOptionId }, { closeAutocomplete: closeAutocomplete, setAutocompleteContainer: setAutocompleteContainer, setSelectedAutocompleteOptionId: setSelectedAutocompleteOptionId }] = (0, $9IGks.useAutocomplete)();
    const [isAutocompleteOpen] = (0, $9IGks.useAutocompleteIsOpen)();
    const [{ top: top, left: left }] = (0, $9IGks.useAutocompletePosition)();
    const [areRichInlineNodesEnabled] = (0, $9IGks.useRichInlineNodesEnabled)();
    const [autocompleteId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$be6de605c287d65));
    const isPopperPositioningEnabled = (0, $eGOwo.fg)('jql_editor_autocomplete_use_popper');
    // Create virtual reference element positioned at cursor location (for popper implementation)
    const virtualReferenceElement = (0, $eJOHy.useMemo)(()=>{
        if (!isPopperPositioningEnabled || !editorView || !isAutocompleteOpen) return null;
        // Create a virtual element that uses the same positioning logic as the old implementation
        return {
            getBoundingClientRect: ()=>{
                // Use the same top/left values that the old manual positioning uses
                // This ensures consistency between old and new positioning
                const rect = {
                    width: 0,
                    height: 0,
                    top: top,
                    left: left,
                    right: left,
                    bottom: top,
                    x: left,
                    y: top,
                    toJSON: ()=>rect
                };
                return rect;
            }
        };
    }, [
        isPopperPositioningEnabled,
        editorView,
        isAutocompleteOpen,
        top,
        left
    ]);
    const onContainerRef = (0, $eJOHy.useCallback)((container)=>{
        containerRef.current = container;
        if (!isPopperPositioningEnabled) setAutocompleteContainer(container);
    }, [
        setAutocompleteContainer,
        isPopperPositioningEnabled
    ]);
    const onScrollContainerRef = (0, $eJOHy.useCallback)((container)=>{
        scrollContainerRef.current = container;
    }, [
        scrollContainerRef
    ]);
    const handleClick = (0, $eJOHy.useCallback)((option, optionIndex, keyboard)=>{
        closeAutocomplete();
        onClick(option, {
            keyboard: keyboard,
            numberOfOptions: options.length,
            optionIndex: optionIndex,
            optionType: option.type,
            queryLength: option.matchedText.length,
            nodeType: areRichInlineNodesEnabled && option.valueType !== undefined ? option.valueType : 'text'
        });
    }, [
        options,
        onClick,
        closeAutocomplete,
        areRichInlineNodesEnabled
    ]);
    const onMouseMove = (0, $eJOHy.useCallback)(()=>{
        if (navigatingWithKeyboard) setNavigatingWithKeyboard(false);
    }, [
        navigatingWithKeyboard,
        setNavigatingWithKeyboard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        keymap.bindKey((0, $5ORvr.ARROW_UP_KEY), ()=>{
            if (!isAutocompleteOpen) return false;
            !navigatingWithKeyboard && setNavigatingWithKeyboard(true);
            const previousOptionId = $5f40dcbfd517299c$var$getPreviousOptionId(options, selectedOptionId);
            setSelectedAutocompleteOptionId(previousOptionId);
            return true;
        });
        keymap.bindKey((0, $5ORvr.ARROW_DOWN_KEY), ()=>{
            if (!isAutocompleteOpen) return false;
            !navigatingWithKeyboard && setNavigatingWithKeyboard(true);
            const nextOptionId = $5f40dcbfd517299c$var$getNextOptionId(options, selectedOptionId);
            setSelectedAutocompleteOptionId(nextOptionId);
            return true;
        });
        keymap.bindMultipleKeys([
            (0, $5ORvr.ENTER_KEY),
            (0, $5ORvr.TAB_KEY)
        ], ()=>{
            if (!isAutocompleteOpen) return false;
            const selectedOptionIndex = options.findIndex((option)=>option.id === selectedOptionId);
            if (selectedOptionId && selectedOptionIndex !== -1) {
                if (options[selectedOptionIndex].isDeprecated) return true;
                handleClick(options[selectedOptionIndex], selectedOptionIndex, true);
                return true;
            }
            // Open with no option selected, so we let PM do its stuff (a.k.a. keep inserting new lines)
            return false;
        });
        keymap.bindKey((0, $5ORvr.ESCAPE_KEY), ()=>{
            if (!isAutocompleteOpen) return false;
            closeAutocomplete();
            return true;
        });
        keymap.bindMultipleKeys([
            (0, $5ORvr.HOME_KEY),
            (0, $5ORvr.CMD_ARROW_UP_KEY)
        ], ()=>{
            if (!isAutocompleteOpen) return false;
            !navigatingWithKeyboard && setNavigatingWithKeyboard(true);
            setSelectedAutocompleteOptionId(options[0]?.id);
            return true;
        });
        keymap.bindMultipleKeys([
            (0, $5ORvr.END_KEY),
            (0, $5ORvr.CMD_ARROW_DOWN_KEY)
        ], ()=>{
            if (!isAutocompleteOpen) return false;
            !navigatingWithKeyboard && setNavigatingWithKeyboard(true);
            setSelectedAutocompleteOptionId(options[options.length - 1]?.id);
            return true;
        });
        // New bindings should also be registered in plugins/autocomplete/index.tsx
        return ()=>{
            keymap.unbindKey((0, $5ORvr.ARROW_UP_KEY));
            keymap.unbindKey((0, $5ORvr.ARROW_DOWN_KEY));
            keymap.unbindKey((0, $5ORvr.ENTER_KEY));
            keymap.unbindKey((0, $5ORvr.TAB_KEY));
            keymap.unbindKey((0, $5ORvr.ESCAPE_KEY));
            keymap.unbindKey((0, $5ORvr.HOME_KEY));
            keymap.unbindKey((0, $5ORvr.END_KEY));
            keymap.unbindKey((0, $5ORvr.CMD_ARROW_UP_KEY));
            keymap.unbindKey((0, $5ORvr.CMD_ARROW_DOWN_KEY));
        };
    }, [
        keymap,
        isAutocompleteOpen,
        closeAutocomplete,
        navigatingWithKeyboard,
        setNavigatingWithKeyboard,
        options,
        selectedOptionId,
        setSelectedAutocompleteOptionId,
        handleClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Reset to no selection when:
        // - autocomplete is closed
        // - we get new options and those don't include the currently selected option
        if (!isAutocompleteOpen || !options.some((option)=>option.id === selectedOptionId)) setSelectedAutocompleteOptionId(undefined);
    }, [
        isAutocompleteOpen,
        options,
        selectedOptionId,
        setSelectedAutocompleteOptionId
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!isPopperPositioningEnabled) requestAnimationFrame(()=>{
            if (containerRef.current) {
                containerRef.current.style.top = `${top}px`;
                containerRef.current.style.left = `${left}px`;
            }
        });
    }, [
        top,
        left,
        isPopperPositioningEnabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (navigatingWithKeyboard) selectedItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        navigatingWithKeyboard,
        selectedOptionId,
        selectedItemRef
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        selectedItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        options,
        selectedItemRef
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isAutocompleteOpen && !selectedOptionId && scrollContainerRef.current) scrollContainerRef.current.scrollTop = 0;
    }, [
        isAutocompleteOpen,
        selectedOptionId
    ]);
    const announcedMessage = (0, $eJOHy.useMemo)(()=>{
        if (!isAutocompleteOpen || !options.length) return '';
        return intl.formatMessage((0, $42FIa.messages).optionsFound);
    }, [
        isAutocompleteOpen,
        intl,
        options
    ]);
    const renderAutocompleteContent = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iSAQy.AutocompleteOptionsContainer), {
            ref: onScrollContainerRef,
            onMouseMove: onMouseMove,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iSAQy.OptionList), {
                role: "listbox",
                id: autocompleteId,
                children: options.map((option, index)=>{
                    const isSelected = option.id === selectedOptionId;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aOPUp.default), {
                        isSelected: isSelected,
                        ...isSelected && {
                            ref: selectedItemRef
                        },
                        option: option,
                        onClick: ()=>handleClick(option, index, false),
                        onMouseMove: ()=>{
                            if (options[index]?.id !== selectedOptionId) setSelectedAutocompleteOptionId(options[index]?.id);
                        }
                    }, option.value);
                })
            })
        });
    const renderLoadingFooter = ()=>loading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iSAQy.AutocompleteLoadingFooter), {
            "data-testid": "jql-editor-autocomplete-loading",
            hasOptions: !!options.length,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "small"
            })
        });
    // Early return if popper positioning is enabled but virtual reference element is not available
    if (isPopperPositioningEnabled && !virtualReferenceElement) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            isPopperPositioningEnabled ? // New popper-based positioning
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                referenceElement: virtualReferenceElement,
                placement: "bottom-start",
                shouldFitViewport: true,
                children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $iSAQy.AutocompleteContainer), {
                        "data-testid": "jql-editor-autocomplete",
                        tabIndex: -1,
                        ref: ref,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Popper requires dynamic positioning via style prop
                        style: style,
                        isOpen: isAutocompleteOpen,
                        usePopper: true,
                        onBlur: onEditorViewBlur,
                        onFocus: onEditorViewFocus,
                        children: [
                            renderAutocompleteContent(),
                            renderLoadingFooter()
                        ]
                    })
            }) : // Old manual positioning
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $iSAQy.AutocompleteContainer), {
                "data-testid": "jql-editor-autocomplete",
                tabIndex: -1,
                ref: onContainerRef,
                isOpen: isAutocompleteOpen,
                usePopper: false,
                onBlur: onEditorViewBlur,
                onFocus: onEditorViewFocus,
                children: [
                    renderAutocompleteContent(),
                    renderLoadingFooter()
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpDm2.ScreenReaderText), {
                role: "status",
                "aria-live": "polite",
                children: announcedMessage
            })
        ]
    });
};
var $5f40dcbfd517299c$export$2e2bcd8739ae039 = $5f40dcbfd517299c$var$AutocompleteDropdown;

});
parcelRegister("hpDm2", function(module, exports) {
$parcel$export(module.exports, "ScreenReaderText", () => $5bd266327d9754cf$export$88fad6aa294f111c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lM09c = parcelRequire("lM09c");

var $aWILV = parcelRequire("aWILV");
const $5bd266327d9754cf$export$88fad6aa294f111c = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ei086710"
})((0, $lM09c.hiddenMixin));

});
parcelRegister("lM09c", function(module, exports) {
$parcel$export(module.exports, "hiddenMixin", () => $2a57fe79db07a28d$export$962299bb0027d6ec);
$parcel$export(module.exports, "TooltipContent", () => $2a57fe79db07a28d$export$e9003e2be37ec060);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $2a57fe79db07a28d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2a57fe79db07a28d$export$962299bb0027d6ec = {
    name: "1ixuqoh",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute"
};
const $2a57fe79db07a28d$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1oc6ghn0"
})({
    name: "1oabopy",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});


const $480e76317c70d1e5$export$ecb000296b5c29b4 = 'jql-editor-main';
const $480e76317c70d1e5$export$be6de605c287d65 = 'jql-editor-autocomplete';
const $480e76317c70d1e5$export$3f56b97ad9192f69 = 'jql-editor-input';
const $480e76317c70d1e5$export$e46ae403d4c79c56 = 'jql-editor-help-content';
const $480e76317c70d1e5$export$2d81723ade6fdc3a = 'jql-editor-validation';
const $480e76317c70d1e5$export$84b7d548dbd97842 = 'syntax-help-description';

parcelRegister("42FIa", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2cba5fb8410873ac$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2cba5fb8410873ac$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    optionsFound: {
        id: 'jql-editor.plugins.autocomplete.options-found',
        defaultMessage: 'Choose from the suggested list of options below.',
        description: 'This message is read by screen readers when autocomplete suggestions are available in the JQL editor.'
    }
});

});

parcelRegister("aOPUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $574dba83386af84f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jZ5x9 = parcelRequire("jZ5x9");

var $12DRg = parcelRequire("12DRg");

var $bpdtz = parcelRequire("bpdtz");

var $btkTq = parcelRequire("btkTq");

var $i5stJ = parcelRequire("i5stJ");

var $bAn7e = parcelRequire("bAn7e");

var $50VmZ = parcelRequire("50VmZ");

var $6J86O = parcelRequire("6J86O");

var $gNUuP = parcelRequire("gNUuP");

var $787ZT = parcelRequire("787ZT");

var $bwM92 = parcelRequire("bwM92");

var $8hNRj = parcelRequire("8hNRj");

var $h8zsn = parcelRequire("h8zsn");

var $k8Qe5 = parcelRequire("k8Qe5");

var $hklms = parcelRequire("hklms");

var $4enj2 = parcelRequire("4enj2");

var $1N2qK = parcelRequire("1N2qK");

var $gVXa7 = parcelRequire("gVXa7");

var $4MJB5 = parcelRequire("4MJB5");

var $fgerk = parcelRequire("fgerk");

var $iAPm4 = parcelRequire("iAPm4");

var $dmiLH = parcelRequire("dmiLH");


var $k71qx = parcelRequire("k71qx");

var $9IGks = parcelRequire("9IGks");

var $713Qz = parcelRequire("713Qz");

var $fxEXT = parcelRequire("fxEXT");
const $574dba83386af84f$var$ResizedIcon = ({ Icon: Icon, LegacyIcon: LegacyIcon })=>/*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        LEGACY_fallbackIcon: LegacyIcon,
        LEGACY_size: "small",
        label: "",
        testId: "jql-editor-field-type-icon",
        color: "currentColor"
    });
/**
 * List of types with supported icons is derived from GIN
 * Custom SVGs are provisional while we work on making field type icons consistent across Atlassian
 */ const $574dba83386af84f$var$getFieldTypeIcon = (type)=>{
    switch(type){
        case 'Checkboxes':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
                LegacyIcon: (0, $iAPm4.default)
            });
        case 'Date':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btkTq))),
                LegacyIcon: (0, $4enj2.default)
            });
        case 'Dropdown':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($50VmZ))),
                LegacyIcon: (0, $hklms.default)
            });
        case 'Labels':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($787ZT))),
                LegacyIcon: (0, $fgerk.default)
            });
        case 'Number':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bAn7e))),
                LegacyIcon: (0, $gVXa7.default)
            });
        case 'Paragraph':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))),
                LegacyIcon: (0, $k8Qe5.default)
            });
        case 'People':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNUuP))),
                LegacyIcon: (0, $4MJB5.default)
            });
        case 'Short text':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))),
                LegacyIcon: (0, $dmiLH.default)
            });
        case 'Time stamp':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($574dba83386af84f$var$ResizedIcon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))),
                LegacyIcon: (0, $1N2qK.default)
            });
        default:
            return null;
    }
};
const $574dba83386af84f$var$getHighlightPosition = (name, matchedText)=>{
    const normalizedName = (0, (/*@__PURE__*/$parcel$interopDefault($jZ5x9)))(name).toLowerCase();
    const normalizedMatchedText = (0, (/*@__PURE__*/$parcel$interopDefault($jZ5x9)))((0, $h8zsn.normaliseJqlString)(matchedText)).toLowerCase();
    const index = normalizedName.indexOf(normalizedMatchedText);
    if (index === -1) return null;
    return [
        index,
        index + normalizedMatchedText.length
    ];
};
const $574dba83386af84f$var$getDeprecatedTooltipMessage = (deprecatedSearcherKey)=>{
    switch(deprecatedSearcherKey){
        case 'com.pyxis.greenhopper.jira:gh-epic-link-searcher':
        case 'com.atlassian.jpo:jpo-custom-field-parent-searcher':
            return (0, $713Qz.messages).deprecatedFieldTooltipParentReplacementMessage;
        default:
            return (0, $713Qz.messages).deprecatedFieldTooltipDefaultMessage;
    }
};
const $574dba83386af84f$var$AutocompleteOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { option: { id: id, name: name, fieldType: fieldType, matchedText: matchedText, isDeprecated: isDeprecated = false, deprecatedSearcherKey: deprecatedSearcherKey }, isSelected: isSelected, onClick: onClick, onMouseMove: onMouseMove } = props;
    const [overflows, setOverflows] = (0, $eJOHy.useState)(false);
    const [{ formatMessage: formatMessage }] = (0, $9IGks.useIntl)();
    const onNameRef = (0, $eJOHy.useCallback)((node)=>{
        // This ref will be re-invoked after a tooltip is rendered, so we avoid recomputing the overflow in that instance
        // so we don't risk infinite re-renders (which we've observed through production logs).
        if (node != null && !overflows) setOverflows(node.offsetWidth < node.scrollWidth);
    }, [
        overflows
    ]);
    // TODO: verify type is i18n'd after integrating with GraphQL API
    const fieldTypeIcon = fieldType ? $574dba83386af84f$var$getFieldTypeIcon(fieldType) : null;
    const optionName = (0, $eJOHy.useMemo)(()=>{
        const highlightPosition = $574dba83386af84f$var$getHighlightPosition(name, matchedText);
        return highlightPosition ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fxEXT.OptionName), {
            ref: onNameRef,
            "aria-label": name,
            children: [
                name.substring(0, highlightPosition[0]),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fxEXT.OptionHighlight), {
                    children: name.substring(...highlightPosition)
                }),
                name.substring(highlightPosition[1])
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fxEXT.OptionName), {
            ref: onNameRef,
            children: name
        });
    }, [
        onNameRef,
        name,
        matchedText
    ]);
    const deprecatedTooltipContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fxEXT.TooltipContent), {
        children: formatMessage($574dba83386af84f$var$getDeprecatedTooltipMessage(deprecatedSearcherKey), {
            b: (text)=>/*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                    children: text
                }),
            received: name,
            parentReplacement: 'Parent'
        })
    });
    const ListItem = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fxEXT.OptionListItem), {
        id: id,
        "data-testid": "jql-editor-autocomplete-option",
        role: "option",
        isSelected: isSelected,
        isDeprecated: isDeprecated,
        onClick: isDeprecated ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : onClick,
        onMouseMove: isDeprecated ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : onMouseMove,
        ...ref && {
            ref: ref
        },
        "aria-selected": isSelected,
        children: [
            isDeprecated ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fxEXT.DeprecatedOptionContainer), {
                children: [
                    optionName,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: deprecatedTooltipContent,
                        position: 'right',
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J86O))), {
                            spacing: "spacious",
                            testId: "jql-editor-deprecated-icon",
                            label: "",
                            color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$eece5f492e429f08)})`
                        })
                    })
                ]
            }) : optionName,
            fieldType && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fxEXT.FieldType), {
                children: [
                    fieldTypeIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fxEXT.FieldTypeIcon), {
                        children: fieldTypeIcon
                    }),
                    fieldType
                ]
            })
        ]
    });
    const tooltipContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fxEXT.TooltipContent), {
        children: name
    });
    if (overflows) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        position: 'right',
        children: ListItem
    });
    return ListItem;
});
var $574dba83386af84f$export$2e2bcd8739ae039 = $574dba83386af84f$var$AutocompleteOption;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("bAn7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ce11e14058ccd074504e3c8591c7cbb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f4fccfbbb95621$var$_react = $86f4fccfbbb95621$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86f4fccfbbb95621$var$_baseNew = $86f4fccfbbb95621$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86f4fccfbbb95621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataNumber".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Representing number datatype fields in Proforma and databases.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86f4fccfbbb95621$var$DataNumberIcon = (props)=>/*#__PURE__*/ $86f4fccfbbb95621$var$_react.default.createElement($86f4fccfbbb95621$var$_baseNew.default, Object.assign({
        name: "DataNumberIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.75 4h2a.75.75 0 0 1 .75.75V12H2V5.5H.75zM5 4h3.13c.76 0 1.38.62 1.38 1.38v2c0 .76-.62 1.38-1.37 1.38H6.5v1.75h3V12H5.75a.75.75 0 0 1-.75-.75V8.63c0-.76.62-1.37 1.38-1.37H8V5.5H5zm6 0h3.13c.76 0 1.38.62 1.38 1.38v5.25c0 .76-.62 1.38-1.37 1.38H11v-1.5h3V8.75h-3v-1.5h3V5.5h-3z" clip-rule="evenodd"/>`
    }, props));
$86f4fccfbbb95621$var$DataNumberIcon.displayName = 'DataNumberIcon';
var $86f4fccfbbb95621$var$_default = module.exports.default = $86f4fccfbbb95621$var$DataNumberIcon;

});

parcelRegister("50VmZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9586fb5efe71b6941b8bd5aa4e67c1a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a69744c8bf0b664$var$_react = $3a69744c8bf0b664$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3a69744c8bf0b664$var$_baseNew = $3a69744c8bf0b664$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3a69744c8bf0b664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldDropdown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Dropdown field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a69744c8bf0b664$var$FieldDropdownIcon = (props)=>/*#__PURE__*/ $3a69744c8bf0b664$var$_react.default.createElement($3a69744c8bf0b664$var$_baseNew.default, Object.assign({
        name: "FieldDropdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 3.5H0V2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M9 8.19 7.03 6.22 5.97 7.28l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$3a69744c8bf0b664$var$FieldDropdownIcon.displayName = 'FieldDropdownIcon';
var $3a69744c8bf0b664$var$_default = module.exports.default = $3a69744c8bf0b664$var$FieldDropdownIcon;

});

parcelRegister("6J86O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be95c47a86ba406b4074b195e08f177d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5d3c47f79fd131$var$_react = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4e5d3c47f79fd131$var$_statusInformation = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("2R0ne")));

var $4e5d3c47f79fd131$var$_panel = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("1Sm4w")));
function $4e5d3c47f79fd131$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e5d3c47f79fd131$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $4e5d3c47f79fd131$var$_react.default.createElement($4e5d3c47f79fd131$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $4e5d3c47f79fd131$var$_panel.default
    }, props));
$4e5d3c47f79fd131$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $4e5d3c47f79fd131$var$_default = module.exports.default = $4e5d3c47f79fd131$var$StatusInformationIcon;

});
parcelRegister("1Sm4w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15dbf4a3ad51a12e$var$_react = $15dbf4a3ad51a12e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $15dbf4a3ad51a12e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $15dbf4a3ad51a12e$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $15dbf4a3ad51a12e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props));
$15dbf4a3ad51a12e$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $15dbf4a3ad51a12e$var$_default = module.exports.default = $15dbf4a3ad51a12e$var$EditorPanelIcon;

});


parcelRegister("787ZT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd85a061670900bca44ad5d1568ae5ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $530f7bdea5458957$var$_react = $530f7bdea5458957$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $530f7bdea5458957$var$_baseNew = $530f7bdea5458957$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $530f7bdea5458957$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $530f7bdea5458957$var$TagIcon = (props)=>/*#__PURE__*/ $530f7bdea5458957$var$_react.default.createElement($530f7bdea5458957$var$_baseNew.default, Object.assign({
        name: "TagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$530f7bdea5458957$var$TagIcon.displayName = 'TagIcon';
var $530f7bdea5458957$var$_default = module.exports.default = $530f7bdea5458957$var$TagIcon;

});

parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("8hNRj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4d05a25c478251d31315596858be41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $608696355e141648$var$_react = $608696355e141648$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $608696355e141648$var$_baseNew = $608696355e141648$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $608696355e141648$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $608696355e141648$var$TextIcon = (props)=>/*#__PURE__*/ $608696355e141648$var$_react.default.createElement($608696355e141648$var$_baseNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$608696355e141648$var$TextIcon.displayName = 'TextIcon';
var $608696355e141648$var$_default = module.exports.default = $608696355e141648$var$TextIcon;

});

parcelRegister("k8Qe5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddfa9e32e47f4d8c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $ddfa9e32e47f4d8c$var$AlignLeftIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __AlignLeftIcon__
 */ const $ddfa9e32e47f4d8c$var$AlignLeftIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $ddfa9e32e47f4d8c$var$AlignLeftIconGlyph
    });
var $ddfa9e32e47f4d8c$export$2e2bcd8739ae039 = $ddfa9e32e47f4d8c$var$AlignLeftIcon;

});

parcelRegister("hklms", function(module, exports) {
$parcel$export(module.exports, "default", () => $96f42570ac2ae4ee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $96f42570ac2ae4ee$var$ArrowDownCircleIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M12 19.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.65-5.268l2.44-2.463a.84.84 0 0 0 0-1.182.822.822 0 0 0-1.17 0l-1.916 1.93-1.922-1.939a.824.824 0 0 0-1.173 0 .842.842 0 0 0 0 1.183l2.45 2.47a.92.92 0 0 0 .649.269.9.9 0 0 0 .641-.268z",
            fill: "currentColor"
        })
    });
/**
 * __ArrowDownCircleIcon__
 */ const $96f42570ac2ae4ee$var$ArrowDownCircleIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $96f42570ac2ae4ee$var$ArrowDownCircleIconGlyph
    });
var $96f42570ac2ae4ee$export$2e2bcd8739ae039 = $96f42570ac2ae4ee$var$ArrowDownCircleIcon;

});

parcelRegister("4enj2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff6e1d568f643fa8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $ff6e1d568f643fa8$var$CalendarIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __CalendarIcon__
 */ const $ff6e1d568f643fa8$var$CalendarIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $ff6e1d568f643fa8$var$CalendarIconGlyph
    });
var $ff6e1d568f643fa8$export$2e2bcd8739ae039 = $ff6e1d568f643fa8$var$CalendarIcon;

});

parcelRegister("1N2qK", function(module, exports) {
$parcel$export(module.exports, "default", () => $74794c60d14445ad$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $74794c60d14445ad$var$ClockIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __ClockIcon__
 */ const $74794c60d14445ad$var$ClockIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $74794c60d14445ad$var$ClockIconGlyph
    });
var $74794c60d14445ad$export$2e2bcd8739ae039 = $74794c60d14445ad$var$ClockIcon;

});

parcelRegister("gVXa7", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d5d7c2ce33896e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $37d5d7c2ce33896e$var$DataNumberIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __DataNumberIcon__
 */ const $37d5d7c2ce33896e$var$DataNumberIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $37d5d7c2ce33896e$var$DataNumberIconGlyph
    });
var $37d5d7c2ce33896e$export$2e2bcd8739ae039 = $37d5d7c2ce33896e$var$DataNumberIcon;

});

parcelRegister("4MJB5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbabc7bb33e8fa74$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $fbabc7bb33e8fa74$var$PersonAvatarIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __PersonAvatarIcon__
 */ const $fbabc7bb33e8fa74$var$PersonAvatarIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $fbabc7bb33e8fa74$var$PersonAvatarIconGlyph
    });
var $fbabc7bb33e8fa74$export$2e2bcd8739ae039 = $fbabc7bb33e8fa74$var$PersonAvatarIcon;

});

parcelRegister("fgerk", function(module, exports) {
$parcel$export(module.exports, "default", () => $07824a3198104aa4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $07824a3198104aa4$var$TagIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __TagIcon__
 */ const $07824a3198104aa4$var$TagIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $07824a3198104aa4$var$TagIconGlyph
    });
var $07824a3198104aa4$export$2e2bcd8739ae039 = $07824a3198104aa4$var$TagIcon;

});

parcelRegister("iAPm4", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaedf0d4d61cc00b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $eaedf0d4d61cc00b$var$TaskIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
/**
 * __TaskIcon__
 */ const $eaedf0d4d61cc00b$var$TaskIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $eaedf0d4d61cc00b$var$TaskIconGlyph
    });
var $eaedf0d4d61cc00b$export$2e2bcd8739ae039 = $eaedf0d4d61cc00b$var$TaskIcon;

});

parcelRegister("dmiLH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7da6ef34023c5e60$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7da6ef34023c5e60$var$TextIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        viewBox: "0 0 24 24",
        focusable: "false",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
            fill: "currentColor"
        })
    });
/**
 * __TextIcon__
 */ const $7da6ef34023c5e60$var$TextIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'small', testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $7da6ef34023c5e60$var$TextIconGlyph
    });
var $7da6ef34023c5e60$export$2e2bcd8739ae039 = $7da6ef34023c5e60$var$TextIcon;

});

var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("713Qz", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6a5be16d52878648$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6a5be16d52878648$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deprecatedFieldTooltipDefaultMessage: {
        id: 'jql-editor.plugins.autocomplete.autocomplete-option.deprecated-tooltip.default',
        defaultMessage: 'This field has been deprecated and may stop working in the future.',
        description: 'Default tooltip message for a deprecated field.'
    },
    deprecatedFieldTooltipParentReplacementMessage: {
        id: 'jql-editor.plugins.autocomplete.autocomplete-option.deprecated-tooltip.epic-link',
        defaultMessage: "<b>''{received}''</b> will soon be replaced with <b>''{parentReplacement}''</b>. Use the <b>''{parentReplacement}''</b> field instead.",
        description: 'Tooltip message served to user when there is a deprecated field'
    }
});

});

parcelRegister("fxEXT", function(module, exports) {
$parcel$export(module.exports, "TooltipContent", () => $84100be5a69a6ef8$export$e9003e2be37ec060);
$parcel$export(module.exports, "OptionListItem", () => $84100be5a69a6ef8$export$e3368ad6f3de8539);
$parcel$export(module.exports, "OptionName", () => $84100be5a69a6ef8$export$70bb3d2793b2c20e);
$parcel$export(module.exports, "DeprecatedOptionContainer", () => $84100be5a69a6ef8$export$d09d629d055a5235);
$parcel$export(module.exports, "OptionHighlight", () => $84100be5a69a6ef8$export$18c07d6b2be0f164);
$parcel$export(module.exports, "FieldType", () => $84100be5a69a6ef8$export$ed12481c953b8653);
$parcel$export(module.exports, "FieldTypeIcon", () => $84100be5a69a6ef8$export$87c5289d8835f589);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
function $84100be5a69a6ef8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $84100be5a69a6ef8$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e19fwjs66"
})({
    name: "1oabopy",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $84100be5a69a6ef8$export$e3368ad6f3de8539 = /*#__PURE__*/ (0, $aWILV.default)("li", {
    target: "e19fwjs65"
})({
    cursor: 'pointer',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isSelected: isSelected })=>isSelected && {
        background: `var(--ds-background-neutral-subtle-hovered, ${0, $7bb4c1736002a04a$export$9fdfb749e33cdf97})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isDeprecated: isDeprecated })=>isDeprecated && {
        cursor: 'default',
        color: `var(--ds-text-disabled, ${0, $7bb4c1736002a04a$export$8754fc7e6d8b3000})`
    });
const $84100be5a69a6ef8$export$70bb3d2793b2c20e = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e19fwjs64"
})({
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // Added so that overflowed option names do not squish the deprecated info icon
    flex: 1
});
const $84100be5a69a6ef8$export$d09d629d055a5235 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e19fwjs63"
})({
    color: `var(--ds-text-disabled, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`,
    display: 'flex',
    justifyContent: 'space-between',
    opacity: 0.6
});
const $84100be5a69a6ef8$export$18c07d6b2be0f164 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e19fwjs62"
})({
    name: "zh3azs",
    styles: "font-weight:var(--ds-font-weight-bold, 700)"
});
const $84100be5a69a6ef8$export$ed12481c953b8653 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e19fwjs61"
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: "var(--ds-space-negative-025, -2px)",
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`
});
const $84100be5a69a6ef8$export$87c5289d8835f589 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e19fwjs60"
})({
    name: "15quk7w",
    styles: "display:flex;margin-right:var(--ds-space-050, 4px)"
});

});


parcelRegister("iSAQy", function(module, exports) {
$parcel$export(module.exports, "AutocompleteContainer", () => $05385b7dd2e0c215$export$7282d2260172d3da);
$parcel$export(module.exports, "AutocompleteOptionsContainer", () => $05385b7dd2e0c215$export$995b5ada947076b1);
$parcel$export(module.exports, "OptionList", () => $05385b7dd2e0c215$export$6c7d1e2ecefc0a19);
$parcel$export(module.exports, "AutocompleteLoadingFooter", () => $05385b7dd2e0c215$export$7c05ed73e960d685);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $IW7jS = parcelRequire("IW7jS");

var $aWILV = parcelRequire("aWILV");
function $05385b7dd2e0c215$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $05385b7dd2e0c215$export$7282d2260172d3da = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ewqprav3"
})({
    position: 'absolute',
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-radius-small, 3px)",
    willChange: 'top, left',
    zIndex: (0, $IW7jS.layers).dialog(),
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-0, 0)"}`,
    minWidth: '200px',
    maxWidth: '400px',
    '&:focus': {
        outline: 'none'
    },
    marginLeft: "var(--ds-space-negative-100, -8px)",
    marginTop: "var(--ds-space-200, 16px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
({ isOpen: isOpen })=>isOpen ? {
        visibility: 'visible'
    } : {
        visibility: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
({ usePopper: usePopper })=>usePopper && {
        marginTop: "var(--ds-space-100, 8px)"
    });
const $05385b7dd2e0c215$export$995b5ada947076b1 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ewqprav2"
})({
    name: "1g6z03h",
    styles: "max-height:288px;overflow:auto"
});
const $05385b7dd2e0c215$export$6c7d1e2ecefc0a19 = /*#__PURE__*/ (0, $aWILV.default)("ul", {
    target: "ewqprav1"
})({
    listStyle: 'none',
    margin: `${"var(--ds-space-0, 0)"}`,
    padding: `${"var(--ds-space-0, 0)"}`
});
const $05385b7dd2e0c215$export$7c05ed73e960d685 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ewqprav0"
})({
    display: 'flex',
    justifyContent: 'center',
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
    fontStyle: 'italic',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ hasOptions: hasOptions })=>hasOptions && {
        borderTop: `solid 1px ${`var(--ds-border, ${0, $7bb4c1736002a04a$export$1ce2d1575d444ceb})`}`,
        marginTop: "var(--ds-space-075, 6px)",
        paddingTop: "var(--ds-space-250, 20px)"
    });

});





parcelRegister("3HQ0y", function(module, exports) {
$parcel$export(module.exports, "getJastFromState", () => $cc6b7602712dee13$export$c1a05ed9420ab131);
$parcel$export(module.exports, "default", () => $cc6b7602712dee13$export$2e2bcd8739ae039);

var $3lIcL = parcelRequire("3lIcL");

var $9qsUT = parcelRequire("9qsUT");

var $j3U9J = parcelRequire("j3U9J");

var $iEqTv = parcelRequire("iEqTv");
const $cc6b7602712dee13$var$JQLAstPluginKey = new (0, $3lIcL.PluginKey)('jql-ast-plugin');
const $cc6b7602712dee13$export$c1a05ed9420ab131 = (state)=>{
    const jast = $cc6b7602712dee13$var$JQLAstPluginKey.getState(state);
    // This should never happen as the JQLAstPlugin will always be configured but we'll handle this case anyway to keep TS happy.
    if (jast == null) {
        // eslint-disable-next-line no-console
        console.error('Unable to get state from the JQLAstPlugin as it has not been configured.');
        return {
            query: undefined,
            represents: '',
            errors: []
        };
    }
    return jast;
};
const $cc6b7602712dee13$var$jqlAstPlugin = (intlRef)=>{
    const jastBuilder = new (0, $9qsUT.JastBuilder)().setErrorHandler(new (0, $iEqTv.default)(intlRef));
    return new (0, $3lIcL.Plugin)({
        key: $cc6b7602712dee13$var$JQLAstPluginKey,
        state: {
            init: (_, { doc: doc })=>{
                return jastBuilder.build((0, $j3U9J.getNodeText)(doc, 0, doc.content.size));
            },
            // @ts-ignore
            apply: (tr, value, oldState)=>{
                const text = (0, $j3U9J.getNodeText)(tr.doc, 0, tr.doc.content.size);
                const oldText = (0, $j3U9J.getNodeText)(oldState.doc, 0, oldState.doc.content.size);
                // Only update the AST if textContent has changed
                return text !== oldText ? jastBuilder.build(text) : value;
            }
        }
    });
};
var $cc6b7602712dee13$export$2e2bcd8739ae039 = $cc6b7602712dee13$var$jqlAstPlugin;

});
parcelRegister("j3U9J", function(module, exports) {
$parcel$export(module.exports, "getNodeText", () => $4e174f724fdcfd72$export$4df7572681026e66);
$parcel$export(module.exports, "getFragmentText", () => $4e174f724fdcfd72$export$8201a931e479d714);
const $4e174f724fdcfd72$export$4df7572681026e66 = (node, from, to)=>{
    return $4e174f724fdcfd72$export$8201a931e479d714(node.content, from, to);
};
const $4e174f724fdcfd72$export$8201a931e479d714 = (fragment, from, to)=>{
    return $4e174f724fdcfd72$var$textBetween(fragment, from, to, '\n');
};
/**
 * A modified version of {@link Fragment#textBetween}. The default implementation does not insert `blockSeparator` for
 * consecutive empty block nodes (i.e. empty blocks are collapsed into one).
 */ const $4e174f724fdcfd72$var$textBetween = (fragment, from, to, blockSeparator, leafText)=>{
    let text = '';
    let enteredInitialBlock = false;
    fragment.nodesBetween(from, to, (innerNode, pos)=>{
        if (innerNode.isText) text += innerNode.text?.slice(Math.max(from, pos) - pos, to - pos);
        else if (innerNode.isLeaf && leafText) text += leafText;
        else if (innerNode.isBlock) {
            if (enteredInitialBlock) text += blockSeparator;
            else enteredInitialBlock = true;
        }
    }, 0);
    return text;
};

});

parcelRegister("iEqTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ec79620f7ad0377$export$2e2bcd8739ae039);

var $jz1xX = parcelRequire("jz1xX");

var $ZDIGd = parcelRequire("ZDIGd");

var $h8zsn = parcelRequire("h8zsn");

var $dEBM2 = parcelRequire("dEBM2");

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");

var $6PXs7 = parcelRequire("6PXs7");

var $8bZ1Q = parcelRequire("8bZ1Q");

var $k9cJb = parcelRequire("k9cJb");

var $fLEh0 = parcelRequire("fLEh0");

var $yDZkq = parcelRequire("yDZkq");

var $35FrL = parcelRequire("35FrL");

var $gMF29 = parcelRequire("gMF29");

var $6av2Q = parcelRequire("6av2Q");

var $lL9v9 = parcelRequire("lL9v9");

var $8m75h = parcelRequire("8m75h");
const $0ec79620f7ad0377$var$isEscape = (char)=>char === '\\';
const $0ec79620f7ad0377$export$4e2300c749487ef6 = (char)=>{
    const hex = char.charCodeAt(0).toString(16).toUpperCase();
    return `U+${(0, (/*@__PURE__*/$parcel$interopDefault($ZDIGd)))(hex, 4, '0')}`;
};
const $0ec79620f7ad0377$export$d5f1e69cf4f1e8fe = (char)=>{
    const hex = char.charCodeAt(0).toString(16);
    return `\\u${(0, (/*@__PURE__*/$parcel$interopDefault($ZDIGd)))(hex, 4, '0')}`;
};
class $0ec79620f7ad0377$export$2e2bcd8739ae039 extends (0, $jz1xX.DefaultErrorStrategy) {
    constructor(intlRef){
        super();
        this.intlRef = intlRef;
    }
    reportInputMismatch(recognizer, exception) {
        this.handleSyntaxError(recognizer, recognizer.currentToken, exception);
    }
    reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        this.handleSyntaxError(recognizer, recognizer.currentToken);
    }
    reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        // This is called when single token insertion is a viable recovery strategy for the error. In this case we can
        // use expected tokens from the parser to display an error to the user. If there are no viable tokens to show then
        // we should fallback to syntax error handling.
        if ((0, $8m75h.getExpectedTokensFromParserOrException)(recognizer).length > 0) {
            const message = (0, $k9cJb.handleExpectedTokensError)(recognizer, recognizer.currentToken, // We want to derive expectedTokens from the parser state
            [], this.intlRef.current);
            recognizer.notifyErrorListeners(message, recognizer.currentToken, undefined);
        } else this.handleSyntaxError(recognizer, recognizer.currentToken);
    }
    reportNoViableAlternative(recognizer, exception) {
        // There are some cases, like "status was", where parser is unable to provide viable alternatives for current
        // token, but autocomplete engine is still able to provide meaningful suggestions at offending token index
        const currentToken = exception?.getOffendingToken() ?? recognizer.currentToken;
        this.handleSyntaxError(recognizer, currentToken, exception);
    }
    reportFailedPredicate(recognizer, e) {
        // TODO: Don't know how to produce this error. Monitor if this happens and defer to default implementation
        super.reportFailedPredicate(recognizer, e);
    }
    handleSyntaxError(recognizer, currentToken, exception) {
        let message;
        switch(currentToken.type){
            /*
			 * This is called when ANTLR finds a character that the grammar does not recognise. The grammar lexer uses
			 * a DFA to decide if a character is in error or not. This can mean that legal characters come as an error
			 * because they do not form a valid token. Because of this we have to do some extra checks here.
			 */ case (0, $bFJ48.JQLLexer).ERRORCHAR:
            case (0, $bFJ48.JQLLexer).INVALID_QUOTE_STRING:
            case (0, $bFJ48.JQLLexer).INVALID_SQUOTE_STRING:
                {
                    let currentText = currentToken.text;
                    // These tokens are returned when an illegal character appears at the end of a quote string, but the token
                    // includes the entire quoted text. We take the last character from our text as that's the offending token.
                    if (currentToken.type === (0, $bFJ48.JQLLexer).INVALID_QUOTE_STRING || currentToken.type === (0, $bFJ48.JQLLexer).INVALID_SQUOTE_STRING) currentText = currentText?.slice(-1);
                    // This can happen (e.g. comment ~ \)
                    if ($0ec79620f7ad0377$var$isEscape(currentText)) {
                        const nextToken = recognizer.inputStream.get(currentToken.tokenIndex + 1);
                        if (nextToken.type === (0, $bFJ48.JQLLexer).MATCHWS || nextToken.type === (0, $bFJ48.JQLLexer).EOF) message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).illegalEscapeBlank);
                        else {
                            // Show the escaped character sequence in the message
                            const received = `${currentText ?? ''}${nextToken.text ?? ''}`;
                            message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).illegalEscape, {
                                received: received
                            });
                        }
                    } else message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).illegalChar, {
                        char: $0ec79620f7ad0377$export$4e2300c749487ef6(currentText ?? ''),
                        escapedChar: $0ec79620f7ad0377$export$d5f1e69cf4f1e8fe(currentText ?? '')
                    });
                    break;
                }
            // Special tokens that get created every time there is an unfinished string (i.e. without matching closing quote)
            case (0, $bFJ48.JQLLexer).UNCLOSED_QUOTE_STRING:
            case (0, $bFJ48.JQLLexer).UNCLOSED_SQUOTE_STRING:
                {
                    const received = (0, $h8zsn.normaliseJqlString)(currentToken.text ?? '');
                    if (received === '') message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).unfinishedStringBlank);
                    else message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).unfinishedString, {
                        received: received
                    });
                    break;
                }
            case (0, $bFJ48.JQLLexer).RESERVED_WORD:
                message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).reservedWord, {
                    word: currentToken.text
                });
                break;
            case (0, $bFJ48.JQLLexer).ERROR_RESERVED:
                message = this.intlRef.current.formatMessage((0, $lL9v9.errorMessages).reservedChar, {
                    char: currentToken.text,
                    escapedChar: $0ec79620f7ad0377$export$d5f1e69cf4f1e8fe(currentToken.text ?? '')
                });
                break;
            default:
                {
                    const autocomplete = (0, $dEBM2.JQLAutocomplete).fromParser(recognizer, (0, $6PXs7.ignoredTokens), (0, $6PXs7.preferredRules), new Set());
                    const { tokens: tokens, rules: rules } = autocomplete.getJQLSuggestionsForTokenIndex(currentToken.tokenIndex);
                    if (rules.value || rules.list || // Restrict function rules to only be shown if we are currently INSIDE a function rule. Otherwise this error
                    // message would be shown for incomplete tokens following an operand, e.g. `status = open ord`.
                    rules.function && recognizer.context.ruleIndex === (0, $41LBU.JQLParser).RULE_jqlFunction) message = (0, $gMF29.handleOperandRuleError)(recognizer, currentToken, tokens.values, rules, this.intlRef.current, exception);
                    else if (tokens.values.includes('EMPTY')) message = (0, $k9cJb.handleExpectedTokensError)(recognizer, currentToken, tokens.values, this.intlRef.current, exception);
                    else if (rules.operator) message = (0, $6av2Q.handleOperatorRuleError)(currentToken, this.intlRef.current);
                    else if (rules.field) message = (0, $yDZkq.handleFieldRuleError)(currentToken, this.intlRef.current);
                    else if (rules.customField) message = (0, $8bZ1Q.handleCustomFieldRuleError)(this.intlRef.current);
                    else if (rules.fieldProperty && recognizer.context.ruleIndex === (0, $41LBU.JQLParser).RULE_jqlFieldProperty) // Shows the correct message when a field property rule hasn't been completed, e.g. `issuetype[abc!`
                    message = (0, $k9cJb.handleExpectedTokensError)(recognizer, currentToken, // We want to derive expectedTokens from the exception/parser state
                    [], this.intlRef.current, exception);
                    else if (rules.fieldPropertyId) message = (0, $fLEh0.handleFieldPropertyIdRuleError)(currentToken, this.intlRef.current);
                    else if (rules.functionArgument) message = (0, $35FrL.handleFunctionArgumentRuleError)(currentToken, this.intlRef.current);
                    else message = (0, $k9cJb.handleExpectedTokensError)(recognizer, currentToken, tokens.values, this.intlRef.current, exception);
                    break;
                }
        }
        recognizer.notifyErrorListeners(message, currentToken, undefined);
    }
}

});
parcelRegister("ZDIGd", function(module, exports) {

var $6lakZ = parcelRequire("6lakZ");

var $esCHN = parcelRequire("esCHN");

var $c9FP3 = parcelRequire("c9FP3");

var $cz1WF = parcelRequire("cz1WF");
/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */ function $0b94821d333e3376$var$padStart(string, length, chars) {
    string = $cz1WF(string);
    length = $c9FP3(length);
    var strLength = length ? $esCHN(string) : 0;
    return length && strLength < length ? $6lakZ(length - strLength, chars) + string : string;
}
module.exports = $0b94821d333e3376$var$padStart;

});
parcelRegister("6lakZ", function(module, exports) {

var $eabRX = parcelRequire("eabRX");

var $wkcOI = parcelRequire("wkcOI");

var $j4Djm = parcelRequire("j4Djm");

var $beeZR = parcelRequire("beeZR");

var $esCHN = parcelRequire("esCHN");

var $gsm7J = parcelRequire("gsm7J");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $49dcb913cce4ec95$var$nativeCeil = Math.ceil;
/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */ function $49dcb913cce4ec95$var$createPadding(length, chars) {
    chars = chars === undefined ? ' ' : $wkcOI(chars);
    var charsLength = chars.length;
    if (charsLength < 2) return charsLength ? $eabRX(chars, length) : chars;
    var result = $eabRX(chars, $49dcb913cce4ec95$var$nativeCeil(length / $esCHN(chars)));
    return $beeZR(chars) ? $j4Djm($gsm7J(result), 0, length).join('') : result.slice(0, length);
}
module.exports = $49dcb913cce4ec95$var$createPadding;

});
parcelRegister("eabRX", function(module, exports) {
/** Used as references for various `Number` constants. */ var $a4fb34d81a0e51c8$var$MAX_SAFE_INTEGER = 9007199254740991;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a4fb34d81a0e51c8$var$nativeFloor = Math.floor;
/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */ function $a4fb34d81a0e51c8$var$baseRepeat(string, n) {
    var result = '';
    if (!string || n < 1 || n > $a4fb34d81a0e51c8$var$MAX_SAFE_INTEGER) return result;
    // Leverage the exponentiation by squaring algorithm for a faster repeat.
    // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
    do {
        if (n % 2) result += string;
        n = $a4fb34d81a0e51c8$var$nativeFloor(n / 2);
        if (n) string += string;
    }while (n);
    return result;
}
module.exports = $a4fb34d81a0e51c8$var$baseRepeat;

});

parcelRegister("esCHN", function(module, exports) {

var $cVaIZ = parcelRequire("cVaIZ");

var $beeZR = parcelRequire("beeZR");

var $dsEqJ = parcelRequire("dsEqJ");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $a871b4482705c524$var$stringSize(string) {
    return $beeZR(string) ? $dsEqJ(string) : $cVaIZ(string);
}
module.exports = $a871b4482705c524$var$stringSize;

});
parcelRegister("cVaIZ", function(module, exports) {

var $9U1Ux = parcelRequire("9U1Ux");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9683209b72c5c382$var$asciiSize = $9U1Ux('length');
module.exports = $9683209b72c5c382$var$asciiSize;

});

parcelRegister("dsEqJ", function(module, exports) {
/** Used to compose unicode character classes. */ var $9ccd4073599dd88e$var$rsAstralRange = '\\ud800-\\udfff', $9ccd4073599dd88e$var$rsComboMarksRange = '\\u0300-\\u036f', $9ccd4073599dd88e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9ccd4073599dd88e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9ccd4073599dd88e$var$rsComboRange = $9ccd4073599dd88e$var$rsComboMarksRange + $9ccd4073599dd88e$var$reComboHalfMarksRange + $9ccd4073599dd88e$var$rsComboSymbolsRange, $9ccd4073599dd88e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $9ccd4073599dd88e$var$rsAstral = '[' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsCombo = '[' + $9ccd4073599dd88e$var$rsComboRange + ']', $9ccd4073599dd88e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9ccd4073599dd88e$var$rsModifier = '(?:' + $9ccd4073599dd88e$var$rsCombo + '|' + $9ccd4073599dd88e$var$rsFitz + ')', $9ccd4073599dd88e$var$rsNonAstral = '[^' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9ccd4073599dd88e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9ccd4073599dd88e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9ccd4073599dd88e$var$reOptMod = $9ccd4073599dd88e$var$rsModifier + '?', $9ccd4073599dd88e$var$rsOptVar = '[' + $9ccd4073599dd88e$var$rsVarRange + ']?', $9ccd4073599dd88e$var$rsOptJoin = '(?:' + $9ccd4073599dd88e$var$rsZWJ + '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair
].join('|') + ')' + $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + ')*', $9ccd4073599dd88e$var$rsSeq = $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + $9ccd4073599dd88e$var$rsOptJoin, $9ccd4073599dd88e$var$rsSymbol = '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral + $9ccd4073599dd88e$var$rsCombo + '?',
    $9ccd4073599dd88e$var$rsCombo,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair,
    $9ccd4073599dd88e$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $9ccd4073599dd88e$var$reUnicode = RegExp($9ccd4073599dd88e$var$rsFitz + '(?=' + $9ccd4073599dd88e$var$rsFitz + ')|' + $9ccd4073599dd88e$var$rsSymbol + $9ccd4073599dd88e$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $9ccd4073599dd88e$var$unicodeSize(string) {
    var result = $9ccd4073599dd88e$var$reUnicode.lastIndex = 0;
    while($9ccd4073599dd88e$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $9ccd4073599dd88e$var$unicodeSize;

});




parcelRegister("6PXs7", function(module, exports) {
$parcel$export(module.exports, "ignoredTokens", () => $10e0b98ffd00a961$export$eec1cc2a022e1949);
$parcel$export(module.exports, "preferredRules", () => $10e0b98ffd00a961$export$180228f03418b543);
$parcel$export(module.exports, "lowPriorityTokens", () => $10e0b98ffd00a961$export$e26f7a13758dbfe3);

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");
const $10e0b98ffd00a961$export$eec1cc2a022e1949 = new Set([
    (0, $bFJ48.JQLLexer).EOF,
    (0, $bFJ48.JQLLexer).LPAREN,
    (0, $bFJ48.JQLLexer).LBRACKET,
    (0, $bFJ48.JQLLexer).STRING,
    (0, $bFJ48.JQLLexer).QUOTE_STRING,
    (0, $bFJ48.JQLLexer).SQUOTE_STRING,
    (0, $bFJ48.JQLLexer).POSNUMBER,
    (0, $bFJ48.JQLLexer).NEGNUMBER,
    (0, $bFJ48.JQLLexer).BANG,
    (0, $bFJ48.JQLLexer).CUSTOMFIELD
]);
const $10e0b98ffd00a961$export$180228f03418b543 = new Set([
    (0, $41LBU.JQLParser).RULE_jqlField,
    (0, $41LBU.JQLParser).RULE_jqlFieldProperty,
    (0, $41LBU.JQLParser).RULE_jqlEqualsOperator,
    (0, $41LBU.JQLParser).RULE_jqlLikeOperator,
    (0, $41LBU.JQLParser).RULE_jqlComparisonOperator,
    (0, $41LBU.JQLParser).RULE_jqlInOperator,
    (0, $41LBU.JQLParser).RULE_jqlIsOperator,
    (0, $41LBU.JQLParser).RULE_jqlWasOperator,
    (0, $41LBU.JQLParser).RULE_jqlWasInOperator,
    (0, $41LBU.JQLParser).RULE_jqlChangedOperator,
    (0, $41LBU.JQLParser).RULE_jqlValue,
    (0, $41LBU.JQLParser).RULE_jqlListStart,
    (0, $41LBU.JQLParser).RULE_jqlFunction,
    (0, $41LBU.JQLParser).RULE_jqlCustomField,
    // Produces rules for fieldPropertyId, fieldPropertyArgument and functionArgument
    (0, $41LBU.JQLParser).RULE_jqlArgument
]);
const $10e0b98ffd00a961$export$e26f7a13758dbfe3 = [
    (0, $bFJ48.JQLLexer).RPAREN,
    (0, $bFJ48.JQLLexer).RBRACKET,
    (0, $bFJ48.JQLLexer).COMMA
];

});

parcelRegister("8bZ1Q", function(module, exports) {
$parcel$export(module.exports, "handleCustomFieldRuleError", () => $ce9f338bc7704784$export$7f0bc19dab2c2c7);

var $lL9v9 = parcelRequire("lL9v9");
const $ce9f338bc7704784$export$7f0bc19dab2c2c7 = (intl)=>{
    return intl.formatMessage((0, $lL9v9.errorMessages).expectingCustomFieldId);
};

});
parcelRegister("lL9v9", function(module, exports) {
$parcel$export(module.exports, "errorMessages", () => $b48d41a1ca8f9292$export$d8bd0967cb58683);

var $7qGN1 = parcelRequire("7qGN1");
const $b48d41a1ca8f9292$export$d8bd0967cb58683 = (0, $7qGN1.defineMessages)({
    expectingOperatorButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingOperatorButReceived',
        defaultMessage: "Expecting an operator but got ''{received}''. The valid operators are '=', '!=', '<', '>', '<=', '>=', '~', '!~', 'IN', 'NOT IN', 'IS' and 'IS NOT'.",
        description: 'When an operator was expected but another token was received.'
    },
    expectingOperatorBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingOperatorBeforeEOF',
        defaultMessage: "Expecting an operator before the end of the query. The valid operators are '=', '!=', '<', '>', '<=', '>=', '~', '!~', 'IN', 'NOT IN', 'IS' and 'IS NOT'.",
        description: 'When an operator was expected before the end of the query.'
    },
    expectingFieldButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFieldButReceived',
        defaultMessage: "Expecting a field name but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a field name.",
        description: 'When a field was expected but another token was received.'
    },
    expectingFieldBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFieldBeforeEOF',
        defaultMessage: 'Expecting a field name before the end of the query.',
        description: 'When a field was expected before the end of the query.'
    },
    expectingCFButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingCFButReceived',
        defaultMessage: "Expecting a field name but got '['. Did you mean 'cf['?",
        description: `When a field was expected but a left bracket was received without a 'cf' prefix.`
    },
    expectingCustomFieldId: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingCustomFieldId',
        defaultMessage: `Expecting a custom field id enclosed by '[ ]' after 'cf'. Example: 'cf[10021]'.`,
        description: 'When a custom field id was expected before the end of the query. Text wrapped in single quotes in our message refer to specific tokens in the query so they should not be translated.'
    },
    expectingOperandButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingOperandButReceived',
        defaultMessage: "Expecting either a value, list or function but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When an operand was expected but another token was received.'
    },
    expectingOperandBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingOperandBeforeEOF',
        defaultMessage: 'Expecting either a value, list or function before the end of the query.',
        description: 'When an operand was expected before the end of the query.'
    },
    expectingValueOrFunctionButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingValueOrFunctionButReceived',
        defaultMessage: "Expecting a value or function but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a value or function was expected but another token was received.'
    },
    expectingValueOrFunctionBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingValueOrFunctionBeforeEOF',
        defaultMessage: 'Expecting a value or function before the end of the query.',
        description: 'When a value or function was expected before the end of the query.'
    },
    expectingListOrFunctionButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingListOrFunctionButReceived',
        defaultMessage: "Expecting a list or function but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a list or function was expected but another token was received.'
    },
    expectingListOrFunctionBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingListOrFunctionBeforeEOF',
        defaultMessage: 'Expecting a list or function before the end of the query.',
        description: 'When a list or function was expected before the end of the query.'
    },
    expectingValueButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingValueButReceived',
        defaultMessage: "Expecting a value but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a value was expected but another token was received.'
    },
    expectingValueBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingValueBeforeEOF',
        defaultMessage: 'Expecting a value before the end of the query.',
        description: 'When a value was expected before the end of the query.'
    },
    expectingListButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingListButReceived',
        defaultMessage: "Expecting a list but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a list was expected but another token was received.'
    },
    expectingListBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingListBeforeEOF',
        defaultMessage: 'Expecting a list before the end of the query.',
        description: 'When a list was expected before the end of the query.'
    },
    expectingFunctionButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFunctionButReceived',
        defaultMessage: "Expecting a function but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a function was expected but another token was received.'
    },
    expectingFunctionBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFunctionBeforeEOF',
        defaultMessage: 'Expecting a function before the end of the query.',
        description: 'When a function was expected before the end of the query.'
    },
    expectingFieldPropertyIdButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFieldPropertyIdButReceived',
        defaultMessage: "Expecting a property id but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a field property ID was expected but another token was received.'
    },
    expectingFieldPropertyIdBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFieldPropertyIdBeforeEOF',
        defaultMessage: 'Expecting a property id before the end of the query.',
        description: 'When a field property ID was expected before the end of the query.'
    },
    expectingFunctionArgButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFunctionArgButReceived',
        defaultMessage: "Expecting a function argument but got ''{received}''. You must surround ''{received}'' in quotation marks to use it as a value.",
        description: 'When a function argument was expected but another token was received.'
    },
    expectingFunctionArgBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingFunctionArgBeforeEOF',
        defaultMessage: 'Expecting a function argument before the end of the query.',
        description: 'When a function argument was expected before the end of the query.'
    },
    expectingMultipleTokensButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingMultipleTokensButReceived',
        defaultMessage: "Expecting {firstExpectedTokens} or ''{lastExpectedToken}'' but got ''{received}''.",
        description: 'When the text the user entered does not match any of the expected tokens.'
    },
    expectingMultipleTokensBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingMultipleTokensBeforeEOF',
        defaultMessage: "Expecting {firstExpectedTokens} or ''{lastExpectedToken}'' before the end of the query.",
        description: 'When there are still tokens expected before the query can end.'
    },
    expectingTokenButReceived: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingTokenButReceived',
        defaultMessage: "Expecting ''{expectedToken}'' but got ''{received}''.",
        description: 'When the text the user entered does not match the expected tokens.'
    },
    expectingTokenBeforeEOF: {
        id: 'jql-editor.plugins.jql-ast.error-messages.expectingTokenBeforeEOF',
        defaultMessage: "Expecting ''{expectedToken}'' before the end of the query.",
        description: 'When an expected token needs to be inserted before the query can end.'
    },
    unknownErrorAtToken: {
        id: 'jql-editor.plugins.jql-ast.error-messages.unknownErrorAtToken',
        defaultMessage: "Unable to parse the query at ''{received}''.",
        description: 'When the query could not be parsed when a token was reached.'
    },
    reservedChar: {
        id: 'jql-editor.plugins.jql-ast.error-messages.reservedChar',
        defaultMessage: "The character ''{char}'' is a reserved JQL character. You must enclose it in a string or use the escape ''{escapedChar}'' instead.",
        description: 'When the user has a reserved character in the query.'
    },
    reservedWord: {
        id: 'jql-editor.plugins.jql-ast.error-messages.reservedWord',
        defaultMessage: "''{word}'' is a reserved JQL word. You must surround it in quotation marks to use it in a query.",
        description: 'When the user has a reserved word in the query.'
    },
    unfinishedString: {
        id: 'jql-editor.plugins.jql-ast.error-messages.unfinishedString',
        defaultMessage: `The quoted string ''{received}'' has not been completed.`,
        description: 'When a string is missing an opening or closing quote.'
    },
    unfinishedStringBlank: {
        id: 'jql-editor.plugins.jql-ast.error-messages.unfinishedStringBlank',
        defaultMessage: 'The quoted string has not been completed.',
        description: 'When a string is missing an opening or closing quote.'
    },
    illegalEscape: {
        id: 'jql-editor.plugins.jql-ast.error-messages.illegalEscape',
        defaultMessage: `''{received}'' is an illegal JQL escape sequence. The valid escape sequences are \u005C', \u005C", \u005Ct, \u005Cn, \u005Cr, \u005C\u005C, '\u005C ' and \u005CuXXXX.`,
        description: 'When there are no valid tokens following an escape character.'
    },
    illegalEscapeBlank: {
        id: 'jql-editor.plugins.jql-ast.error-messages.illegalEscapeBlank',
        defaultMessage: `The escape sequence has not been completed. The valid escape sequences are \u005C', \u005C", \u005Ct, \u005Cn, \u005Cr, \u005C\u005C, '\u005C ' and \u005CuXXXX.`,
        description: 'When there are no valid tokens following an escape character.'
    },
    illegalChar: {
        id: 'jql-editor.plugins.jql-ast.error-messages.illegalChar',
        defaultMessage: "The character ''{char}'' must be escaped. Use the escape ''{escapedChar}'' instead.",
        description: 'When an illegal character is encountered in a query.'
    }
});

});


parcelRegister("k9cJb", function(module, exports) {
$parcel$export(module.exports, "handleExpectedTokensError", () => $4b948aad4f5ca232$export$e4c17c5a30efba5b);

var $bFJ48 = parcelRequire("bFJ48");

var $1R5KR = parcelRequire("1R5KR");

var $6PXs7 = parcelRequire("6PXs7");

var $lL9v9 = parcelRequire("lL9v9");

var $8m75h = parcelRequire("8m75h");
const $4b948aad4f5ca232$export$e4c17c5a30efba5b = (recognizer, currentToken, expectedTokens, intl, exception)=>{
    // If there are no expected autocomplete tokens, then attempt to find viable tokens from the exception/parser.
    if (expectedTokens.length === 0) expectedTokens = (0, $8m75h.getTokenDisplayNames)(recognizer, (0, $8m75h.getExpectedTokensFromParserOrException)(recognizer, exception));
    const lowPriorityTokenNames = (0, $8m75h.getTokenDisplayNames)(recognizer, (0, $6PXs7.lowPriorityTokens));
    // Only include tokens that are NOT low priority
    const highPriorityTokens = expectedTokens.filter((tokenType)=>!lowPriorityTokenNames.includes(tokenType));
    // If we have any tokens that are high priority then we want to show them (without low priority suggestions).
    if (highPriorityTokens.length > 0) expectedTokens = highPriorityTokens;
    const isEOF = currentToken.type === (0, $bFJ48.JQLLexer).EOF;
    if (expectedTokens.length > 1) {
        const firstExpectedTokens = expectedTokens.slice(0, -1)// Need to wrap tokens in single quotes ourselves as we cannot do it in the message descriptor
        .map((token)=>`'${token}'`).join(', ');
        const lastExpectedToken = expectedTokens[expectedTokens.length - 1];
        return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingMultipleTokensBeforeEOF, {
            firstExpectedTokens: firstExpectedTokens,
            lastExpectedToken: lastExpectedToken
        }) : intl.formatMessage((0, $lL9v9.errorMessages).expectingMultipleTokensButReceived, {
            firstExpectedTokens: firstExpectedTokens,
            lastExpectedToken: lastExpectedToken,
            received: currentToken.text
        });
    } else if (expectedTokens.length === 1) return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingTokenBeforeEOF, {
        expectedToken: expectedTokens[0]
    }) : intl.formatMessage((0, $lL9v9.errorMessages).expectingTokenButReceived, {
        expectedToken: expectedTokens[0],
        received: currentToken.text
    });
    else return isEOF ? intl.formatMessage((0, $1R5KR.commonMessages).unknownError) : intl.formatMessage((0, $lL9v9.errorMessages).unknownErrorAtToken, {
        received: currentToken.text
    });
};

});
parcelRegister("1R5KR", function(module, exports) {
$parcel$export(module.exports, "commonMessages", () => $e597b9315cf49e5d$export$822cdd78febe6c96);

var $7qGN1 = parcelRequire("7qGN1");
const $e597b9315cf49e5d$export$822cdd78febe6c96 = (0, $7qGN1.defineMessages)({
    unknownError: {
        id: 'jql-editor.common.validation.unknown-error',
        defaultMessage: 'Unable to parse the query.',
        description: 'Message shown when the query could not be parsed due to an unknown error.'
    }
});

});

parcelRegister("8m75h", function(module, exports) {
$parcel$export(module.exports, "getTokenDisplayNames", () => $640f0ef35c10f828$export$aa889736429fba24);
$parcel$export(module.exports, "getExpectedTokensFromParserOrException", () => $640f0ef35c10f828$export$67be51611ee879b6);

var $6PXs7 = parcelRequire("6PXs7");
const $640f0ef35c10f828$export$aa889736429fba24 = (parser, tokens)=>{
    return tokens.map((tokenType)=>parser.vocabulary.getDisplayName(tokenType).replace(/^'|'$/g, ''));
};
const $640f0ef35c10f828$export$67be51611ee879b6 = (parser, exception)=>{
    // Read expected tokens from the exception if present, as it refers to the expected input symbols at the time the
    // exception was thrown (whereas JQLParser will give us possible tokens from the current parser state).
    const expectedTokenSet = exception?.expectedTokens ?? parser.getExpectedTokens();
    return expectedTokenSet.toArray()// Show the token if it's not ignored
    .filter((tokenType)=>!(0, $6PXs7.ignoredTokens).has(tokenType));
};

});


parcelRegister("fLEh0", function(module, exports) {
$parcel$export(module.exports, "handleFieldPropertyIdRuleError", () => $d5895411ce218511$export$12849a9199f9905a);

var $bFJ48 = parcelRequire("bFJ48");

var $lL9v9 = parcelRequire("lL9v9");
const $d5895411ce218511$export$12849a9199f9905a = (currentToken, intl)=>{
    const isEOF = currentToken.type === (0, $bFJ48.JQLLexer).EOF;
    return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingFieldPropertyIdBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingFieldPropertyIdButReceived, {
        received: currentToken.text
    });
};

});

parcelRegister("yDZkq", function(module, exports) {
$parcel$export(module.exports, "handleFieldRuleError", () => $42c1f7d092f1dbae$export$1008bb481a8a5358);

var $bFJ48 = parcelRequire("bFJ48");

var $lL9v9 = parcelRequire("lL9v9");
const $42c1f7d092f1dbae$export$1008bb481a8a5358 = (currentToken, intl)=>{
    const isEOF = currentToken.type === (0, $bFJ48.JQLLexer).EOF;
    if (currentToken.type === (0, $bFJ48.JQLLexer).LBRACKET) return intl.formatMessage((0, $lL9v9.errorMessages).expectingCFButReceived);
    return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingFieldBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingFieldButReceived, {
        received: currentToken.text
    });
};

});

parcelRegister("35FrL", function(module, exports) {
$parcel$export(module.exports, "handleFunctionArgumentRuleError", () => $a70ad1a48bd0541c$export$60552ea7b45a28c3);

var $bFJ48 = parcelRequire("bFJ48");

var $lL9v9 = parcelRequire("lL9v9");
const $a70ad1a48bd0541c$export$60552ea7b45a28c3 = (currentToken, intl)=>{
    const isEOF = currentToken.type === (0, $bFJ48.JQLLexer).EOF;
    return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingFunctionArgBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingFunctionArgButReceived, {
        received: currentToken.text
    });
};

});

parcelRegister("gMF29", function(module, exports) {
$parcel$export(module.exports, "handleOperandRuleError", () => $4d79c5b3b78e1fb7$export$eeff50333b45934e);

var $bFJ48 = parcelRequire("bFJ48");

var $lL9v9 = parcelRequire("lL9v9");

var $8m75h = parcelRequire("8m75h");

var $k9cJb = parcelRequire("k9cJb");
const $4d79c5b3b78e1fb7$export$eeff50333b45934e = (recognizer, currentToken, expectedTokens, rules, intl, exception)=>{
    // If there are no expected autocomplete tokens, then attempt to find viable tokens from the exception/parser.
    if (expectedTokens.length === 0) expectedTokens = (0, $8m75h.getTokenDisplayNames)(recognizer, (0, $8m75h.getExpectedTokensFromParserOrException)(recognizer, exception));
    const isEOF = currentToken.type === (0, $bFJ48.JQLLexer).EOF;
    if (rules.value && rules.list && rules.function) return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingOperandBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingOperandButReceived, {
        received: currentToken.text
    });
    if (rules.value && rules.function) return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingValueOrFunctionBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingValueOrFunctionButReceived, {
        received: currentToken.text
    });
    if (rules.list && rules.function) {
        // Lists and functions are the only operands that contain structural tokens (i.e. LPAREN, RPAREN and COMMA).
        // So, if there are specific expected tokens, we prioritize those over generic rule messages.
        if (expectedTokens.length) return (0, $k9cJb.handleExpectedTokensError)(recognizer, currentToken, expectedTokens, intl, exception);
        return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingListOrFunctionBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingListOrFunctionButReceived, {
            received: currentToken.text
        });
    }
    // Value or list combination is not possible with current grammar definition
    if (rules.function) {
        // Lists and functions are the only operands that contain structural tokens (i.e. LPAREN, RPAREN and COMMA).
        // So, if there are specific expected tokens, we prioritize those over generic rule messages.
        if (expectedTokens.length) return (0, $k9cJb.handleExpectedTokensError)(recognizer, currentToken, expectedTokens, intl, exception);
        return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingFunctionBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingFunctionButReceived, {
            received: currentToken.text
        });
    }
    if (rules.list) {
        // Lists and functions are the only operands that contain structural tokens (i.e. LPAREN, RPAREN and COMMA).
        // So, if there are specific expected tokens, we prioritize those over generic rule messages.
        if (expectedTokens.length) return (0, $k9cJb.handleExpectedTokensError)(recognizer, currentToken, expectedTokens, intl, exception);
        return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingListBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingListButReceived, {
            received: currentToken.text
        });
    }
    return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingValueBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingValueButReceived, {
        received: currentToken.text
    });
};

});

parcelRegister("6av2Q", function(module, exports) {
$parcel$export(module.exports, "handleOperatorRuleError", () => $d074791881e87493$export$443ff2717695f6f9);

var $bFJ48 = parcelRequire("bFJ48");

var $lL9v9 = parcelRequire("lL9v9");
const $d074791881e87493$export$443ff2717695f6f9 = (currentToken, intl)=>{
    const isEOF = currentToken.type === (0, $bFJ48.JQLLexer).EOF;
    return isEOF ? intl.formatMessage((0, $lL9v9.errorMessages).expectingOperatorBeforeEOF) : intl.formatMessage((0, $lL9v9.errorMessages).expectingOperatorButReceived, {
        received: currentToken.text
    });
};

});



parcelRegister("esdm6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8d8c17e44cf9c49$export$2e2bcd8739ae039);

var $3lIcL = parcelRequire("3lIcL");

var $cic90 = parcelRequire("cic90");

var $ab4Yl = parcelRequire("ab4Yl");

var $3HQ0y = parcelRequire("3HQ0y");

var $2Iqah = parcelRequire("2Iqah");
const $d8d8c17e44cf9c49$var$getHighlights = (state)=>{
    const ast = (0, $3HQ0y.getJastFromState)(state);
    // Get highlights for AST nodes
    const visitor = new (0, $2Iqah.SyntaxHighlightingVisitor)(state);
    const highlights = ast.query ? visitor.visit(ast.query) : [];
    // Create a highlight for the first syntax error encountered
    const [error] = ast.errors;
    if (error instanceof (0, $cic90.JQLSyntaxError)) {
        const documentFrom = (0, $ab4Yl.default)(state.doc, error.start);
        const documentTo = (0, $ab4Yl.default)(state.doc, error.stop);
        highlights.push({
            tokenType: 'error',
            documentFrom: documentFrom,
            documentTo: documentTo
        });
    }
    return highlights;
};
const $d8d8c17e44cf9c49$var$JQLSyntaxHighlightingPluginKey = new (0, $3lIcL.PluginKey)('jql-syntax-highlighting-plugin');
const $d8d8c17e44cf9c49$var$jqlSyntaxHighlightingPlugin = ()=>new (0, $3lIcL.Plugin)({
        key: $d8d8c17e44cf9c49$var$JQLSyntaxHighlightingPluginKey,
        appendTransaction: (_, oldState, newState)=>{
            // Avoid unnecessary transactions if document hasn't changed in the current transaction
            if (oldState.doc === newState.doc) return;
            const transaction = newState.tr;
            // Remove token marks from all inline nodes so they can be recomputed
            transaction.removeMark(0, newState.doc.content.size);
            // Create marks for computed highlights
            const highlights = $d8d8c17e44cf9c49$var$getHighlights(newState);
            highlights.forEach(({ tokenType: tokenType, documentFrom: documentFrom, documentTo: documentTo })=>{
                // Apply mark to all text nodes within the highlighted range
                newState.doc.nodesBetween(documentFrom, documentTo, (node, pos)=>{
                    if (node.isText) {
                        const from = Math.max(pos, documentFrom);
                        const to = Math.min(pos + node.nodeSize, documentTo);
                        const mark = newState.schema.marks.token.create({
                            tokenType: tokenType
                        });
                        transaction.addMark(from, to, mark);
                    }
                });
            });
            return transaction;
        }
    });
var $d8d8c17e44cf9c49$export$2e2bcd8739ae039 = $d8d8c17e44cf9c49$var$jqlSyntaxHighlightingPlugin;

});
parcelRegister("2Iqah", function(module, exports) {
$parcel$export(module.exports, "SyntaxHighlightingVisitor", () => $57469c3bc231f7eb$export$8582ce0a1c29a6d6);

var $dl9fK = parcelRequire("dl9fK");
var $uL8wO = parcelRequire("uL8wO");

var $ab4Yl = parcelRequire("ab4Yl");
class $57469c3bc231f7eb$export$8582ce0a1c29a6d6 extends (0, $dl9fK.AbstractJastVisitor) {
    constructor(state){
        super(), this.visitCompoundOperator = (compoundOperator)=>{
            return compoundOperator.positions.map((position)=>this.createHighlight('keyword', position));
        }, this.visitNotClauseOperator = (notClauseOperator)=>{
            return this.getHighlightsIfPosition('keyword', notClauseOperator.position);
        }, this.visitOrderByOperator = (orderByOperator)=>{
            return this.getHighlightsIfPosition('keyword', orderByOperator.position);
        }, this.visitOrderByDirection = (orderByDirection)=>{
            return this.getHighlightsIfPosition('keyword', orderByDirection.position);
        }, this.visitField = (field)=>{
            return this.getHighlightsIfPosition('field', field.position);
        }, this.visitOperator = (operator)=>{
            return this.getHighlightsIfPosition('operator', operator.position);
        }, this.visitPredicateOperator = (predicateOperator)=>{
            return this.getHighlightsIfPosition('operator', predicateOperator.position);
        }, this.getHighlightsIfPosition = (tokenType, maybePosition)=>{
            if (!maybePosition) return [];
            return [
                this.createHighlight(tokenType, maybePosition)
            ];
        }, this.createHighlight = (tokenType, [start, end])=>{
            const documentFrom = (0, $ab4Yl.default)(this.state.doc, start);
            const documentTo = (0, $ab4Yl.default)(this.state.doc, end);
            return {
                tokenType: tokenType,
                documentFrom: documentFrom,
                documentTo: documentTo
            };
        };
        this.state = state;
    }
    shouldVisitNextChild(node) {
        // Skip visiting operand subtrees, which don't require syntax highlighting and can make a big impact on performance
        return !(0, $uL8wO.isOperandNode)(node);
    }
    aggregateResult(aggregate, nextResult) {
        return aggregate.concat(nextResult);
    }
    defaultResult() {
        return [];
    }
}

});
parcelRegister("uL8wO", function(module, exports) {
$parcel$export(module.exports, "isOperandNode", () => $ab9afccf6cae5714$export$a9cf79e8f09322ba);

const $ab9afccf6cae5714$export$a9cf79e8f09322ba = (maybeOperandNode)=>maybeOperandNode.type === (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d);

});
const $07f17d613ee96ad1$export$98dda21ec825792 = 'query';
const $07f17d613ee96ad1$export$2d205682cc545947 = 'clause';
const $07f17d613ee96ad1$export$d2f212d8ddbc8d1d = 'operand';
const $07f17d613ee96ad1$export$da0f73edded4a63d = 'order_by';




parcelRegister("ldpRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c677c6bb09d05d65$export$2e2bcd8739ae039);

var $huH03 = parcelRequire("huH03");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $cic90 = parcelRequire("cic90");

var $ab4Yl = parcelRequire("ab4Yl");

var $3HQ0y = parcelRequire("3HQ0y");


var $Ly2Gm = parcelRequire("Ly2Gm");

var $kqSSG = parcelRequire("kqSSG");
const $c677c6bb09d05d65$var$decorateNodesInRange = (state, decoration, from, to)=>{
    const decorations = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type.spec.group === (0, $46481d3a70b8323b$export$631debe5726024e8)) decorations.push((0, $b7EWj.Decoration).node(pos, pos + node.nodeSize, {}, {
            type: decoration
        }));
    });
    return decorations;
};
const $c677c6bb09d05d65$var$RichInlineNodesPluginKey = new (0, $3lIcL.PluginKey)('rich-inline-nodes-plugin');
const $c677c6bb09d05d65$var$richInlineNodesPlugin = (portalActions)=>new (0, $3lIcL.Plugin)({
        key: $c677c6bb09d05d65$var$RichInlineNodesPluginKey,
        props: {
            decorations: (state)=>{
                const decorations = [];
                // Apply selected decoration to node views when they are part of a text selection
                const { from: from, to: to } = state.selection;
                decorations.push(...$c677c6bb09d05d65$var$decorateNodesInRange(state, (0, $46481d3a70b8323b$export$c3c342701c7bc4c3), from, to));
                // Apply error decoration to node views when they are part of AST error range
                const ast = (0, $3HQ0y.getJastFromState)(state);
                const [error] = ast.errors;
                if (error instanceof (0, $cic90.JQLSyntaxError)) {
                    const documentFrom = (0, $ab4Yl.default)(state.doc, error.start);
                    const documentTo = (0, $ab4Yl.default)(state.doc, error.stop);
                    decorations.push(...$c677c6bb09d05d65$var$decorateNodesInRange(state, (0, $46481d3a70b8323b$export$ab35a9029c27730d), documentFrom, documentTo));
                }
                return (0, $b7EWj.DecorationSet).create(state.doc, decorations);
            },
            nodeViews: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))((0, $Ly2Gm.richInlineNodes), (jqlNodeSpec)=>(node, _view, _getPos, decorations)=>(0, $kqSSG.ReactNodeView).for(jqlNodeSpec.component, portalActions, node, decorations))
        }
    });
var $c677c6bb09d05d65$export$2e2bcd8739ae039 = $c677c6bb09d05d65$var$richInlineNodesPlugin;

});
const $46481d3a70b8323b$export$631debe5726024e8 = 'rich_inline';
const $46481d3a70b8323b$export$c3c342701c7bc4c3 = 'selected';
const $46481d3a70b8323b$export$ab35a9029c27730d = 'error';

parcelRegister("Ly2Gm", function(module, exports) {
$parcel$export(module.exports, "richInlineNodes", () => $b793aaaa3c950cb0$export$9595597cab4e5e4d);

var $kx7g1 = parcelRequire("kx7g1");

var $1CqvV = parcelRequire("1CqvV");
const $b793aaaa3c950cb0$export$9595597cab4e5e4d = {
    user: $1CqvV.user,
    team: $kx7g1.team
};

});
parcelRegister("kx7g1", function(module, exports) {
$parcel$export(module.exports, "team", () => $1f840da323c75e05$export$8d64293bd263e87);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $9IGks = parcelRequire("9IGks");

var $9zMEz = parcelRequire("9zMEz");
const $1f840da323c75e05$var$Team = ({ id: id, name: name, fieldName: fieldName, selected: selected, error: error })=>{
    const [team] = (0, $9IGks.useHydratedTeam)({
        id: id,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9zMEz.TeamContainer), {
        selected: selected,
        error: error,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9zMEz.AvatarWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                    src: team?.avatarUrl,
                    appearance: "square",
                    borderColor: "transparent",
                    size: "xsmall"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9zMEz.NameContainer), {
                children: name
            })
        ]
    });
};
const $1f840da323c75e05$export$8d64293bd263e87 = {
    component: $1f840da323c75e05$var$Team,
    attrs: {
        id: {},
        name: {},
        fieldName: {}
    }
};

});
parcelRegister("9zMEz", function(module, exports) {
$parcel$export(module.exports, "TeamContainer", () => $d292a38b652ff34f$export$49d7e90fea971ae5);
$parcel$export(module.exports, "NameContainer", () => $d292a38b652ff34f$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "AvatarWrapper", () => $d292a38b652ff34f$export$f7513421c53ce141);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $aWILV = parcelRequire("aWILV");
function $d292a38b652ff34f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d292a38b652ff34f$export$49d7e90fea971ae5 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1lexip62"
})({
    display: 'inline-flex',
    alignItems: 'baseline',
    paddingLeft: `${"var(--ds-space-025, 2px)"}`,
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    cursor: 'pointer',
    userSelect: 'none'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ selected: selected, error: error })=>{
    if (selected) {
        if (error) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            backgroundColor: `var(--ds-background-danger-bold, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
            textDecoration: 'wavy underline',
            textDecorationThickness: '1px',
            textDecorationSkipInk: 'none',
            textDecorationColor: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`
        });
        else // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            backgroundColor: `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, transparent)"}`
        });
    } else {
        if (error) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            textDecoration: 'wavy underline',
            textDecorationThickness: '1px',
            textDecorationSkipInk: 'none',
            textDecorationColor: `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
            }
        });
        else // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
            }
        });
    }
});
const $d292a38b652ff34f$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1lexip61"
})({
    name: "19nuqh5",
    styles: "margin-left:var(--ds-space-075, 6px);margin-right:var(--ds-space-050, 4px);line-height:var(--ds-space-250, 20px)"
});
const $d292a38b652ff34f$export$f7513421c53ce141 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1lexip60"
})({
    name: "1sfo6tt",
    styles: "height:var(--ds-space-200, 16px);width:var(--ds-space-200, 16px);align-self:center;> div span{margin:var(--ds-space-0, 0px);}> div > span:has(> span){position:relative;top:-2px;}"
});

});


parcelRegister("1CqvV", function(module, exports) {
$parcel$export(module.exports, "user", () => $b903c18fb204f1d9$export$ddb906a32562356c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $9IGks = parcelRequire("9IGks");

var $bvqaw = parcelRequire("bvqaw");
const $b903c18fb204f1d9$var$User = ({ id: id, name: name, fieldName: fieldName, selected: selected, error: error })=>{
    const [user] = (0, $9IGks.useHydratedUser)({
        id: id,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bvqaw.UserContainer), {
        selected: selected,
        error: error,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvqaw.AvatarWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                    src: user?.avatarUrl,
                    borderColor: "transparent",
                    size: "xsmall"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvqaw.NameContainer), {
                children: name
            })
        ]
    });
};
const $b903c18fb204f1d9$export$ddb906a32562356c = {
    component: $b903c18fb204f1d9$var$User,
    attrs: {
        id: {},
        name: {},
        fieldName: {}
    }
};

});
parcelRegister("bvqaw", function(module, exports) {
$parcel$export(module.exports, "UserContainer", () => $3c77693c72280834$export$7ff085589970ee0a);
$parcel$export(module.exports, "NameContainer", () => $3c77693c72280834$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "AvatarWrapper", () => $3c77693c72280834$export$f7513421c53ce141);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $aWILV = parcelRequire("aWILV");
function $3c77693c72280834$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3c77693c72280834$export$7ff085589970ee0a = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e19h98s52"
})({
    display: 'inline-flex',
    alignItems: 'baseline',
    paddingLeft: `${"var(--ds-space-025, 2px)"}`,
    borderRadius: "var(--ds-radius-xlarge, 12px)",
    cursor: 'pointer',
    userSelect: 'none'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ selected: selected, error: error })=>{
    if (selected) {
        if (error) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            backgroundColor: `var(--ds-background-danger-bold, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
            textDecoration: 'wavy underline',
            textDecorationThickness: '1px',
            textDecorationSkipInk: 'none',
            textDecorationColor: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`
        });
        else // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            backgroundColor: `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, transparent)"}`
        });
    } else {
        if (error) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            textDecoration: 'wavy underline',
            textDecorationThickness: '1px',
            textDecorationSkipInk: 'none',
            textDecorationColor: `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
            }
        });
        else // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.css)({
            color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
            }
        });
    }
});
const $3c77693c72280834$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e19h98s51"
})({
    name: "11bb7yo",
    styles: "margin-left:var(--ds-space-075, 6px);margin-right:var(--ds-space-100, 8px);line-height:var(--ds-space-250, 20px)"
});
const $3c77693c72280834$export$f7513421c53ce141 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e19h98s50"
})({
    name: "1sfo6tt",
    styles: "height:var(--ds-space-200, 16px);width:var(--ds-space-200, 16px);align-self:center;> div span{margin:var(--ds-space-0, 0px);}> div > span:has(> span){position:relative;top:-2px;}"
});

});



parcelRegister("kqSSG", function(module, exports) {
$parcel$export(module.exports, "ReactNodeView", () => $00db61734c73ef17$export$eac36b62725dff99);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6WhQS = parcelRequire("6WhQS");

var $aXKmr = parcelRequire("aXKmr");

var $9IGks = parcelRequire("9IGks");

class $00db61734c73ef17$export$eac36b62725dff99 {
    constructor(component, portalActions, node){
        this.componentSubject = new (0, $6WhQS.Subject)();
        this.init = (decorations)=>{
            const Component = this.component;
            const PortallingComponent = ()=>{
                const [state, setState] = (0, $eJOHy.useState)({
                    ...this.getProps(this.node),
                    selected: this.isSelected(decorations),
                    error: this.hasError(decorations)
                });
                // ProseMirror keeps decorations on blur (as those are derived from editor state and focus isn't part of it),
                // but we don't want to show node views as selected when that happens. We could build a workaround for this in
                // richInlineNodesPlugin, but this hook will make selection behave more consistently with other focus-related features.
                const [hasFocus] = (0, $9IGks.useEditorViewHasFocus)();
                (0, $eJOHy.useEffect)(()=>{
                    // Subscribe to the RxJS subject so concrete subclasses can emit events to re-render the node view component
                    const subscription = this.componentSubject.subscribe((props)=>{
                        setState(props);
                    });
                    return ()=>subscription.unsubscribe();
                }, []);
                (0, $eJOHy.useLayoutEffect)(()=>{
                    if (state.error) this.dom.dataset.tokenType = 'error';
                    else delete this.dom.dataset.tokenType;
                }, [
                    state
                ]);
                return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...state,
                    selected: state.selected && hasFocus
                });
            };
            // Ok, this is a tricky one. As everything that requires collaboration between ProseMirror and React.
            //
            // If we run `onCreatePortal` synchronously, ProseMirror won't insert the node view container (`this.dom`)
            // immediately into the DOM (as init function hasn't returned yet). This can trigger race conditions in other
            // code paths where ProseMirror may try to get DOM position for this node view before it has been inserted
            // (e.g. calculating new autocomplete position after insertion, or setting selection after the node).
            //
            // With `queueMicrotask` we can schedule this operation to be run after ProseMirror is done with the element
            // insertion, but before control of the execution context is returned to the browser's event loop. This should
            // prevent all conflicts with other pieces of asynchronous code and still render the portal as soon as it is
            // practically possible, so we can avoid flicker in situations where node views are reconstructed by ProseMirror.
            // @see https://github.com/ProseMirror/prosemirror/issues/872
            queueMicrotask(()=>{
                this.portalActions.onCreatePortal(this.portalKey, /*#__PURE__*/ (0, $gt9Am.jsx)(PortallingComponent, {}), this.dom);
            });
            return this;
        };
        this.destroy = ()=>{
            this.portalActions.onDestroyPortal(this.portalKey);
        };
        this.update = (node, decorations)=>{
            // Update function may be called by ProseMirror with a node that has nothing to do with this node view ¯\_(ツ)_/¯
            // @see https://prosemirror.net/docs/ref/#view.NodeView.update
            if (node !== this.node) return false;
            this.componentSubject.next({
                ...this.getProps(node),
                selected: this.isSelected(decorations),
                error: this.hasError(decorations)
            });
            return true;
        };
        this.getProps = (node)=>{
            return {
                ...node.attrs
            };
        };
        this.isSelected = (decorations)=>{
            return decorations.some((decoration)=>decoration.spec.type === (0, $46481d3a70b8323b$export$c3c342701c7bc4c3));
        };
        this.hasError = (decorations)=>{
            return decorations.some((decoration)=>decoration.spec.type === (0, $46481d3a70b8323b$export$ab35a9029c27730d));
        };
        this.component = component;
        this.portalActions = portalActions;
        this.node = node;
        // Generate unique portal identifier
        // If you read this comment in the future and TypeScript has added support for Symbols as object keys, please do
        // JQL Editor a favor and replace this library with the native JS functionality that TS was supposed to support.
        this.portalKey = (0, $aXKmr.v4)();
        // Creating span under the assumption that all node views will be inline elements in JQL Editor
        this.dom = document.createElement('span');
        this.dom.setAttribute('data-testid', 'jql-editor-node-view');
    }
    static for(component, portalActions, node, decorations) {
        return new $00db61734c73ef17$export$eac36b62725dff99(component, portalActions, node).init(decorations);
    }
}

});


parcelRegister("a5NiY", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6390790fca13a12$export$2e2bcd8739ae039);

var $3lIcL = parcelRequire("3lIcL");

var $7xEmd = parcelRequire("7xEmd");

var $5KoUK = parcelRequire("5KoUK");
const $c6390790fca13a12$var$validationTooltipPlugin = (mainId)=>{
    const plugin = new (0, $3lIcL.Plugin)({
        key: (0, $7xEmd.JQLValidationTooltipPluginKey),
        view: ()=>new (0, $5KoUK.ValidationTooltipPluginView)(mainId),
        state: {
            init () {
                return false;
            },
            // @ts-ignore
            apply (tr, value) {
                if (tr.getMeta(plugin) !== undefined) return tr.getMeta(plugin);
                else return value;
            }
        },
        props: {
            handleDOMEvents: {
                mouseover: ({ state: state, dispatch: dispatch }, event)=>{
                    const isHovered = plugin.getState(state);
                    if (event.target instanceof Element && event.target.closest('[data-token-type="error"]')) {
                        if (!isHovered) dispatch(state.tr.setMeta(plugin, true));
                    } else if (isHovered) dispatch(state.tr.setMeta(plugin, false));
                    return false;
                },
                mouseleave: ({ state: state, dispatch: dispatch })=>{
                    const isHovered = plugin.getState(state);
                    if (isHovered) dispatch(state.tr.setMeta(plugin, false));
                    return false;
                }
            }
        }
    });
    return plugin;
};
var $c6390790fca13a12$export$2e2bcd8739ae039 = $c6390790fca13a12$var$validationTooltipPlugin;

});
parcelRegister("5KoUK", function(module, exports) {
$parcel$export(module.exports, "ValidationTooltipPluginView", () => $527120ef3cd5a0e8$export$e52a158d35240cb);

var $cic90 = parcelRequire("cic90");

var $ab4Yl = parcelRequire("ab4Yl");

var $3HQ0y = parcelRequire("3HQ0y");

var $7xEmd = parcelRequire("7xEmd");
class $527120ef3cd5a0e8$export$e52a158d35240cb {
    constructor(mainId){
        this.showTooltip = (error, start, end)=>{
            // Find a center position from the selection endpoints
            const left = (start.left + end.left) / 2;
            // The box in which the container is positioned, to use as base
            const box = this.tooltip.offsetParent?.getBoundingClientRect();
            this.tooltip.style.left = `${left - (box?.left ?? 0)}px`;
            this.tooltip.style.top = `${start.top - (box?.top ?? 0)}px`;
            this.tooltip.textContent = error.message;
            this.tooltip.classList.remove((0, $7xEmd.TOOLTIP_EXIT_CLASSNAME));
            this.tooltip.classList.add((0, $7xEmd.TOOLTIP_ENTER_CLASSNAME));
        };
        this.hideTooltip = ()=>{
            this.tooltip.classList.remove((0, $7xEmd.TOOLTIP_ENTER_CLASSNAME));
            this.tooltip.classList.add((0, $7xEmd.TOOLTIP_EXIT_CLASSNAME));
        };
        this.tooltip = document.createElement('div');
        this.tooltip.setAttribute('data-testid', 'jql-validation-tooltip');
        this.tooltip.classList.add((0, $7xEmd.TOOLTIP_CLASSNAME));
        document.getElementById(mainId)?.appendChild(this.tooltip);
    }
    update(view, lastState) {
        const state = view.state;
        const isHovered = (0, $7xEmd.JQLValidationTooltipPluginKey).getState(state);
        const lastIsHovered = (0, $7xEmd.JQLValidationTooltipPluginKey).getState(lastState);
        const jast = (0, $3HQ0y.getJastFromState)(state);
        const [error] = jast.errors;
        if (isHovered === lastIsHovered) return;
        if (isHovered) {
            if (error instanceof (0, $cic90.JQLSyntaxError)) {
                const start = (0, $ab4Yl.default)(state.doc, error.start);
                const stop = (0, $ab4Yl.default)(state.doc, error.stop);
                const startCoords = view.coordsAtPos(start);
                const stopCoords = view.coordsAtPos(stop);
                this.showTooltip(error, startCoords, stopCoords);
            }
        } else this.hideTooltip();
    }
    destroy() {
        this.tooltip.remove();
    }
}

});


parcelRegister("f49d6", function(module, exports) {
$parcel$export(module.exports, "createNodeSpec", () => $155c442bb27f6993$export$ceb9a9e7d9565c75);

var $8V8so = parcelRequire("8V8so");

var $huH03 = parcelRequire("huH03");

const $155c442bb27f6993$export$ceb9a9e7d9565c75 = (name, attrs)=>{
    return {
        group: (0, $46481d3a70b8323b$export$631debe5726024e8),
        content: 'text*',
        inline: true,
        atom: true,
        attrs: attrs,
        toDOM: (node)=>{
            const domAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(node.attrs, (_, attr)=>`data-${attr}`);
            return [
                name,
                domAttrs,
                0
            ];
        },
        parseDOM: [
            {
                tag: name,
                getAttrs: (node)=>{
                    if (node instanceof Element) return (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(attrs, (_, attr)=>node.getAttribute(`data-${attr}`));
                    return null; // should never™ happen
                }
            }
        ]
    };
};

});
parcelRegister("8V8so", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $67ea34f606cb6857$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $67ea34f606cb6857$var$mapKeys;

});





parcelRegister("eRjpa", function(module, exports) {
$parcel$export(module.exports, "onStartAutocompleteEvent", () => $1d91df30f41504aa$export$d671d0c045f67ec1);

var $2PBDa = parcelRequire("2PBDa");

var $4cOHu = parcelRequire("4cOHu");
var $6S5SS = parcelRequire("6S5SS");
const $1d91df30f41504aa$export$9a1eed85eaf8ada6 = 2000;
const $1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE = 'jql-editor-autocomplete';
const $1d91df30f41504aa$export$d671d0c045f67ec1 = ()=>(_, { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent })=>{
        performance.clearMeasures($1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE);
        performance.clearMarks(`${$1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE}::start`);
        performance.mark(`${$1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE}::start`);
        let timeoutId = null;
        const promise = new Promise((resolve)=>{
            // Resolve the promise after a fixed debounce period
            timeoutId = window.setTimeout(()=>{
                resolve();
            }, $1d91df30f41504aa$export$9a1eed85eaf8ada6);
        });
        // Create a new subscription which will cancel the analytics promise when unsubscribed
        const analyticsSubscription = new (0, $2PBDa.Subscription)(()=>{
            timeoutId !== null && window.clearTimeout(timeoutId);
        });
        const onStopAutocompleteEvent = (isSuccess, optionTypes, hasOptions)=>{
            performance.measure($1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE, `${$1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE}::start`);
            const entry = performance.getEntriesByName($1d91df30f41504aa$var$AUTOCOMPLETE_ANALYTICS_MEASURE).pop();
            const duration = entry?.duration;
            // Fire our analytics event once our autocomplete data is fetched AND our debounced promise is resolved
            return promise.then(()=>{
                const attributes = {
                    optionTypes: optionTypes.sort(),
                    hasOptions: hasOptions
                };
                if (duration !== undefined) attributes.duration = duration;
                createAndFireAnalyticsEvent({
                    action: isSuccess ? (0, $4cOHu.Action).RETRIEVED : (0, $4cOHu.Action).RETRIEVE_FAILED,
                    actionSubject: (0, $4cOHu.ActionSubject).AUTOCOMPLETE_OPTION,
                    eventType: (0, $6S5SS.EventType).OPERATIONAL,
                    attributes: attributes
                });
            });
        };
        return {
            analyticsSubscription: analyticsSubscription,
            onStopAutocompleteEvent: onStopAutocompleteEvent
        };
    };

});

parcelRegister("dutrm", function(module, exports) {
$parcel$export(module.exports, "sortOperators", () => $ce1be78e8f11db81$export$c2d02f7c0646a42f);

var $3PmNk = parcelRequire("3PmNk");

var $jPlb3 = parcelRequire("jPlb3");
const $ce1be78e8f11db81$export$9cac195e96ce5585 = [
    (0, $jPlb3.OPERATOR_EQUALS),
    (0, $jPlb3.OPERATOR_NOT_EQUALS),
    (0, $jPlb3.OPERATOR_LIKE),
    (0, $jPlb3.OPERATOR_NOT_LIKE),
    (0, $jPlb3.OPERATOR_LT_EQUALS),
    (0, $jPlb3.OPERATOR_GT_EQUALS),
    (0, $jPlb3.OPERATOR_GT),
    (0, $jPlb3.OPERATOR_LT),
    (0, $jPlb3.OPERATOR_IS),
    (0, $jPlb3.OPERATOR_IS_NOT),
    (0, $jPlb3.OPERATOR_IN),
    (0, $jPlb3.OPERATOR_NOT_IN),
    (0, $jPlb3.OPERATOR_WAS),
    (0, $jPlb3.OPERATOR_WAS_NOT),
    (0, $jPlb3.OPERATOR_WAS_IN),
    (0, $jPlb3.OPERATOR_WAS_NOT_IN),
    (0, $jPlb3.OPERATOR_CHANGED)
];
const $ce1be78e8f11db81$export$c2d02f7c0646a42f = (operators$)=>{
    return operators$.pipe((0, $3PmNk.map)((options)=>{
        return $ce1be78e8f11db81$export$9cac195e96ce5585.reduce((result, orderedOperator)=>{
            const matchingOption = options.find((option)=>orderedOperator.toLowerCase() === option.value.toLowerCase());
            if (matchingOption !== undefined) result.push(matchingOption);
            return result;
        }, []);
    }));
};

});

parcelRegister("fksm0", function(module, exports) {
$parcel$export(module.exports, "hydrateQuery", () => $3442746b1c749736$export$18907ba55472a0d);

var $3HQ0y = parcelRequire("3HQ0y");

var $1iXhs = parcelRequire("1iXhs");

var $9IGks = parcelRequire("9IGks");

var $d1c6N = parcelRequire("d1c6N");
const $3442746b1c749736$export$18907ba55472a0d = ()=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { onHydrate: onHydrate })=>{
        const { query: query, hydratedValues: oldHydratedValues, enableRichInlineNodes: enableRichInlineNodes, editorState: editorState } = getState();
        if (!enableRichInlineNodes || !onHydrate || !query) return;
        let queryToHydrate = query;
        const jast = (0, $3HQ0y.getJastFromState)(editorState);
        // Hydration API will fail for syntactically invalid queries, including partial queries. We do want to hydrate those
        // as well to be able to handle queries like `assignee in (abc-123-def`, so we build an equivalent valid query.
        if (jast.query && jast.errors.length) {
            const visitor = new (0, $d1c6N.ValidQueryVisitor)();
            queryToHydrate = jast.query.accept(visitor);
        }
        if (!queryToHydrate) return;
        try {
            const newHydratedValues = await onHydrate(queryToHydrate);
            const hydratedValuesMap = Object.entries(newHydratedValues).reduce((map, [fieldName, values])=>{
                const valueMap = new Map(oldHydratedValues[fieldName]);
                values.forEach((value)=>{
                    valueMap.set(value.id, value);
                });
                return {
                    ...map,
                    [fieldName]: valueMap
                };
            }, {});
            setState({
                hydratedValues: hydratedValuesMap
            });
            dispatch($3442746b1c749736$var$replaceHydratedValuesWithRichInlineNodes());
        } catch (error) {
        // Hydration failed, do nothing
        }
    };
const $3442746b1c749736$var$replaceHydratedValuesWithRichInlineNodes = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { editorState: editorState, hydratedValues: hydratedValues } = getState();
        const transaction = (0, $1iXhs.replaceRichInlineNodes)(editorState, hydratedValues);
        dispatch((0, $9IGks.actions).onApplyEditorTransaction(transaction));
    };

});
parcelRegister("1iXhs", function(module, exports) {
$parcel$export(module.exports, "replaceRichInlineNodes", () => $bf897fe5578d1e10$export$507380dfaf9b8152);

var $dl9fK = parcelRequire("dl9fK");

var $eGOwo = parcelRequire("eGOwo");

var $bkqOC = parcelRequire("bkqOC");

var $ab4Yl = parcelRequire("ab4Yl");

var $3HQ0y = parcelRequire("3HQ0y");

const $bf897fe5578d1e10$export$507380dfaf9b8152 = (editorState, hydratedValues)=>{
    const ast = (0, $3HQ0y.getJastFromState)(editorState);
    const transaction = editorState.tr;
    // Do not allow users to revert this transaction with undo command so they can't land in an unhydrated state
    transaction.setMeta('addToHistory', false);
    Object.entries(hydratedValues).forEach(([fieldName, values])=>{
        values.forEach((value)=>{
            if (value.type === 'user' || value.type === 'team' && (0, $eGOwo.fg)('jira_update_jql_teams')) {
                const astNodes = $bf897fe5578d1e10$var$getValueNodes(ast, fieldName, value.id);
                astNodes.forEach((astNode)=>{
                    if (astNode.position) {
                        const [from, to] = astNode.position;
                        const documentFrom = (0, $ab4Yl.default)(transaction.doc, from);
                        if (!$bf897fe5578d1e10$var$isRichInlineNode(transaction.doc, documentFrom)) {
                            const documentTo = (0, $ab4Yl.default)(transaction.doc, to);
                            const node = $bf897fe5578d1e10$var$getRichInlineNode(fieldName, value, astNode.text);
                            transaction.replaceWith(documentFrom, documentTo, node);
                        }
                    }
                });
            }
        });
    });
    return transaction;
};
const $bf897fe5578d1e10$var$getRichInlineNode = (fieldName, value, text)=>{
    switch(value.type){
        case 'user':
            {
                const textContent = (0, $bkqOC.JQLEditorSchema).text(text);
                return (0, $bkqOC.JQLEditorSchema).nodes.user.create({
                    ...value,
                    fieldName: fieldName
                }, textContent);
            }
        case 'team':
            {
                const textContent = (0, $bkqOC.JQLEditorSchema).text(text);
                return (0, $bkqOC.JQLEditorSchema).nodes.team.create({
                    ...value,
                    fieldName: fieldName
                }, textContent);
            }
        default:
            throw new Error(`Unsupported hydrated value type ${value.type}`);
    }
};
const $bf897fe5578d1e10$var$isRichInlineNode = (doc, position)=>{
    return doc.resolve(position).nodeAfter?.type.spec.group === (0, $46481d3a70b8323b$export$631debe5726024e8);
};
const $bf897fe5578d1e10$var$getValueNodes = (ast, field, value)=>{
    if (!ast.query) return [];
    return ast.query.accept(new $bf897fe5578d1e10$var$FindValuesVisitor(field, value));
};
class $bf897fe5578d1e10$var$FindValuesVisitor extends (0, $dl9fK.AbstractJastVisitor) {
    constructor(field, value){
        super(), this.visitQuery = (query)=>{
            if (query.where === undefined) return [];
            return query.where.accept(this);
        }, this.visitCompoundClause = (compoundClause)=>{
            return compoundClause.clauses.reduce((operands, compoundClause)=>{
                return [
                    ...operands,
                    ...compoundClause.accept(this)
                ];
            }, []);
        }, this.visitTerminalClause = (terminalClause)=>{
            if (!this.equalsIgnoreCase(terminalClause.field.value, this.field)) return [];
            if (terminalClause.operand === undefined) return [];
            return terminalClause.operand.accept(this);
        }, this.visitNotClause = (notClause)=>{
            return notClause.clause.accept(this);
        }, this.visitValueOperand = (valueOperand)=>{
            if (!this.equalsIgnoreCase(valueOperand.value, this.value)) return [];
            return [
                valueOperand
            ];
        }, this.visitListOperand = (listOperand)=>{
            return listOperand.values.reduce((values, operand)=>{
                return [
                    ...values,
                    ...operand.accept(this)
                ];
            }, []);
        };
        this.field = field;
        this.value = value;
    }
    aggregateResult(aggregate, nextResult) {
        return [
            ...aggregate,
            ...nextResult
        ];
    }
    defaultResult() {
        return [];
    }
    equalsIgnoreCase(a, b) {
        return a.localeCompare(b, undefined, {
            sensitivity: 'base'
        }) === 0;
    }
}

});

parcelRegister("d1c6N", function(module, exports) {
$parcel$export(module.exports, "ValidQueryVisitor", () => $2cbc050cb862f98e$export$fddac936ffb2bcab);

var $dl9fK = parcelRequire("dl9fK");
class $2cbc050cb862f98e$export$fddac936ffb2bcab extends (0, $dl9fK.AbstractJastVisitor) {
    defaultResult() {
        return '';
    }
    constructor(...args){
        super(...args), this.visitQuery = (query)=>{
            if (!query.where) return '';
            return query.where.accept(this);
        }, this.visitCompoundClause = (compoundClause)=>{
            return compoundClause.clauses.map((clause)=>clause.accept(this)).filter((value)=>!!value).join(' and ');
        }, this.visitTerminalClause = (terminalClause)=>{
            const { field: field, operator: operator, operand: operand } = terminalClause;
            if (!operator || !operand) return '';
            const operandValue = operand.accept(this);
            if (!operandValue) return '';
            return `${field.text} ${operator.value} ${operandValue}`;
        }, this.visitNotClause = (notClause)=>{
            return notClause.clause.accept(this);
        }, this.visitValueOperand = (valueOperand)=>{
            return valueOperand.text;
        }, this.visitListOperand = (listOperand)=>{
            return `(${listOperand.values.map((value)=>value.accept(this)).filter((value)=>!!value).join(', ')})`;
        };
    }
}

});


parcelRegister("6Moo9", function(module, exports) {
$parcel$export(module.exports, "getAutocompleteOptionId", () => $2f25bf143128c436$export$71a94b367afebb02);
$parcel$export(module.exports, "tokensToAutocompleteOptions", () => $2f25bf143128c436$export$b5810eb2255d6a38);
$parcel$export(module.exports, "getReplacePositionStart", () => $2f25bf143128c436$export$39882fd181825498);
$parcel$export(module.exports, "getAutocompletePosition", () => $2f25bf143128c436$export$8b6384cdb407fdf);
$parcel$export(module.exports, "sendDebugMessage", () => $2f25bf143128c436$export$719a0cee2a09909c);
$parcel$export(module.exports, "getFieldNodes", () => $2f25bf143128c436$export$5e0b0284375d0cf3);

var $6PCNA = parcelRequire("6PCNA");

var $7LzVf = parcelRequire("7LzVf");

var $dl9fK = parcelRequire("dl9fK");

var $ab4Yl = parcelRequire("ab4Yl");

var $j3U9J = parcelRequire("j3U9J");
// Unique namespace to identify JQL autocomplete options!
const $2f25bf143128c436$var$UUID_NAMESPACE = '9a90299c-aa58-494b-b6a1-e93206e3fdd6';
const $2f25bf143128c436$export$71a94b367afebb02 = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($7LzVf)))(value, $2f25bf143128c436$var$UUID_NAMESPACE);
const $2f25bf143128c436$export$b5810eb2255d6a38 = (tokens)=>{
    let tokensToDisplay = tokens.values;
    if (tokens.matchedText !== '') {
        // Candidates that start with last token text but are not an exact match (case insensitive)
        const regex = new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(tokens.matchedText)}[^$]`, 'i');
        tokensToDisplay = tokens.values.filter((token)=>regex.test(token));
    }
    return tokensToDisplay.map((token)=>({
            id: $2f25bf143128c436$export$71a94b367afebb02(token),
            name: token,
            value: token,
            replacePosition: tokens.replacePosition,
            matchedText: tokens.matchedText,
            context: tokens.context ?? null,
            type: 'keyword'
        }));
};
const $2f25bf143128c436$export$39882fd181825498 = ({ rules: rules, tokens: tokens })=>{
    // Matching tokens should be prioritized over rules when calculating autocomplete dropdown position
    if (tokens.values.length) return tokens.replacePosition[0];
    // Same precedence as `useAutocompleteOptions`, this may change in future if we don't limit suggestions to one rule
    const rulePrecedence = [
        'value',
        'function',
        'list',
        'operator',
        'field'
    ];
    for (const rule of rulePrecedence){
        if (Object.prototype.hasOwnProperty.call(rules, rule)) return rules[rule].replacePosition[0];
    }
    return tokens.replacePosition[0];
};
const $2f25bf143128c436$export$8b6384cdb407fdf = (editorView, replacePositionStart)=>{
    const { doc: doc, selection: selection } = editorView.state;
    const documentPosition = (0, $ab4Yl.default)(doc, replacePositionStart);
    const { left: left } = editorView.coordsAtPos(documentPosition);
    // Vertically position autocomplete relative to selection end
    const { bottom: bottom } = editorView.coordsAtPos(selection.to);
    return {
        top: bottom,
        left: left
    };
};
const $2f25bf143128c436$var$getDebugSelectionAttributes = ()=>{
    const selection = document.getSelection();
    if (selection === null || selection.type === 'None') return {};
    return {
        anchorOffset: selection.anchorOffset,
        anchorNodeText: selection.anchorNode?.textContent,
        anchorNodeName: selection.anchorNode?.nodeName,
        focusOffset: selection.focusOffset,
        focusNodeText: selection.focusNode?.textContent,
        focusNodeName: selection.focusNode?.nodeName
    };
};
const $2f25bf143128c436$export$719a0cee2a09909c = (message, editorView, editorState, onDebugUnsafeMessage, eventAttributes)=>{
    if (!onDebugUnsafeMessage) return;
    try {
        const editorViewStateText = (0, $j3U9J.getNodeText)(editorView.state.doc, 0, editorView.state.doc.content.size);
        const editorViewStateJson = JSON.stringify(editorView.state.toJSON());
        const editorStateJson = JSON.stringify(editorState.toJSON());
        const editorViewHtml = editorView.dom.innerHTML;
        onDebugUnsafeMessage(message, {
            editorStateJson: editorStateJson,
            editorViewStateText: editorViewStateText,
            editorViewStateJson: editorViewStateJson,
            editorViewHtml: editorViewHtml,
            ...$2f25bf143128c436$var$getDebugSelectionAttributes(),
            ...eventAttributes
        });
    } catch (ignored) {
    // Do nothing
    }
};
const $2f25bf143128c436$export$5e0b0284375d0cf3 = (ast)=>{
    if (!ast.query) return new Set();
    const visitor = new $2f25bf143128c436$var$FindFieldsVisitor();
    ast.query.accept(visitor);
    return visitor.fields;
};
class $2f25bf143128c436$var$FindFieldsVisitor extends (0, $dl9fK.AbstractJastVisitor) {
    defaultResult() {
        return;
    }
    constructor(...args){
        super(...args), this.fields = new Set(), this.visitQuery = (query)=>{
            if (query.where !== undefined) query.where.accept(this);
            if (query.orderBy !== undefined) query.orderBy.accept(this);
        }, this.visitOrderBy = (orderBy)=>{
            orderBy.fields.map((orderByField)=>orderByField.accept(this));
        }, this.visitOrderByField = (orderByField)=>{
            orderByField.field.accept(this);
        }, this.visitCompoundClause = (compoundClause)=>{
            compoundClause.clauses.map((clause)=>clause.accept(this));
        }, this.visitTerminalClause = (terminalClause)=>{
            terminalClause.field.accept(this);
        }, this.visitNotClause = (notClause)=>{
            notClause.clause.accept(this);
        }, this.visitField = (field)=>{
            this.fields.add(field.value.toLowerCase());
        };
    }
}

});
parcelRegister("7LzVf", function(module, exports) {

var $6US0O = parcelRequire("6US0O");

var $dls8G = parcelRequire("dls8G");
module.exports = $6US0O('v5', 0x50, $dls8G);

});
parcelRegister("6US0O", function(module, exports) {

var $a6ehQ = parcelRequire("a6ehQ");
function $5091debe56396d97$var$uuidToBytes(uuid) {
    // Note: We assume we're being passed a valid uuid string
    var bytes = [];
    uuid.replace(/[a-fA-F0-9]{2}/g, function(hex) {
        bytes.push(parseInt(hex, 16));
    });
    return bytes;
}
function $5091debe56396d97$var$stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    var bytes = new Array(str.length);
    for(var i = 0; i < str.length; i++)bytes[i] = str.charCodeAt(i);
    return bytes;
}
module.exports = function(name, version, hashfunc) {
    var generateUUID = function(value, namespace, buf, offset) {
        var off = buf && offset || 0;
        if (typeof value == 'string') value = $5091debe56396d97$var$stringToBytes(value);
        if (typeof namespace == 'string') namespace = $5091debe56396d97$var$uuidToBytes(namespace);
        if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
        if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values');
        // Per 4.3
        var bytes = hashfunc(namespace.concat(value));
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) for(var idx = 0; idx < 16; ++idx)buf[off + idx] = bytes[idx];
        return buf || $a6ehQ(bytes);
    };
    // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name;
    } catch (err) {}
    // Pre-defined namespaces, per Appendix C
    generateUUID.DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
    generateUUID.URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
    return generateUUID;
};

});

parcelRegister("dls8G", function(module, exports) {
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
'use strict';
function $9b731056ca16dcaa$var$f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function $9b731056ca16dcaa$var$ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function $9b731056ca16dcaa$var$sha1(bytes) {
    var K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    var H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes == 'string') {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Array(msg.length);
        for(var i = 0; i < msg.length; i++)bytes[i] = msg.charCodeAt(i);
    }
    bytes.push(0x80);
    var l = bytes.length / 4 + 2;
    var N = Math.ceil(l / 16);
    var M = new Array(N);
    for(var i = 0; i < N; i++){
        M[i] = new Array(16);
        for(var j = 0; j < 16; j++)M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(var i = 0; i < N; i++){
        var W = new Array(80);
        for(var t = 0; t < 16; t++)W[t] = M[i][t];
        for(var t = 16; t < 80; t++)W[t] = $9b731056ca16dcaa$var$ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        for(var t = 0; t < 80; t++){
            var s = Math.floor(t / 20);
            var T = $9b731056ca16dcaa$var$ROTL(a, 5) + $9b731056ca16dcaa$var$f(s, b, c, d) + e + K[s] + W[t] >>> 0;
            e = d;
            d = c;
            c = $9b731056ca16dcaa$var$ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
module.exports = $9b731056ca16dcaa$var$sha1;

});




parcelRegister("CnEPi", function(module, exports) {
$parcel$export(module.exports, "JQLEditorPortalRenderer", () => $261aac0182f52772$export$9a99f07338c3a4b1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $372T9 = parcelRequire("372T9");
const $261aac0182f52772$var$initialState = {
    components: {},
    containers: {}
};
const $261aac0182f52772$var$reducer = (state, action)=>{
    switch(action.type){
        case 'createPortal':
            {
                const { key: key, portalComponent: portalComponent, container: container } = action.payload;
                return {
                    ...state,
                    components: {
                        ...state.components,
                        [key]: {
                            portalComponent: portalComponent,
                            container: container
                        }
                    }
                };
            }
        case 'destroyPortal':
            {
                const { [action.payload]: toDestroy, ...components } = state.components;
                return {
                    ...state,
                    components: components
                };
            }
        case 'registerPluginContainer':
            {
                const { element: element, containerKey: containerKey } = action.payload;
                if (!element) return state;
                return {
                    ...state,
                    containers: {
                        ...state.containers,
                        [containerKey]: element
                    }
                };
            }
        default:
            return state;
    }
};
const $261aac0182f52772$export$9a99f07338c3a4b1 = ({ children: children })=>{
    const [state, dispatch] = (0, $eJOHy.useReducer)($261aac0182f52772$var$reducer, $261aac0182f52772$var$initialState);
    const actionsContext = (0, $eJOHy.useMemo)(()=>{
        return {
            onCreatePortal: (key, portalComponent, container)=>dispatch({
                    type: 'createPortal',
                    payload: {
                        key: key,
                        portalComponent: portalComponent,
                        container: container
                    }
                }),
            onDestroyPortal: (key)=>dispatch({
                    type: 'destroyPortal',
                    payload: key
                }),
            onRegisterPluginContainer: (containerKey, element)=>dispatch({
                    type: 'registerPluginContainer',
                    payload: {
                        containerKey: containerKey,
                        element: element
                    }
                })
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $372T9.PortalActionsContext).Provider, {
        value: actionsContext,
        children: [
            children,
            Object.entries(state.components).map(([key, value])=>{
                const container = value.container instanceof Element ? value.container : state.containers[value.container];
                return container !== undefined ? /*#__PURE__*/ (0, $aQK2r.createPortal)(value.portalComponent, container, key) : null;
            })
        ]
    });
};

});
parcelRegister("372T9", function(module, exports) {
$parcel$export(module.exports, "PortalActionsContext", () => $4a421dfe706b92bb$export$e28929084085920e);
$parcel$export(module.exports, "usePortalActionsContext", () => $4a421dfe706b92bb$export$d82a073882ef87b1);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $4a421dfe706b92bb$export$e28929084085920e = (0, $eJOHy.createContext)({
    onCreatePortal: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDestroyPortal: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onRegisterPluginContainer: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $4a421dfe706b92bb$export$d82a073882ef87b1 = ()=>(0, $eJOHy.useContext)($4a421dfe706b92bb$export$e28929084085920e);

});


parcelRegister("aMgHa", function(module, exports) {
$parcel$export(module.exports, "default", () => $9107e524abef3536$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");


var $lkATK = parcelRequire("lkATK");

var $gsQ8m = parcelRequire("gsQ8m");

var $9IGks = parcelRequire("9IGks");

var $hdDXV = parcelRequire("hdDXV");

var $83AC1 = parcelRequire("83AC1");

var $k8Hie = parcelRequire("k8Hie");

var $372T9 = parcelRequire("372T9");

var $6uAuO = parcelRequire("6uAuO");
/**
 * This wraps ProseMirror's EditorView as a React component.
 */ const $9107e524abef3536$var$JQLEditorView = ({ inputRef: inputRef })=>{
    const [editorView, { initialiseEditorView: initialiseEditorView, updateEditorView: updateEditorView }] = (0, $9IGks.useEditorView)();
    const editorViewNodeRef = (0, $eJOHy.useRef)(null);
    const [mainId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$ecb000296b5c29b4));
    const [autocompleteId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$be6de605c287d65));
    const [editorId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$3f56b97ad9192f69));
    const [helpContentId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$e46ae403d4c79c56));
    const [validationId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$2d81723ade6fdc3a));
    const [intl] = (0, $9IGks.useIntl)();
    const portalActions = (0, $372T9.usePortalActionsContext)();
    const [, { setEditorViewContainer: setEditorViewContainer, setEditorViewContainerScroll: setEditorViewContainerScroll }] = (0, $9IGks.useStoreActions)();
    const [editorViewHasFocus, { onEditorViewBlur: onEditorViewBlur, onEditorViewFocus: onEditorViewFocus }] = (0, $9IGks.useEditorViewHasFocus)();
    const [lineNumbersVisible] = (0, $9IGks.useLineNumbersVisible)();
    const [{ selectedOptionId: selectedOptionId }] = (0, $9IGks.useAutocomplete)();
    const [isAutocompleteOpen] = (0, $9IGks.useAutocompleteIsOpen)();
    const editorViewIsInvalid = (0, $gsQ8m.useEditorViewIsInvalid)();
    const { expanded: expanded } = (0, $lkATK.useEditorThemeContext)();
    const previousExpanded = (0, $eJOHy.useRef)(expanded);
    const onEditorViewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        if (!expanded && editorViewNodeRef.current) // Clear any fixed heights when the editor is collapsed
        editorViewNodeRef.current.style.height = '';
    }, [
        expanded,
        editorViewNodeRef
    ]);
    const onMainRef = (0, $eJOHy.useCallback)((element)=>portalActions.onRegisterPluginContainer('main', element), [
        portalActions
    ]);
    const onEditorViewContainerRef = (0, $eJOHy.useCallback)((editorViewContainer)=>{
        if (editorViewContainer) setEditorViewContainer(editorViewContainer);
    }, [
        setEditorViewContainer
    ]);
    const throttledSetEditorViewContainerScroll = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((scrollTop)=>{
            setEditorViewContainerScroll(scrollTop);
        }, 1000 / 60), [
        setEditorViewContainerScroll
    ]);
    const onEditorViewContainerScroll = (0, $eJOHy.useCallback)((event)=>{
        const { scrollTop: scrollTop } = event.currentTarget;
        throttledSetEditorViewContainerScroll(scrollTop);
    }, [
        throttledSetEditorViewContainerScroll
    ]);
    // Compute HTML attributes to be applied to the Prosemirror editor view
    const getAttributes = (0, $eJOHy.useCallback)(()=>{
        return {
            id: editorId,
            'data-testid': 'jql-editor-input',
            // Disable grammarly
            'data-gramm': 'false',
            // Combobox might not be a semantically correct role for the editor,
            // however some browsers like Safari will only announce suggestions when this role is present
            role: 'combobox',
            'aria-expanded': `${isAutocompleteOpen}`,
            'aria-autocomplete': 'list',
            'aria-label': intl.formatMessage((0, $6uAuO.messages).inputLabel),
            'aria-controls': autocompleteId,
            'aria-owns': autocompleteId,
            'aria-describedby': editorViewIsInvalid ? validationId : helpContentId,
            ...selectedOptionId && {
                'aria-activedescendant': selectedOptionId
            },
            ...editorViewIsInvalid && {
                'aria-invalid': 'true'
            }
        };
    }, [
        editorId,
        isAutocompleteOpen,
        intl,
        autocompleteId,
        editorViewIsInvalid,
        validationId,
        helpContentId,
        selectedOptionId
    ]);
    // Update attributes on our editor view whenever they have changed
    (0, $eJOHy.useEffect)(()=>{
        updateEditorView(getAttributes());
    }, [
        getAttributes,
        updateEditorView
    ]);
    const onEditorViewRef = (0, $eJOHy.useCallback)((editorViewNode)=>{
        if (editorViewNode && !editorView) {
            initialiseEditorView(editorViewNode, getAttributes(), portalActions);
            editorViewNodeRef.current = editorViewNode;
        }
    }, [
        editorView,
        initialiseEditorView,
        getAttributes,
        portalActions
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (editorViewNodeRef.current && expanded !== previousExpanded.current) {
            if (expanded) {
                // Set fixed height based on the current element height so we can transition to the expanded height
                editorViewNodeRef.current.style.height = editorViewNodeRef.current.clientHeight + 'px';
                requestAnimationFrame(()=>{
                    if (editorViewNodeRef.current) {
                        editorViewNodeRef.current.style.height = '';
                        editorViewNodeRef.current.setAttribute('data-expanded', 'true');
                    }
                });
            } else if (editorView) requestAnimationFrame(()=>{
                if (editorViewNodeRef.current && editorView) {
                    // Transition to the default height based on the content of the editor
                    editorViewNodeRef.current.style.height = editorView.dom.clientHeight + 'px';
                    editorViewNodeRef.current.removeAttribute('data-expanded');
                }
            });
        }
        previousExpanded.current = expanded;
    }, [
        expanded,
        previousExpanded,
        editorViewNodeRef,
        editorView
    ]);
    (0, $eJOHy.useImperativeHandle)(inputRef, ()=>({
            focus: ()=>{
                if (editorView) editorView.focus();
            }
        }));
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (editorView) editorView.destroy();
        };
    }, [
        editorView
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8Hie.default), {
        EditorControlsContent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hdDXV.JQLEditorControlsContent), {}),
        EditorFooterContent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $83AC1.JQLEditorFooterContent), {}),
        editorViewHasFocus: editorViewHasFocus,
        lineNumbersVisible: lineNumbersVisible,
        editorViewIsInvalid: editorViewIsInvalid,
        mainId: mainId,
        onEditorMainRef: onMainRef,
        onEditorViewContainerRef: onEditorViewContainerRef,
        onEditorViewContainerScroll: onEditorViewContainerScroll,
        onEditorViewRef: onEditorViewRef,
        onEditorViewBlur: onEditorViewBlur,
        onEditorViewFocus: onEditorViewFocus,
        onEditorViewTransitionEnd: onEditorViewTransitionEnd
    });
};
var $9107e524abef3536$export$2e2bcd8739ae039 = $9107e524abef3536$var$JQLEditorView;

});
parcelRegister("gsQ8m", function(module, exports) {
$parcel$export(module.exports, "useEditorViewIsInvalid", () => $019cf422261d3a09$export$7c2251dc2d69a36d);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $9IGks = parcelRequire("9IGks");
const $019cf422261d3a09$export$7c2251dc2d69a36d = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useJqlError), (0, $9IGks.useExternalMessages), (0, $9IGks.useEditorStateHasJqlError));
    const [jqlError] = (0, $9IGks.useJqlError)();
    const [{ errors: externalErrors }] = (0, $9IGks.useExternalMessages)();
    const [editorStateHasJqlError] = (0, $9IGks.useEditorStateHasJqlError)();
    // Determines if the last searched query contained an error that has not been fixed in the editor
    const [hasActiveError, setHasActiveError] = (0, $eJOHy.useState)(false);
    const hasActiveExternalError = jqlError === null && externalErrors.length > 0;
    // Update hasActiveError whenever a query has been searched and the resulting jqlError has changed
    (0, $eJOHy.useEffect)(()=>{
        setHasActiveError(jqlError !== null);
    }, [
        jqlError
    ]);
    // Set hasActiveError to false whenever the editor JQL is valid
    (0, $eJOHy.useEffect)(()=>{
        if (!editorStateHasJqlError) setHasActiveError(false);
    }, [
        editorStateHasJqlError
    ]);
    return hasActiveError || hasActiveExternalError;
};

});

parcelRegister("hdDXV", function(module, exports) {
$parcel$export(module.exports, "JQLEditorControlsContent", () => $18c35c39f8fb240d$export$76b64d5c80db3536);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lkATK = parcelRequire("lkATK");

var $llk5m = parcelRequire("llk5m");

var $lgVT6 = parcelRequire("lgVT6");

var $kyREh = parcelRequire("kyREh");
const $18c35c39f8fb240d$export$76b64d5c80db3536 = ()=>{
    const { isSearch: isSearch } = (0, $lkATK.useEditorThemeContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $llk5m.ExpandToggle), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyREh.SyntaxHelp), {}),
            isSearch && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgVT6.Search), {})
        ]
    });
};

});
parcelRegister("llk5m", function(module, exports) {
$parcel$export(module.exports, "ExpandToggle", () => $7d7c8f8284b7bbf7$export$8bfb96a4815f5fe7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $4cOHu = parcelRequire("4cOHu");
var $6S5SS = parcelRequire("6S5SS");


var $lM09c = parcelRequire("lM09c");

var $lkATK = parcelRequire("lkATK");

var $9IGks = parcelRequire("9IGks");

var $02DyK = parcelRequire("02DyK");

var $liMX9 = parcelRequire("liMX9");

var $hZ0XI = parcelRequire("hZ0XI");
const $7d7c8f8284b7bbf7$export$8bfb96a4815f5fe7 = ()=>{
    const { expanded: expanded, toggleExpanded: toggleExpanded } = (0, $lkATK.useEditorThemeContext)();
    const [, { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent }] = (0, $9IGks.useStoreActions)();
    const [editorId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$3f56b97ad9192f69));
    const [intl] = (0, $9IGks.useIntl)();
    let message;
    if (expanded) message = intl.formatMessage((0, $hZ0XI.messages).collapseTooltip);
    else message = intl.formatMessage((0, $hZ0XI.messages).expandTooltip);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        createAndFireAnalyticsEvent({
            action: (0, $4cOHu.Action).CLICKED,
            actionSubject: (0, $4cOHu.ActionSubject).BUTTON,
            actionSubjectId: (0, $4cOHu.ActionSubjectId).EDITOR_EXPAND,
            eventType: (0, $6S5SS.EventType).UI,
            attributes: {
                expanded: !expanded
            }
        });
        toggleExpanded();
    }, [
        expanded,
        createAndFireAnalyticsEvent,
        toggleExpanded
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        position: 'bottom',
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lM09c.TooltipContent), {
            children: message
        }),
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $02DyK.TooltipTag),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liMX9.BaseExpandToggle), {
            expanded: expanded,
            editorId: editorId,
            label: intl.formatMessage((0, $hZ0XI.messages).buttonLabel),
            onClick: onClick
        })
    });
};

});
parcelRegister("02DyK", function(module, exports) {
$parcel$export(module.exports, "TooltipTag", () => $e118dba3efcab979$export$48d215ae75c54231);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7DUuE = parcelRequire("7DUuE");
const $e118dba3efcab979$export$48d215ae75c54231 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7DUuE.StyledTooltipTag), {
        ref: ref,
        ...props
    }));

});
parcelRegister("7DUuE", function(module, exports) {
$parcel$export(module.exports, "StyledTooltipTag", () => $66a7a022e79ac572$export$710d2963cb2c383e);

var $aWILV = parcelRequire("aWILV");
function $66a7a022e79ac572$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $66a7a022e79ac572$export$710d2963cb2c383e = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1ekq3hq0"
})({
    name: "zjik7",
    styles: "display:flex"
});

});


parcelRegister("hZ0XI", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3e6d0fbe6ba1c63a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3e6d0fbe6ba1c63a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    buttonLabel: {
        id: 'jql-editor.ui.jql-editor-controls-content.expand-toggle.button-label',
        defaultMessage: 'Editor',
        description: 'Label that tells the user the expand toggle is controlling the JQL editor.'
    },
    expandTooltip: {
        id: 'jql-editor.ui.jql-editor-controls-content.expand-toggle.expand-tooltip',
        defaultMessage: 'Expand editor',
        description: 'Tooltip to show for the expand icon which increases the height of the editor'
    },
    collapseTooltip: {
        id: 'jql-editor.ui.jql-editor-controls-content.expand-toggle.collapse-tooltip',
        defaultMessage: 'Collapse editor',
        description: 'Tooltip to show for the collapse icon which shrinks the height of the editor'
    }
});

});


parcelRegister("lgVT6", function(module, exports) {
$parcel$export(module.exports, "Search", () => $9b101dd19b821725$export$4b85d3515bd863a5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lM09c = parcelRequire("lM09c");

var $9IGks = parcelRequire("9IGks");

var $02DyK = parcelRequire("02DyK");

var $8VTHV = parcelRequire("8VTHV");

var $kESJH = parcelRequire("kESJH");
const $9b101dd19b821725$export$4b85d3515bd863a5 = ()=>{
    const [intl] = (0, $9IGks.useIntl)();
    const [, { onSearch: onSearch }] = (0, $9IGks.useStoreActions)();
    const label = intl.formatMessage((0, $kESJH.messages).searchLabel);
    const [isSearching] = (0, $9IGks.useIsSearching)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        position: 'bottom',
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lM09c.TooltipContent), {
            children: label
        }),
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $02DyK.TooltipTag),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8VTHV.BaseSearch), {
            label: label,
            onSearch: onSearch,
            isSearching: isSearching
        })
    });
};

});
parcelRegister("kESJH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3a15bfca6f3b8e57$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3a15bfca6f3b8e57$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    searchLabel: {
        id: 'jql-editor.ui.jql-editor-controls-content.search.label',
        defaultMessage: 'Search',
        description: 'Label to show for the search icon which the user can press to perform a search.'
    }
});

});


parcelRegister("kyREh", function(module, exports) {
$parcel$export(module.exports, "SyntaxHelp", () => $00cf217482b53cff$export$c9a08dd872d390dc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $hpDm2 = parcelRequire("hpDm2");

var $4cOHu = parcelRequire("4cOHu");
var $6S5SS = parcelRequire("6S5SS");


var $lM09c = parcelRequire("lM09c");

var $9IGks = parcelRequire("9IGks");

var $02DyK = parcelRequire("02DyK");

var $cqdbH = parcelRequire("cqdbH");

var $8U9qX = parcelRequire("8U9qX");
const $00cf217482b53cff$export$c9a08dd872d390dc = ()=>{
    const [intl] = (0, $9IGks.useIntl)();
    const label = intl.formatMessage((0, $8U9qX.messages).syntaxHelpTooltip);
    const [descriptionId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$84b7d548dbd97842));
    const [onSyntaxHelp, { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent }] = (0, $9IGks.useOnSyntaxHelp)();
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        createAndFireAnalyticsEvent({
            action: (0, $4cOHu.Action).CLICKED,
            actionSubject: (0, $4cOHu.ActionSubject).BUTTON,
            actionSubjectId: (0, $4cOHu.ActionSubjectId).EDITOR_HELP,
            eventType: (0, $6S5SS.EventType).UI
        });
        const handled = onSyntaxHelp && onSyntaxHelp(e);
        // Prevent default behaviour when the event is handled on the consumer side.
        if (handled) e.preventDefault();
    }, [
        createAndFireAnalyticsEvent,
        onSyntaxHelp
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k71qx.default), {
        position: 'bottom',
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lM09c.TooltipContent), {
            children: label
        }),
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $02DyK.TooltipTag),
        isScreenReaderAnnouncementDisabled: true,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cqdbH.BaseSyntaxHelp), {
                describedby: descriptionId,
                label: label,
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpDm2.ScreenReaderText), {
                id: descriptionId,
                children: intl.formatMessage((0, $8U9qX.messages).syntaxHelpDescription)
            })
        ]
    });
};

});
parcelRegister("8U9qX", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a6489791abc0af3d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a6489791abc0af3d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    syntaxHelpDescription: {
        id: 'jql-editor.ui.jql-editor-footer-content.jql-editor-help.syntax-help.description',
        defaultMessage: 'Open JQL syntax help in a new tab.',
        description: 'Description read when the syntax help link is focused.'
    },
    syntaxHelpTooltip: {
        id: 'jql-editor.ui.jql-editor-footer-content.jql-editor-help.syntax-help.tooltip',
        defaultMessage: 'Syntax help',
        description: 'Tooltip to show when the syntax help link is focused.'
    }
});

});



parcelRegister("83AC1", function(module, exports) {
$parcel$export(module.exports, "JQLEditorFooterContent", () => $871dc7d127489081$export$3108f46d0fa42b03);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $blucA = parcelRequire("blucA");

var $hoAue = parcelRequire("hoAue");

var $gsQ8m = parcelRequire("gsQ8m");

var $73m3r = parcelRequire("73m3r");

var $1XUzr = parcelRequire("1XUzr");
var $8iw5s = parcelRequire("8iw5s");
var $jdVMa = parcelRequire("jdVMa");
const $871dc7d127489081$export$3108f46d0fa42b03 = ()=>{
    (0, $gRw8I.di)((0, $gsQ8m.useEditorViewIsInvalid), (0, $hoAue.useEditorViewHasWarnings), (0, $blucA.useEditorViewHasInfos), (0, $1XUzr.ErrorMessages), (0, $jdVMa.WarningMessages), (0, $8iw5s.InfoMessages), (0, $73m3r.JQLEditorHelp));
    const editorViewIsInvalid = (0, $gsQ8m.useEditorViewIsInvalid)();
    const editorViewHasWarnings = (0, $hoAue.useEditorViewHasWarnings)();
    const editorViewHasInfos = (0, $blucA.useEditorViewHasInfos)();
    if (editorViewIsInvalid) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1XUzr.ErrorMessages), {});
    if (editorViewHasWarnings) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdVMa.WarningMessages), {});
    if (editorViewHasInfos) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8iw5s.InfoMessages), {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $73m3r.JQLEditorHelp), {});
};

});
parcelRegister("blucA", function(module, exports) {
$parcel$export(module.exports, "useEditorViewHasInfos", () => $ddacfd247b74be1d$export$3659c5c770b887aa);

var $gRw8I = parcelRequire("gRw8I");

var $9IGks = parcelRequire("9IGks");
const $ddacfd247b74be1d$export$3659c5c770b887aa = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useExternalMessages));
    const [{ infos: externalInfos }] = (0, $9IGks.useExternalMessages)();
    return externalInfos.length > 0;
};

});

parcelRegister("hoAue", function(module, exports) {
$parcel$export(module.exports, "useEditorViewHasWarnings", () => $4af3a06329ab0af4$export$163c1884c72cbba4);

var $gRw8I = parcelRequire("gRw8I");

var $9IGks = parcelRequire("9IGks");
const $4af3a06329ab0af4$export$163c1884c72cbba4 = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useHydratedDeprecations), (0, $9IGks.useExternalMessages));
    const [hydratedDeprecations] = (0, $9IGks.useHydratedDeprecations)();
    const [{ warnings: externalWarnings }] = (0, $9IGks.useExternalMessages)();
    return hydratedDeprecations.length > 0 || externalWarnings.length > 0;
};

});

parcelRegister("73m3r", function(module, exports) {
$parcel$export(module.exports, "JQLEditorHelp", () => $60eebcd2fbdafe95$export$2e1498edf5d5069e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");

var $3cMgR = parcelRequire("3cMgR");


var $lkATK = parcelRequire("lkATK");

var $9IGks = parcelRequire("9IGks");

var $aUNlY = parcelRequire("aUNlY");

var $8RClV = parcelRequire("8RClV");
const $60eebcd2fbdafe95$export$2e1498edf5d5069e = ()=>{
    const [{ formatMessage: formatMessage }] = (0, $9IGks.useIntl)();
    const [editorViewHasFocus] = (0, $9IGks.useEditorViewHasFocus)();
    const { isSearch: isSearch } = (0, $lkATK.useEditorThemeContext)();
    const [helpContentId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$e46ae403d4c79c56));
    const SearchMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
        size: "UNSAFE_small",
        color: "inherit",
        children: formatMessage((0, $aUNlY.messages).searchCommand, {
            b: (text)=>/*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                    children: text
                })
        })
    });
    const NewLineMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
        size: "UNSAFE_small",
        color: "inherit",
        children: formatMessage(isSearch ? (0, $aUNlY.messages).newLineCommand : (0, $aUNlY.messages).fieldNewLineCommand, {
            b: (text)=>/*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                    children: text
                })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8RClV.HelpContainer), {
        id: helpContentId,
        isVisible: editorViewHasFocus,
        children: [
            isSearch && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
                children: SearchMessage
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
                children: NewLineMessage
            })
        ]
    });
};

});
parcelRegister("aUNlY", function(module, exports) {
$parcel$export(module.exports, "messages", () => $98a1ab94facaea3a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $98a1ab94facaea3a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    searchCommand: {
        id: 'jql-editor.ui.jql-editor-help.search-command',
        defaultMessage: '<b>Enter</b> to search',
        description: `Message to inform users to press the 'Enter' key on the keyboard to search a query.`
    },
    newLineCommand: {
        id: 'jql-editor.ui.jql-editor-help.new-line-command',
        defaultMessage: '<b>Shift+Enter</b> to add a new line',
        description: `In search mode, message to inform users to press the 'Shift' and 'Enter' keys on the keyboard to add a new line into the query.`
    },
    fieldNewLineCommand: {
        id: 'jql-editor.ui.jql-editor-help.field-new-line-command',
        defaultMessage: '<b>Enter</b> to add a new line',
        description: `In field mode, message to inform users to press the 'Enter' key on the keyboard to add a new line into the query.`
    }
});

});

parcelRegister("8RClV", function(module, exports) {
$parcel$export(module.exports, "HelpContainer", () => $6a50953e2eaf8d77$export$fe2452067532ffc4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $lM09c = parcelRequire("lM09c");

var $aWILV = parcelRequire("aWILV");
function $6a50953e2eaf8d77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $6a50953e2eaf8d77$var$_ref = {
    name: "1flj89a",
    styles: "visibility:visible;opacity:1;transition:opacity 250ms cubic-bezier(0.15, 1, 0.3, 1)"
};
const $6a50953e2eaf8d77$export$fe2452067532ffc4 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "em0q3kx0"
})({
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 0,
    flexShrink: 0,
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> * + *': {
        marginLeft: "var(--ds-space-200, 16px)"
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isVisible ? $6a50953e2eaf8d77$var$_ref : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)((0, $lM09c.hiddenMixin), "opacity:0;"));

});


parcelRegister("1XUzr", function(module, exports) {
$parcel$export(module.exports, "ErrorMessages", () => $4779d2f1996fa231$export$6586c12bbf6d0c20);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");

var $cic90 = parcelRequire("cic90");


var $1R5KR = parcelRequire("1R5KR");

var $lkATK = parcelRequire("lkATK");

var $gsQ8m = parcelRequire("gsQ8m");

var $9IGks = parcelRequire("9IGks");

var $e43Yp = parcelRequire("e43Yp");

var $ciPkF = parcelRequire("ciPkF");
/**
 * This function maps client side validation errors and external messages into a unified format
 * This is so that the output of this function can then be processed in a unified manner by different renderers
 */ const $4779d2f1996fa231$var$useErrorMessages = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useIntl), (0, $9IGks.useJqlError), (0, $9IGks.useStoreActions), (0, $9IGks.useExternalMessages), (0, $gsQ8m.useEditorViewIsInvalid));
    const [{ formatMessage: formatMessage }] = (0, $9IGks.useIntl)();
    const [jqlError] = (0, $9IGks.useJqlError)();
    const [{ errors: externalErrors }] = (0, $9IGks.useExternalMessages)();
    const [, { externalErrorMessageViewed: externalErrorMessageViewed }] = (0, $9IGks.useStoreActions)();
    const editorViewIsInvalid = (0, $gsQ8m.useEditorViewIsInvalid)();
    (0, $eJOHy.useEffect)(()=>{
        // Emit a UI event whenever external errors has changed
        externalErrorMessageViewed();
    }, [
        externalErrorMessageViewed,
        externalErrors
    ]);
    if (!editorViewIsInvalid) return null;
    /**
	 * Transform a string message to take the form of an ExternalMessage,
	 * so that we can reduce a bunch of conditionals when processing the output of useErrorMessages
	 */ const toExternalMessageShape = (message)=>[
            {
                type: 'error',
                message: message
            }
        ];
    // Prioritise client errors over external errors
    if (jqlError instanceof (0, $cic90.JQLSyntaxError)) return toExternalMessageShape(`${jqlError.message} ${formatMessage((0, $ciPkF.messages).jqlErrorPosition, {
        lineNumber: jqlError.line,
        charPosition: jqlError.charPositionInLine + 1
    })}`);
    if (externalErrors.length > 0) return externalErrors;
    if (jqlError !== null) return toExternalMessageShape(formatMessage((0, $1R5KR.commonMessages).unknownError));
    return null;
};
/**
 * This is a decorator component to include the editorTheme prop to the already passed list of props
 */ const $4779d2f1996fa231$var$CustomComponentDecoratedWithEditorTheme = (props)=>{
    (0, $gRw8I.di)((0, $lkATK.useEditorThemeContext));
    const { Component: Component, ...rest } = props;
    const editorThemeContext = (0, $lkATK.useEditorThemeContext)();
    // This is a slightly redundant condition.
    // Technically, CustomErrorMessage component should never be called with an undefined Component
    // This is enforced by the static types. Adding this condition as an extra layer of protection
    if (!Component) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: "props.children"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        editorTheme: editorThemeContext,
        ...rest
    });
};
const $4779d2f1996fa231$export$6586c12bbf6d0c20 = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useScopedId), $4779d2f1996fa231$var$useErrorMessages, (0, $9IGks.useCustomErrorComponent));
    const [editorId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$3f56b97ad9192f69));
    const [validationId] = (0, $9IGks.useScopedId)((0, $480e76317c70d1e5$export$2d81723ade6fdc3a));
    const errorMessages = $4779d2f1996fa231$var$useErrorMessages();
    const [CustomErrorComponent] = (0, $9IGks.useCustomErrorComponent)();
    const childrenToRender = errorMessages != null ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.MessageContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
            testId: (0, $480e76317c70d1e5$export$2d81723ade6fdc3a),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                role: "alert",
                id: validationId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.FormatMessages), {
                    messages: errorMessages
                })
            })
        })
    }) : null;
    // Only render CustomErrorComponent if there is an errorMessage
    if (errorMessages != null && CustomErrorComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)($4779d2f1996fa231$var$CustomComponentDecoratedWithEditorTheme, {
        testId: (0, $480e76317c70d1e5$export$2d81723ade6fdc3a),
        editorId: editorId,
        validationId: validationId,
        Component: CustomErrorComponent,
        errorMessages: (0, $e43Yp.extractMessageNodes)(errorMessages),
        children: childrenToRender
    });
    return childrenToRender;
};

});
parcelRegister("e43Yp", function(module, exports) {
$parcel$export(module.exports, "MessageContainer", () => $9f8e57d6a0c51904$export$616d763e306cba45);
$parcel$export(module.exports, "FormatMessages", () => $9f8e57d6a0c51904$export$45479db45569b3f);
$parcel$export(module.exports, "extractMessageNodes", () => $9f8e57d6a0c51904$export$d5e18dd21faae55d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lkATK = parcelRequire("lkATK");

var $4BKcN = parcelRequire("4BKcN");
// Max number messages we want to show
const $9f8e57d6a0c51904$var$MAX_MESSAGES = 10;
const $9f8e57d6a0c51904$export$616d763e306cba45 = ({ children: children })=>{
    const { isSearch: isSearch } = (0, $lkATK.useEditorThemeContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BKcN.MessageContainer), {
        isSearch: isSearch,
        children: children
    });
};
const $9f8e57d6a0c51904$export$45479db45569b3f = ({ messages: messages })=>{
    const messageNodes = $9f8e57d6a0c51904$export$d5e18dd21faae55d(messages);
    if (messageNodes.length === 0) return null;
    if (messageNodes.length === 1) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        children: messageNodes[0]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BKcN.MessageList), {
        children: messageNodes.map((m, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                children: m
            }, i))
    });
};
const $9f8e57d6a0c51904$export$d5e18dd21faae55d = (messages)=>{
    return messages.slice(0, $9f8e57d6a0c51904$var$MAX_MESSAGES).map((m)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: m.message
        }));
};

});
parcelRegister("4BKcN", function(module, exports) {
$parcel$export(module.exports, "MessageContainer", () => $d54d4d268cba5b2f$export$616d763e306cba45);
$parcel$export(module.exports, "MessageList", () => $d54d4d268cba5b2f$export$89085c7857c3f940);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $d54d4d268cba5b2f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d54d4d268cba5b2f$export$616d763e306cba45 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e34tulu1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingLeft: props.isSearch ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"
    }));
const $d54d4d268cba5b2f$export$89085c7857c3f940 = /*#__PURE__*/ (0, $aWILV.default)("ul", {
    target: "e34tulu0"
})({
    name: "p3e5m3",
    styles: "margin:0;padding-left:var(--ds-space-300, 24px)"
});

});


parcelRegister("ciPkF", function(module, exports) {
$parcel$export(module.exports, "messages", () => $653ecf7ed09c960f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $653ecf7ed09c960f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    jqlErrorPosition: {
        id: 'jql-editor.ui.jql-validation-message.jql-error-position',
        defaultMessage: '(line {lineNumber}, character {charPosition})',
        description: 'Show the line and character position that an error occurs in the JQL string, e.g. (line 1, character 23)'
    }
});

});


parcelRegister("8iw5s", function(module, exports) {
$parcel$export(module.exports, "InfoMessages", () => $bb053119d1a24d97$export$dd957e47a466d758);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");

var $2R0ne = parcelRequire("2R0ne");

var $cDDv2 = parcelRequire("cDDv2");

var $8IeH1 = parcelRequire("8IeH1");


var $blucA = parcelRequire("blucA");

var $9IGks = parcelRequire("9IGks");

var $e43Yp = parcelRequire("e43Yp");
const $bb053119d1a24d97$export$331fea808273a09e = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useExternalMessages), (0, $blucA.useEditorViewHasInfos));
    const [{ infos: externalInfos }] = (0, $9IGks.useExternalMessages)();
    const hasInfos = (0, $blucA.useEditorViewHasInfos)();
    if (!hasInfos) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.FormatMessages), {
        messages: externalInfos
    });
};
const $bb053119d1a24d97$export$dd957e47a466d758 = ()=>{
    (0, $gRw8I.di)($bb053119d1a24d97$export$331fea808273a09e);
    const infoMessage = $bb053119d1a24d97$export$331fea808273a09e();
    return infoMessage != null ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.MessageContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fKXve.HelperMessage), {
            testId: "jql-editor-info-message",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    paddingInlineEnd: "space.050",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                        label: "",
                        color: `var(--ds-icon-information, ${$7bb4c1736002a04a$export$a6ee3d71bc067634})`,
                        LEGACY_size: "small",
                        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cDDv2))),
                        LEGACY_margin: "0 -4px 0 0",
                        size: "small"
                    })
                }),
                infoMessage
            ]
        })
    }) : null;
};

});

parcelRegister("jdVMa", function(module, exports) {
$parcel$export(module.exports, "WarningMessages", () => $24873a5919ae1f4e$export$877c48800daec5f4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");

var $d8UFE = parcelRequire("d8UFE");

var $60rxg = parcelRequire("60rxg");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");


var $hoAue = parcelRequire("hoAue");

var $9IGks = parcelRequire("9IGks");

var $e43Yp = parcelRequire("e43Yp");

var $hz67S = parcelRequire("hz67S");
const $24873a5919ae1f4e$var$softDeprecateEpicParentDocsLink = 'https://support.atlassian.com/jira-software-cloud/docs/upcoming-changes-epic-link-replaced-with-parent/';
const $24873a5919ae1f4e$var$getEpicLinkDeprecationTerm = (hydratedDeprecations)=>{
    const epicLinkWarning = hydratedDeprecations.filter((warning)=>warning.deprecatedSearcherKey === 'com.pyxis.greenhopper.jira:gh-epic-link-searcher');
    return epicLinkWarning.length > 0 ? epicLinkWarning[0].id : null;
};
const $24873a5919ae1f4e$var$getParentLinkDeprecationTerm = (hydratedDeprecations)=>{
    const parentLinkWarning = hydratedDeprecations.filter((warning)=>warning.deprecatedSearcherKey === 'com.atlassian.jpo:jpo-custom-field-parent-searcher');
    return parentLinkWarning.length > 0 ? parentLinkWarning[0].id : null;
};
const $24873a5919ae1f4e$export$baefd725b6d5c14 = ()=>{
    (0, $gRw8I.di)((0, $9IGks.useHydratedDeprecations), (0, $9IGks.useExternalMessages), (0, $hoAue.useEditorViewHasWarnings), (0, $9IGks.useIntl));
    const [hydratedDeprecations] = (0, $9IGks.useHydratedDeprecations)();
    const [{ warnings: externalWarnings }] = (0, $9IGks.useExternalMessages)();
    const hasWarnings = (0, $hoAue.useEditorViewHasWarnings)();
    const [{ formatMessage: formatMessage }] = (0, $9IGks.useIntl)();
    const epicLinkDeprecationTerm = $24873a5919ae1f4e$var$getEpicLinkDeprecationTerm(hydratedDeprecations);
    const parentLinkDeprecationTerm = $24873a5919ae1f4e$var$getParentLinkDeprecationTerm(hydratedDeprecations);
    const formatWarnings = (0, $eJOHy.useCallback)((message)=>{
        const combinedMessages = [
            {
                type: 'warning',
                message: message
            },
            ...externalWarnings
        ];
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.FormatMessages), {
            messages: combinedMessages
        });
    }, [
        externalWarnings
    ]);
    if (!hasWarnings) return null;
    else if (!hydratedDeprecations.length && externalWarnings.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.FormatMessages), {
        messages: externalWarnings
    });
    else if (epicLinkDeprecationTerm == null && parentLinkDeprecationTerm == null) return formatWarnings(formatMessage((0, $hz67S.messages).defaultWarning, {
        deprecatedField: hydratedDeprecations[0]?.id
    }));
    else if (epicLinkDeprecationTerm && parentLinkDeprecationTerm) return formatWarnings(formatMessage((0, $hz67S.messages).deprecatedBothParentReplacementMessage, {
        link: (chunks)=>(0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__jira-platform-') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                href: $24873a5919ae1f4e$var$softDeprecateEpicParentDocsLink,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (e)=>e.stopPropagation(),
                children: chunks
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                href: $24873a5919ae1f4e$var$softDeprecateEpicParentDocsLink,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (e)=>e.stopPropagation(),
                children: chunks
            }),
        receivedFirst: epicLinkDeprecationTerm,
        receivedSecond: parentLinkDeprecationTerm,
        parentReplacement: 'Parent'
    }));
    else if (epicLinkDeprecationTerm || parentLinkDeprecationTerm) return formatWarnings(formatMessage((0, $hz67S.messages).deprecatedParentReplacementMessage, {
        link: (chunks)=>(0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__jira-platform-') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                href: $24873a5919ae1f4e$var$softDeprecateEpicParentDocsLink,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (e)=>e.stopPropagation(),
                children: chunks
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                href: $24873a5919ae1f4e$var$softDeprecateEpicParentDocsLink,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (e)=>e.stopPropagation(),
                children: chunks
            }),
        deprecatedField: epicLinkDeprecationTerm ? epicLinkDeprecationTerm : parentLinkDeprecationTerm,
        parentReplacement: 'Parent'
    }));
};
const $24873a5919ae1f4e$export$877c48800daec5f4 = ()=>{
    (0, $gRw8I.di)($24873a5919ae1f4e$export$baefd725b6d5c14);
    const warningMessage = $24873a5919ae1f4e$export$baefd725b6d5c14();
    return warningMessage != null ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e43Yp.MessageContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fKXve.HelperMessage), {
            testId: "jql-editor-warning-message",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    paddingInlineEnd: "space.050",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
                        label: "",
                        color: `var(--ds-icon-warning, ${$7bb4c1736002a04a$export$59619663aa6500fb})`,
                        LEGACY_size: "small",
                        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($60rxg))),
                        LEGACY_margin: "0 -4px 0 0",
                        size: "small"
                    })
                }),
                warningMessage
            ]
        })
    }) : null;
};

});
parcelRegister("hz67S", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a42f8ed40de652e2$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a42f8ed40de652e2$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deprecatedParentReplacementMessage: {
        id: 'jql-editor.ui.jql-warning-message.deprecated-epic-link-or-parent-link-field',
        defaultMessage: '{deprecatedField} will soon be replaced with {parentReplacement}. <link>Update to {parentReplacement}</link> to prepare for these changes.',
        description: 'Warning message for Epic Link and Parent Link deprecation, with link to docs'
    },
    deprecatedBothParentReplacementMessage: {
        id: 'jql-editor.ui.jql-warning-message.deprecated-both-epic-link-parent-link-field',
        defaultMessage: '{receivedFirst} and {receivedSecond} will soon be replaced with {parentReplacement}. <link>Update to {parentReplacement}</link> to prepare for these changes.',
        description: 'Warning message for both Epic Link and Parent Link deprecation, with link to docs'
    },
    defaultWarning: {
        id: 'jql-editor.ui.jql-warning-message.default',
        defaultMessage: '{deprecatedField} has been deprecated and may stop working in the future.',
        description: 'Default warning message to show on NIN'
    }
});

});



parcelRegister("6uAuO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $55107bed7b11f8b4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $55107bed7b11f8b4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    inputLabel: {
        id: 'jql-editor.ui.input-label',
        defaultMessage: 'JQL query',
        description: 'Label for the input where users can type a JQL query. This text is not visible and is only read by screen readers.'
    }
});

});




//# sourceMappingURL=async-jql-editor.8621a15f.js.map
